unit PrjFormPeriodenUnabhaengigeDaten;

interface

uses
  System.SysUtils,
  System.Classes,
  System.StrUtils,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  PrjFormDefault,
  Vcl.Graphics,
  Vcl.StdCtrls,
  Vcl.Controls,
  WEBLib.StdCtrls,
  Vcl.Imaging.GIFImg,
  PrjClassHBMDataAccess,

  WEBLib.ExtCtrls,
  WEBLib.ComCtrls,
  Types,
  Vcl.Grids,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Data.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.DB,
  XData.Web.Connection;

type
  TPrjFormsPeriodenUnabhaengigeDaten = class(TPrjFormsDefault)
    PageControl: TPageControl;
    pgSeite1: TTabSheet;
    pnInstitute: TPanel;
    pgSeite3: TTabSheet;
    pgSeite4: TTabSheet;
    pgSeite5: TTabSheet;
    pgSeite6: TTabSheet;
    pnFallZuordnung: TPanel;
    pnMedVersorgung: TPanel;
    WebLabel15: TLabel;
    WebLabel16: TLabel;
    WebLabel17: TLabel;
    WebLabel18: TLabel;
    WebLabel19: TLabel;
    WebLabel20: TLabel;
    lblfirstChirurgieHeadline: TLabel;
    lblfirstOrthopaedieHeadline: TLabel;
    lblfirstInnereHeadline: TLabel;
    WebLabel24: TLabel;
    WebLabel25: TLabel;
    WebLabel26: TLabel;
    WebLabel27: TLabel;
    WebLabel28: TLabel;
    WebLabel29: TLabel;
    WebLabel30: TLabel;
    WebLabel31: TLabel;
    WebLabel32: TLabel;
    WebLabel33: TLabel;
    WebLabel34: TLabel;
    RFE_MVZ_AnschaffKoA1: TDBEdit;
    RFE_MVZ_InvestiKoA1: TDBEdit;
    RFE_MVZ_InstHaltKoA1: TDBEdit;
    RFE_MVZ_ZusVerwKoA1: TDBEdit;
    RFE_MVZ_ZusLebensmA1: TDBEdit;
    RFE_MVZ_ZusMedTechnA1: TDBEdit;
    RFE_MVZ_AnschaffKoA2: TDBEdit;
    RFE_MVZ_InvestiKoA2: TDBEdit;
    RFE_MVZ_InstHaltKoA2: TDBEdit;
    RFE_MVZ_ZusVerwKoA2: TDBEdit;
    RFE_MVZ_ZusLebensmA2: TDBEdit;
    RFE_MVZ_ZusMedTechnA2: TDBEdit;
    RFE_MVZ_AnschaffKoA3: TDBEdit;
    RFE_MVZ_InvestiKoA3: TDBEdit;
    RFE_MVZ_InstHaltKoA3: TDBEdit;
    RFE_MVZ_ZusVerwKoA3: TDBEdit;
    RFE_MVZ_ZusLebensmA3: TDBEdit;
    RFE_MVZ_ZusMedTechnA3: TDBEdit;
    RFE_MVZ_EignPaAntNormalA1: TDBEdit;
    RFE_MVZ_EignPaZusErlNormA1: TDBEdit;
    RFE_MVZ_EignPaAntWahlA1: TDBEdit;
    RFE_MVZ_EignPaZusErlWahlA1: TDBEdit;
    RFE_MVZ_EignPaVersTageA1: TDBEdit;
    RFE_MVZ_FrmdPaAntNormalA1: TDBEdit;
    RFE_MVZ_EignPaAntNormalA2: TDBEdit;
    RFE_MVZ_EignPaZusErlNormA2: TDBEdit;
    RFE_MVZ_EignPaAntWahlA2: TDBEdit;
    RFE_MVZ_EignPaZusErlWahlA2: TDBEdit;
    RFE_MVZ_EignPaVersTageA2: TDBEdit;
    RFE_MVZ_FrmdPaAntNormalA2: TDBEdit;
    RFE_MVZ_EignPaAntNormalA3: TDBEdit;
    RFE_MVZ_EignPaZusErlNormA3: TDBEdit;
    RFE_MVZ_EignPaAntWahlA3: TDBEdit;
    RFE_MVZ_EignPaZusErlWahlA3: TDBEdit;
    RFE_MVZ_EignPaVersTageA3: TDBEdit;
    RFE_MVZ_FrmdPaAntNormalA3: TDBEdit;
    RFE_MVZ_FrmdPaZusErlNormA1: TDBEdit;
    RFE_MVZ_FrmdPaAntWahlA1: TDBEdit;
    RFE_MVZ_FrmdPaZusErlWahlA1: TDBEdit;
    RFE_MVZ_FrmdPaVersTageA1: TDBEdit;
    RFE_MVZ_ArztMinA1: TDBEdit;
    RFE_MVZ_FrmdPaZusErlNormA2: TDBEdit;
    RFE_MVZ_FrmdPaAntWahlA2: TDBEdit;
    RFE_MVZ_FrmdPaZusErlWahlA2: TDBEdit;
    RFE_MVZ_FrmdPaVersTageA2: TDBEdit;
    RFE_MVZ_ArztMinA2: TDBEdit;
    RFE_MVZ_FrmdPaZusErlNormA3: TDBEdit;
    RFE_MVZ_FrmdPaAntWahlA3: TDBEdit;
    RFE_MVZ_FrmdPaZusErlWahlA3: TDBEdit;
    RFE_MVZ_FrmdPaVersTageA3: TDBEdit;
    RFE_MVZ_ArztMinA3: TDBEdit;
    pnBerichte: TPanel;
    pnModule: TPanel;
    pnModuleFunktion: TPanel;
    lblStation1: TLabel;
    WebLabel1: TLabel;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    LF4_GeldAnl: TDBEdit;
    LF4_ErtrAus: TDBEdit;
    LF4_KredTlg: TDBEdit;
    LF4_VorkErl: TDBEdit;
    LF4_VerkAnl: TDBEdit;
    LF4_CMngmnt: TDBEdit;
    pnLeftNavigation: TPanel;
    lblPeriode: TLabel;
    lblAbteilung: TLabel;
    lblFallnummer: TLabel;
    btnClose: TButton;
    btnSave: TButton;
    spedPeriode: TSpinEdit;
    btnPrint: TButton;
    btnCancel: TButton;
    brnHelp: TButton;
    spedAbteilung: TSpinEdit;
    spedFallNummer: TSpinEdit;
    pnAbteilungen: TPanel;
    strGridInstitute: TStringGrid;
    strGridFallZuordnung: TStringGrid;
    strGridAbteilungen: TStringGrid;
    WebLabel6: TLabel;
    WebLabel8: TLabel;
    WebLabel9: TLabel;
    WebLabel10: TLabel;
    WebLabel11: TLabel;
    lblsecondChirurgieHeadline: TLabel;
    LblthirdChirurgieHeadline: TLabel;
    lblfourthChirurgieHeadline: TLabel;
    lblfourthOrthopaedieHeadline: TLabel;
    LblthirdOrthopaedieHeadline: TLabel;
    lblsecondOrthopaedieHeadline: TLabel;
    lblfourthInnereHeadline: TLabel;
    lblthirdInnereHeadline: TLabel;
    lblsecondInnereHeadline: TLabel;
    LF4_Inst6OutSrc: TDBEdit;
    La4_Inst6: TLabel;
    XDataWebConnection1: TXDataWebConnection;
    ModulWebDataSource: TDataSource;
    XDataWebDataSetModul: TXDataWebDataSet;
    MVZStat1WebDataSource: TDataSource;
    XDataWebDataSetMVZStation1: TXDataWebDataSet;
    MVZStat2WebDataSource: TDataSource;
    XDataWebDataSetMVZStation2: TXDataWebDataSet;
    MVZStat3WebDataSource: TDataSource;
    XDataWebDataSetMVZStation3: TXDataWebDataSet;
    XDataWebDataSetFaelle: TXDataWebDataSet;
    La4_Inst7: TLabel;
    LF4_Inst7PlanKPI: TDBEdit;
    XDataWebDataSetKPI: TXDataWebDataSet;
    KPIWebDataSource: TDataSource;
    WebLabel21: TLabel;
    WebLabel22: TLabel;
    WebLabel23: TLabel;
    WebLabel35: TLabel;
    WebDBEdit4: TDBEdit;
    WebDBEdit5: TDBEdit;
    WebDBEdit6: TDBEdit;
    pnKPI: TPanel;
    lblHeadlineKPIDaten: TLabel;
    procedure btnSaveClick(Sender: TObject);
    procedure btnCloseClick(Sender: TObject);
    procedure ModulWebDataSourceDataChange(Sender: TObject; Field: TField);
    procedure PageControlChange(Sender: TObject);
    procedure strGridFallZuordnungClickCell(Sender: TObject; ACol, ARow: Integer);
    procedure strGridFallZuordnungGetCellEditor(Sender: TObject; ACol, ARow: Integer; var AEditor: TGridCellEditor);
    procedure XDataWebDataSetFaelleAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetModulAfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetMVZStation1AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetMVZStation2AfterOpen(DataSet: TDataSet);
    procedure XDataWebDataSetMVZStation3AfterOpen(DataSet: TDataSet);
    procedure strGridFallZuordnungCheckClick(Sender: TObject; ACol, ARow: Integer; Checked: Boolean);
    procedure LF4_VorkErlValidate(Sender: TObject; var AValue: string; var Valid: Boolean);
  strict private
    function DrawGridPG1Institute: Boolean;
    function DrawGridPG3FallZuordnungen: Boolean;
    function DrawGridPG6Abteilungen: Boolean;

    [Async]
    function SaveData: Boolean; async;

    function SetupPage1(AFirstRun: Boolean = false): Boolean; virtual;
    function SetupPage3(AFirstRun: Boolean = false): Boolean; virtual;
    function SetupPage4(AFirstRun: Boolean = false): Boolean; virtual;
    function SetupPage5(AFirstRun: Boolean = false): Boolean; virtual;
    function SetupPage6(AFirstRun: Boolean = false): Boolean; virtual;


  private
    FDataChanged: Boolean;
    function ReDrawGridPG3FallZuordnungen: Boolean;
    function SaveGridPG3FallZuordnungen: Boolean;
    function ToggleGUI: boolean; virtual;
    [Async]
    function SetupData: Boolean; async; virtual;
    [Async]
    function UpdateFallZuordnung: Boolean; async;
    { Private-Deklarationen }
  public
    [Async]
    function Done: Boolean; async; override;
    [Async]
    function Init: Boolean; async; override;
    { Public-Deklarationen }
  protected
    procedure SetMenuEnable(value: boolean); override;
  published
    property DataChanged: Boolean read FDataChanged write FDataChanged default false;
  protected procedure LoadDFMValues; override; end;

var
  PrjFormsPeriodenUnabhaengigeDaten: TPrjFormsPeriodenUnabhaengigeDaten;

implementation

{$R *.dfm}

uses
  wxBaseClassWebTools,
  PrjClassHelperClasses,
  PrjFormMain,
  HBMWebData;


procedure TPrjFormsPeriodenUnabhaengigeDaten.btnCloseClick(Sender: TObject);
begin
  close;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.btnSaveClick(Sender: TObject);
begin
  WaitMessage.Show;
  try
    SaveData;
    Self.Done;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodenUnabhaengigeDaten.btnSaveClick', slDebug);
  end;
  WaitMessage.Hide;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.Init: Boolean;
begin
  WaitMessage.Show;

  spedPeriode.Value        := DataModule.HBMDefaultData.AktuellePeriode;
  spedPeriode.MinValue     := 0;
  spedPeriode.MaxValue     := 9;

  spedFallNummer.Value        := 1;
  spedFallNummer.MinValue     := 1;
  spedFallNummer.MaxValue     := 6;

  spedAbteilung.MinValue  := 1;
  spedAbteilung.MaxValue  := 3;
  spedAbteilung.Value     := 1;

  PageControl.ActivePage := pgSeite1;
  await(SetUpData);

  SetupPage1;
  SetupPage4;
  SetupPage6;

  Self.PageControlChange(Self);
  WaitMessage.Hide;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.LF4_VorkErlValidate(Sender: TObject; var AValue: string; var Valid: Boolean);
begin
  inherited;
  Valid := AValue.ToDouble > 0;

end;

function TPrjFormsPeriodenUnabhaengigeDaten.Done: Boolean;
begin
  result := true;
  try
    DataChanged := false;
    ToggleGUI;
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodenUnabhaengigeDaten.Done', slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG1Institute: Boolean;
var LRow     : integer;
begin
  result := true;
  try
    strGridInstitute.BeginUpdate;
    strGridInstitute.RowCount := Institute.Count + 1;
    strGridInstitute.Cells[0, 0] := 'Nr:';
    strGridInstitute.Cells[1, 0] := 'Institutsname';
    strGridInstitute.Cells[2, 0] := 'Institut Nr:';
    strGridInstitute.Cells[3, 0] := 'ab Periode';
    strGridInstitute.Cells[4, 0] := 'Institut Kennung';
    for LRow := 0 to Institute.Count - 1 do
    begin
      strGridInstitute.Cells[0, LRow + 1] := (LRow + 1).ToString;
      strGridInstitute.Cells[1, LRow + 1] := Institute.FindAssignment(LRow).FContent;
      strGridInstitute.Cells[2, LRow + 1] := Institute.FindAssignment(LRow).FAssignment.ToString;
      strGridInstitute.Cells[3, LRow + 1] := Institute.FindAssignment(LRow).FPeriod.ToString;
    end;
    strGridInstitute.EndUpdate;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG1Institute while drawing grid',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.ReDrawGridPG3FallZuordnungen: Boolean;
  function AnzFaelleJeAbtl(AABteilung : integer): integer;
  var LIdx  : integer;
  var LCol  : integer;
  begin
    result := 0;
    for LCol := 0 to strGridFallZuordnung.ColCount - 1 do
    begin
      if Abteilungen.FindAssignment(AABteilung).FContent = strGridFallZuordnung.Cells[LCol, 0]  then
      begin
        break;
      end;
    end;

    for LIdx := 1 to strGridFallZuordnung.RowCount - 2 do
    begin
      if strGridFallZuordnung.CheckState[LCol, LIdx] then
        inc(Result);
    end;
  end;
begin
  result := true;
  try
    strGridFallZuordnung.Cells[0, strGridFallZuordnung.RowCount - 1] := '---';
    strGridFallZuordnung.Cells[1, strGridFallZuordnung.RowCount - 1] := 'Summe';
    strGridFallZuordnung.Cells[4, strGridFallZuordnung.RowCount - 1 ]:= AnzFaelleJeAbtl(1).ToString;
    strGridFallZuordnung.Cells[5, strGridFallZuordnung.RowCount - 1 ]:= AnzFaelleJeAbtl(2).ToString;
    strGridFallZuordnung.Cells[6, strGridFallZuordnung.RowCount - 1 ]:= AnzFaelleJeAbtl(3).ToString;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.ReDrawGridPG3FallZuordnungen while redrawing grid', slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SaveGridPG3FallZuordnungen: Boolean;
var LRow  : integer;
begin
  result := true;
  try
    for LRow := 1 to strGridFallZuordnung.RowCount - 2 do
    begin
      if XDataWebDataSetFaelle.Locate('MAFA_FALLNAME', strGridFallZuordnung.Cells[1, LRow], [] ) then
      begin
        if not (XDataWebDataSetFaelle.State in [dsEdit]) then
        begin
          XDataWebDataSetFaelle.Edit;
        end;
        if XDataWebDataSetFaelle.State in [dsEdit] then
        begin
          XDataWebDataSetFaelle.FieldByName('MAFA_VALID_PERIOD').AsInteger := strGridFallZuordnung.Cells[3, LRow].ToInteger;
          XDataWebDataSetFaelle.FieldByName('MAFA_ORDER_BY').AsInteger     := strGridFallZuordnung.Cells[2, LRow].ToInteger;

          if strGridFallZuordnung.CheckState[4, LRow] then
          begin
            XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger := Abteilungen.FindAssignmentByName(strGridFallZuordnung.Cells[4, 0]);
          end else if strGridFallZuordnung.CheckState[5, LRow] then
          begin
            XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger := Abteilungen.FindAssignmentByName(strGridFallZuordnung.Cells[5, 0]);
          end else if strGridFallZuordnung.CheckState[6, LRow] then
          begin
            XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger := Abteilungen.FindAssignmentByName(strGridFallZuordnung.Cells[6, 0]);
          end else
          begin
            XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger := -1;
          end;
          XDataWebDataSetFaelle.Post;
        end;
      end;
    end;
    XDataWebDataSetFaelle.ApplyUpdates;
    DataChanged := False;
    ToggleGUI;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SaveGridPG3FallZuordnungen while saving grid ! Fatal Error: ', slFatalError);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG3FallZuordnungen: Boolean;
var LCol : integer;
var LRow : integer;

  function gesperrt(aCol: Integer): Boolean;
  begin
    result := (aCol = 1);
  end;
begin
  result := true;
  try
    strGridFallZuordnung.BeginUpdate;
    strGridFallZuordnung.RowCount := drgFaelle.Count + 2;
    strGridFallZuordnung.Cells[0, 0] := 'Nr.';
    strGridFallZuordnung.Cells[1, 0] := 'Fall Name';
    strGridFallZuordnung.Cells[2, 0] := 'Sortierung';
    strGridFallZuordnung.Cells[3, 0] := 'Fall ab Periode';
    strGridFallZuordnung.Cells[4, 0] := Abteilungen.FindAssignment(1).FContent;
    strGridFallZuordnung.Cells[5, 0] := Abteilungen.FindAssignment(2).FContent;
    strGridFallZuordnung.Cells[6, 0] := Abteilungen.FindAssignment(3).FContent;
    LRow := 0;

//    for LRow := 0 to drgFaelle.Count - 1 do
//    begin
//      strGridFallZuordnung.Cells[0, LRow + 1]   := drgFaelle.FindAssignment(LRow + 1).FAssignment.ToString;
//      strGridFallZuordnung.Cells[1, LRow + 1]   := drgFaelle.FindAssignment(LRow + 1).FContent;
//      strGridFallZuordnung.Cells[2, LRow + 1]   := drgFaelle.FindAssignment(LRow + 1).FSortOrder.ToString;
//      strGridFallZuordnung.Cells[3, LRow + 1]   := drgFaelle.FindAssignment(LRow + 1).FPeriod.ToString;
//      strGridFallZuordnung.Objects[0, LRow + 1] := drgFaelle.FindAssignment(LRow + 1);
//
//      strGridFallZuordnung.AddCheckBox(4, LRow + 1, drgFaelle.FindAssignment(LRow + 1).FOptionalIntField1 = 1);
//      strGridFallZuordnung.AddCheckBox(5, LRow + 1, drgFaelle.FindAssignment(LRow + 1).FOptionalIntField1 = 2);
//      strGridFallZuordnung.AddCheckBox(6, LRow + 1, drgFaelle.FindAssignment(LRow + 1).FOptionalIntField1 = 3);
//    end;
    LRow := 0;
    if XDataWebDataSetFaelle.Active and (not XDataWebDataSetFaelle.IsEmpty) then
    begin

      while not XDataWebDataSetFaelle.Eof do
      begin
        strGridFallZuordnung.Cells[0, LRow + 1]   := XDataWebDataSetFaelle.FieldByName('MAFA_ASSIGNMENT').AsString;
        strGridFallZuordnung.Cells[1, LRow + 1]   := XDataWebDataSetFaelle.FieldByName('MAFA_FALLNAME').AsString;
        strGridFallZuordnung.Cells[2, LRow + 1]   := XDataWebDataSetFaelle.FieldByName('MAFA_ORDER_BY').AsString;
        strGridFallZuordnung.Cells[3, LRow + 1]   := XDataWebDataSetFaelle.FieldByName('MAFA_VALID_PERIOD').AsString;
  //      strGridFallZuordnung.Objects[0, LRow + 1] := drgFaelle.FindAssignment(LRow + 1);

        strGridFallZuordnung.AddCheckBox(4, LRow + 1, XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger = 1);
        strGridFallZuordnung.AddCheckBox(5, LRow + 1, XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger = 2);
        strGridFallZuordnung.AddCheckBox(6, LRow + 1, XDataWebDataSetFaelle.FieldByName('MAFA_DEPARTMENT_ID').AsInteger = 3);
        XDataWebDataSetFaelle.Next;
        inc(LRow);
      end;
    end else
    begin

    end;

    Self.ReDrawGridPG3FallZuordnungen;

    for LRow := 0 to strGridFallZuordnung.RowCount - 1 do
    begin
      for LCol := 0 to strGridFallZuordnung.ColCount - 1 do
      begin
        strGridFallZuordnung.CellElements[LCol, LRow].style.removeProperty('background-color');
        strGridFallZuordnung.CellElements[LCol, LRow].style.removeProperty('text-align');
        if Gesperrt(LCol) then
        begin
          strGridFallZuordnung.CellElements[LCol, LRow].style.setProperty('background-color', '#F5F6CE');
        end;
        if LCol > 0 then
          strGridFallZuordnung.CellElements[LCol, LRow].style.SetProperty('text-align','center')
        else
          strGridFallZuordnung.CellElements[LCol, LRow].style.SetProperty('text-align','left');

        if (LRow = 0) and (LCol > 1) then
          strGridFallZuordnung.CellElements[LCol, LRow].style.setProperty('background-color', '#F5F6CE');

        if (LRow = strGridFallZuordnung.RowCount - 1) and (LCol > 1) then
          strGridFallZuordnung.CellElements[LCol, LRow].style.setProperty('background-color', '#F5F6CE');
      end;
    end;
    strGridFallZuordnung.EndUpdate;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG3FallZuordnungen while drawing grid',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG6Abteilungen: Boolean;
var LRow : integer;
var LTableProps : TTableProperties;
begin
  result := true;
  try
    strGridAbteilungen.BeginUpdate;
    strGridAbteilungen.RowCount     := 1;
    strGridAbteilungen.Cells[0, 0]  := 'Nr.';
    strGridAbteilungen.Cells[1, 0]  := 'Abteilungs Name';
    strGridAbteilungen.Cells[2, 0]  := 'Abteilungs Nr.';
    strGridAbteilungen.Cells[3, 0]  := 'ab Periode';
    for LRow := 0 to Abteilungen.Count - 1 do
    begin
      LTableProps := Abteilungen.FindAssignment(LRow + 1);
      if Assigned(LTableProps) then
      begin
        strGridAbteilungen.RowCount := strGridAbteilungen.RowCount + 1;
        strGridAbteilungen.Cells[0, strGridAbteilungen.RowCount - 1]  := IntToStr(strGridAbteilungen.RowCount - 1);
        strGridAbteilungen.Cells[1, strGridAbteilungen.RowCount - 1]  := LTableProps.FContent;
        strGridAbteilungen.Cells[2, strGridAbteilungen.RowCount - 1]  := LTableProps.FAssignment.ToString;
        strGridAbteilungen.Cells[3, strGridAbteilungen.RowCount - 1]  := LTableProps.FPeriod.ToString;
      end;

    end;
    strGridAbteilungen.EndUpdate;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.DrawGridPG6Abteilungen while drawing grid',slDebug);
    strGridAbteilungen.EndUpdate;
    result := false;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.ModulWebDataSourceDataChange(Sender: TObject; Field: TField);
begin
  if Assigned(Field) then
  begin
    DataChanged     := true;
    btnSave.Enabled := DataChanged;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.PageControlChange(Sender: TObject);
begin
  if PageControl.ActivePageIndex = 0 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end else if PageControl.ActivePageIndex = 1 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end else if PageControl.ActivePageIndex = 2 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end else if PageControl.ActivePageIndex = 3 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end else if PageControl.ActivePageIndex = 4 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end else if PageControl.ActivePageIndex = 5 then
  begin
    spedAbteilung.Enabled   := false;
    spedFallNummer.Enabled  := false;
    spedPeriode.Enabled     := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupData: Boolean;
begin
  Result := true;
  try
    DataModule.HBMDefaultData.AktuellePeriode := spedPeriode.Value;

    XDataWebDataSetModul.Cancel;
    XDataWebDataSetFaelle.Cancel;
    XDataWebDataSetMVZStation1.Cancel;
    XDataWebDataSetMVZStation2.Cancel;
    XDataWebDataSetMVZStation3.Cancel;

    XDataWebDataSetModul.Close;
    XDataWebDataSetFaelle.Close;
    XDataWebDataSetMVZStation1.Close;
    XDataWebDataSetMVZStation2.Close;
    XDataWebDataSetMVZStation3.Close;

    XDataWebDataSetModul.Connection         := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetFaelle.Connection        := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetMVZStation1.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetMVZStation2.Connection   := PrjFormsMain.XDataWebConnectionMain;
    XDataWebDataSetMVZStation3.Connection   := PrjFormsMain.XDataWebConnectionMain;

    XDataWebDataSetModul.QueryString        := '$filter=(Upmd_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ')';
    XDataWebDataSetFaelle.QueryString       := '$orderby=Mafa_Assignment';
    XDataWebDataSetMVZStation1.QueryString  := '$filter=(Upmv_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ') AND (Upmv_Department_Id eq 1)';
    XDataWebDataSetMVZStation2.QueryString  := '$filter=(Upmv_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ') AND (Upmv_Department_Id eq 2)';
    XDataWebDataSetMVZStation3.QueryString  := '$filter=(Upmv_Simulation_Id eq ' + DataAccess.AktuelleSimulation.toString  + ') AND (Upmv_Department_Id eq 3)';

    await(XDataWebDataSetModul.Load);
    await(XDataWebDataSetFaelle.Load);
    await(XDataWebDataSetMVZStation1.Load);
    await(XDataWebDataSetMVZStation2.Load);
    await(XDataWebDataSetMVZStation3.Load);

    PageControlChange(Self);
  except
    wxBaseWriteLog.Write('Exception occured in modul TPrjFormsPeriodenUnabhaengigeDaten.SetupData', slError);
    Result := false;
  end;
end;


function TPrjFormsPeriodenUnabhaengigeDaten.UpdateFallZuordnung: Boolean;
begin
  Result := true;
  try
    DataModule.HBMDefaultData.CalculatedDepartment  := spedAbteilung.Value;
    DataModule.HBMDefaultData.CalculatedPeriod      := spedPeriode.Value;
    DataModule.HBMDefaultData.CalculatedCase        := spedFallNummer.Value;

    {$IFDEF APPISTLN}
    result := await(DataAccess.RequestDaten('U', HBMMainT.XDataWebConnectionMain,'PP'));
    {$ELSE}
    result := await(DataAccess.RequestDaten('U', PrjFormsMain.XDataWebConnectionMain,'PP'));
    {$ENDIF}
  except
    Result := false;
  end;
end;



function TPrjFormsPeriodenUnabhaengigeDaten.SaveData: Boolean;
begin
  Result := true;
  try
    if Self.SaveGridPG3FallZuordnungen then
    begin
      await(XDataWebDataSetModul.Post);
      await(XDataWebDataSetMVZStation1.Post);
      await(XDataWebDataSetMVZStation2.Post);
      await(XDataWebDataSetMVZStation3.Post);

      await(XDataWebDataSetModul.ApplyUpdates);
      await(XDataWebDataSetMVZStation1.ApplyUpdates);
      await(XDataWebDataSetMVZStation2.ApplyUpdates);
      await(XDataWebDataSetMVZStation3.ApplyUpdates);

      await(Self.UpdateFallZuordnung);
    end;

    XDataWebDataSetModul.Edit;
    XDataWebDataSetFaelle.Edit;
    XDataWebDataSetMVZStation1.Edit;
    XDataWebDataSetMVZStation2.Edit;
    XDataWebDataSetMVZStation3.Edit;

  except
    result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SaveData ! Fatal Error ', slFatalError);
  end;
  DataChanged := Result;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.SetMenuEnable(value: boolean);
begin
//
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupPage1(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    DrawGridPG1Institute;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SetupPage1',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupPage3(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    DrawGridPG3FallZuordnungen;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SetupPage3',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupPage4(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    lblfirstChirurgieHeadline.Caption     := Abteilungen.FindAssignment(1).FContent;
    lblfirstOrthopaedieHeadline.Caption   := Abteilungen.FindAssignment(2).FContent;
    lblfirstInnereHeadline.Caption        := Abteilungen.FindAssignment(3).FContent;

    lblsecondChirurgieHeadline.Caption    := Abteilungen.FindAssignment(1).FContent;
    lblsecondOrthopaedieHeadline.Caption  := Abteilungen.FindAssignment(2).FContent;
    lblsecondInnereHeadline.Caption       := Abteilungen.FindAssignment(3).FContent;

    LblthirdChirurgieHeadline.Caption     := Abteilungen.FindAssignment(1).FContent;
    LblthirdOrthopaedieHeadline.Caption   := Abteilungen.FindAssignment(2).FContent;
    lblthirdInnereHeadline.Caption        := Abteilungen.FindAssignment(3).FContent;

    lblfourthChirurgieHeadline.Caption    := Abteilungen.FindAssignment(1).FContent;
    lblfourthOrthopaedieHeadline.Caption  := Abteilungen.FindAssignment(2).FContent;
    lblfourthInnereHeadline.Caption       := Abteilungen.FindAssignment(3).FContent;

    La4_Inst6.Caption                     := 'Outsourcing ' + Institute.FindAssignment(6).FContent;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SetupPage4',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupPage5(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SetupPage5',slDebug);
    result := false;
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.SetupPage6(AFirstRun: Boolean = false): Boolean;
begin
  Result := true;
  try
    DrawGridPG6Abteilungen;
  except
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.SetupPage6',slDebug);
    result := false;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.strGridFallZuordnungCheckClick(Sender: TObject; ACol, ARow: Integer; Checked: Boolean);
var LIdx : integer;
var LRow : integer;
var LChkCnt  : integer;
begin
  if ACol in [4,5,6] then
  begin
    strGridFallZuordnung.BeginUpdate;
    LChkCnt := 0;
    for LRow := 2 to strGridFallZuordnung.RowCount - 2 do
    begin
      if strGridFallZuordnung.CheckState[ACol, LRow] = true then
        inc(LChkCnt);
    end;

    if (LChkCnt > 6) then
    begin
      strGridFallZuordnung.CheckState[ACol, ARow] := false;
    end;

    if (LChkCnt <= 6) then
    begin
      for LIdx := 4 to 6 do
      begin
        if ACol <> LIdx then
        begin
          strGridFallZuordnung.CheckState[Lidx, ARow] := false;
        end;
      end;
    end;
    strGridFallZuordnung.Invalidate;
    strGridFallZuordnung.EndUpdate;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.strGridFallZuordnungClickCell(Sender: TObject; ACol, ARow: Integer);
begin
  inherited;
  if ACol in [1,2,3,4,5] then
  begin
    DataChanged := true;
    Self.ReDrawGridPG3FallZuordnungen;
    Self.ToggleGUI;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.strGridFallZuordnungGetCellEditor(Sender: TObject; ACol, ARow: Integer; var AEditor: TGridCellEditor);
begin
  inherited;
  if (ACol in [2]) and (ARow > 0) then
  begin
    AEditor := geNumber;
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.XDataWebDataSetModulAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetModul.IsEmpty then
  begin
    XDataWebDataSetModul.Edit;
    SetupPage4;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetModul.EntitySetName + ']', slDebug);
  end;
end;

function TPrjFormsPeriodenUnabhaengigeDaten.ToggleGUI: boolean;
begin
  Result := true;
  try
    btnSave.Enabled := DataChanged;
  except
    Result := false;
    wxBaseWriteLog.Write('Exception raised in TPrjFormsPeriodenUnabhaengigeDaten.ToggleGUI while setting up data',slDebug);
  end;

end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.XDataWebDataSetFaelleAfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetFaelle.IsEmpty then
  begin
    XDataWebDataSetFaelle.Refresh;
    SetupPage3;
    XDataWebDataSetFaelle.Edit;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetFaelle.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.XDataWebDataSetMVZStation1AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetMVZStation1.IsEmpty then
  begin
    XDataWebDataSetMVZStation1.Edit;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetMVZStation1.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.XDataWebDataSetMVZStation2AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetMVZStation2.IsEmpty then
  begin
    XDataWebDataSetMVZStation2.Edit;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetMVZStation2.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.XDataWebDataSetMVZStation3AfterOpen(DataSet: TDataSet);
begin
  if not XDataWebDataSetMVZStation3.IsEmpty then
  begin
    XDataWebDataSetMVZStation3.Edit;
    DataChanged := false;
    ToggleGUI;
  end else
  begin
    wxBaseWriteLog.Write('no records found for Table [' + XDataWebDataSetMVZStation3.EntitySetName + ']', slDebug);
  end;
end;

procedure TPrjFormsPeriodenUnabhaengigeDaten.LoadDFMValues;
begin
  inherited LoadDFMValues;

  PageControl := TPageControl.Create('unabhaengigeDatenTabControl');
  pgSeite1 := TTabSheet.Create('pgSeiteEins');
  pnInstitute := TPanel.Create('pnInstitute');
  strGridInstitute := TStringGrid.Create(Self);
  pgSeite3 := TTabSheet.Create('pgSeiteDrei');
  pnFallZuordnung := TPanel.Create('pnFallzuordnung');
  strGridFallZuordnung := TStringGrid.Create(Self);
  pgSeite4 := TTabSheet.Create('pgSeiteVier');
  pnMedVersorgung := TPanel.Create('pnMedVersorgung');
  WebLabel15 := TLabel.Create('anschaffungGeraeteLabel');
  WebLabel16 := TLabel.Create('investitionGebaeudeLabel');
  WebLabel17 := TLabel.Create('instandhaltungLabel');
  WebLabel18 := TLabel.Create('verwaltungskostenLabel');
  WebLabel19 := TLabel.Create('lebensmittelLabel');
  WebLabel20 := TLabel.Create('medizinischerBedarfLabel');
  lblfirstChirurgieHeadline := TLabel.Create('firstChirurgieHeadline');
  lblfirstOrthopaedieHeadline := TLabel.Create('firstOrthopaedieHeadline');
  lblfirstInnereHeadline := TLabel.Create('firstInnereHeadline');
  WebLabel24 := TLabel.Create('patientenNormalleistungLabel');
  WebLabel25 := TLabel.Create('zusatzNormalLabel');
  WebLabel26 := TLabel.Create('patientenWahlleistungLabel');
  WebLabel27 := TLabel.Create('zusatzWahlLabel');
  WebLabel28 := TLabel.Create('versorgungstageEigeneLabel');
  WebLabel29 := TLabel.Create('fremdePatientenNormalLabel');
  WebLabel30 := TLabel.Create('zusatzFremdLabel');
  WebLabel31 := TLabel.Create('fremdePatientenWahlLabel');
  WebLabel32 := TLabel.Create('zusatzFremdWahlLabel');
  WebLabel33 := TLabel.Create('versorgungstageFremdLabel');
  WebLabel34 := TLabel.Create('arztminutenLabel');
  WebLabel8 := TLabel.Create('anschaffungHeadline');
  WebLabel9 := TLabel.Create('eigenePersonenHeadline');
  WebLabel10 := TLabel.Create('fremdePersonenHeadline');
  WebLabel11 := TLabel.Create('arztminutenHeadline');
  lblsecondChirurgieHeadline := TLabel.Create('secondChirurgieHeadline');
  LblthirdChirurgieHeadline := TLabel.Create('thirdChirurgieHeadline');
  lblfourthChirurgieHeadline := TLabel.Create('fourthChirurgieHeadline');
  lblfourthOrthopaedieHeadline := TLabel.Create('fourthOrthopaedieHeadline');
  LblthirdOrthopaedieHeadline := TLabel.Create('thirdOrthopaedieHeadline');
  lblsecondOrthopaedieHeadline := TLabel.Create('secondOrthopaedieHeadline');
  lblfourthInnereHeadline := TLabel.Create('fourthInnereHeadline');
  lblthirdInnereHeadline := TLabel.Create('thirdInnereHeadline');
  lblsecondInnereHeadline := TLabel.Create('secondInnereHeadline');
  RFE_MVZ_AnschaffKoA1 := TDBEdit.Create('anschaffungGeraeteChirurgie');
  RFE_MVZ_InvestiKoA1 := TDBEdit.Create('investitionGebaeudeChirurgie');
  RFE_MVZ_InstHaltKoA1 := TDBEdit.Create('instandhaltungChirurgie');
  RFE_MVZ_ZusVerwKoA1 := TDBEdit.Create('verwaltungskostenChirurgie');
  RFE_MVZ_ZusLebensmA1 := TDBEdit.Create('lebensmittelChirurgie');
  RFE_MVZ_ZusMedTechnA1 := TDBEdit.Create('medizinischerBedarfChirurgie');
  RFE_MVZ_AnschaffKoA2 := TDBEdit.Create('anschaffungGeraeteOrthopaedie');
  RFE_MVZ_InvestiKoA2 := TDBEdit.Create('investitionGebaeudeOrthopaedie');
  RFE_MVZ_InstHaltKoA2 := TDBEdit.Create('instandhaltungOrthopaedie');
  RFE_MVZ_ZusVerwKoA2 := TDBEdit.Create('verwaltungskostenOrthopaedie');
  RFE_MVZ_ZusLebensmA2 := TDBEdit.Create('lebensmittelOrthopaedie');
  RFE_MVZ_ZusMedTechnA2 := TDBEdit.Create('medizinischerBedarfOrthopaedie');
  RFE_MVZ_AnschaffKoA3 := TDBEdit.Create('anschaffungGeraeteInnere');
  RFE_MVZ_InvestiKoA3 := TDBEdit.Create('investitionGebaeudeInnere');
  RFE_MVZ_InstHaltKoA3 := TDBEdit.Create('instandhaltungInnere');
  RFE_MVZ_ZusVerwKoA3 := TDBEdit.Create('verwaltungskostenInnere');
  RFE_MVZ_ZusLebensmA3 := TDBEdit.Create('lebensmittelInnere');
  RFE_MVZ_ZusMedTechnA3 := TDBEdit.Create('medizinischerBedarfInnere');
  RFE_MVZ_EignPaAntNormalA1 := TDBEdit.Create('patientenNormalleistungChirurgie');
  RFE_MVZ_EignPaZusErlNormA1 := TDBEdit.Create('zusatzNormalChirurgie');
  RFE_MVZ_EignPaAntWahlA1 := TDBEdit.Create('patientenWahlleistungChirurgie');
  RFE_MVZ_EignPaZusErlWahlA1 := TDBEdit.Create('zusatzWahlChirurgie');
  RFE_MVZ_EignPaVersTageA1 := TDBEdit.Create('versorgungstageEigeneChirurgie');
  RFE_MVZ_FrmdPaAntNormalA1 := TDBEdit.Create('fremdePatientenNormalChirurgie');
  RFE_MVZ_EignPaAntNormalA2 := TDBEdit.Create('patientenNormalleistungOrthopaedie');
  RFE_MVZ_EignPaZusErlNormA2 := TDBEdit.Create('zusatzNormalOrthopaedie');
  RFE_MVZ_EignPaAntWahlA2 := TDBEdit.Create('patientenWahlleistungOrthopaedie');
  RFE_MVZ_EignPaZusErlWahlA2 := TDBEdit.Create('zusatzWahlOrthopaedie');
  RFE_MVZ_EignPaVersTageA2 := TDBEdit.Create('versorgungstageEigeneOrthopaedie');
  RFE_MVZ_FrmdPaAntNormalA2 := TDBEdit.Create('fremdePatientenNormalOrthopaedie');
  RFE_MVZ_EignPaAntNormalA3 := TDBEdit.Create('patientenNormalleistungInnere');
  RFE_MVZ_EignPaZusErlNormA3 := TDBEdit.Create('zusatzNormalInnere');
  RFE_MVZ_EignPaAntWahlA3 := TDBEdit.Create('patientenWahlleistungInnere');
  RFE_MVZ_EignPaZusErlWahlA3 := TDBEdit.Create('zusatzWahlInnere');
  RFE_MVZ_EignPaVersTageA3 := TDBEdit.Create('versorgungstageEigeneInnere');
  RFE_MVZ_FrmdPaAntNormalA3 := TDBEdit.Create('fremdePatientenNormalInnere');
  RFE_MVZ_FrmdPaZusErlNormA1 := TDBEdit.Create('zusatzFremdChirurgie');
  RFE_MVZ_FrmdPaAntWahlA1 := TDBEdit.Create('fremdePatientenWahlChirurgie');
  RFE_MVZ_FrmdPaZusErlWahlA1 := TDBEdit.Create('zusatzFremdWahlChirurgie');
  RFE_MVZ_FrmdPaVersTageA1 := TDBEdit.Create('versorgungstageFremdChirurgie');
  RFE_MVZ_ArztMinA1 := TDBEdit.Create('arztminutenChirurgie');
  RFE_MVZ_FrmdPaZusErlNormA2 := TDBEdit.Create('zusatzFremdOrthopaedie');
  RFE_MVZ_FrmdPaAntWahlA2 := TDBEdit.Create('fremdePatientenWahlOrthopaedie');
  RFE_MVZ_FrmdPaZusErlWahlA2 := TDBEdit.Create('zusatzFremdWahlOrthopaedie');
  RFE_MVZ_FrmdPaVersTageA2 := TDBEdit.Create('versorgungstageFremdOrthopaedie');
  RFE_MVZ_ArztMinA2 := TDBEdit.Create('arztminutenOrthopaedie');
  RFE_MVZ_FrmdPaZusErlNormA3 := TDBEdit.Create('zusatzFremdInnere');
  RFE_MVZ_FrmdPaAntWahlA3 := TDBEdit.Create('fremdePatientenWahlInnere');
  RFE_MVZ_FrmdPaZusErlWahlA3 := TDBEdit.Create('zusatzFremdWahlInnere');
  RFE_MVZ_FrmdPaVersTageA3 := TDBEdit.Create('versorgungstageFremdInnere');
  RFE_MVZ_ArztMinA3 := TDBEdit.Create('arztminutenInnere');
  pgSeite5 := TTabSheet.Create('pgSeiteFuenf');
  pnBerichte := TPanel.Create('unabhaengigeDatenPnBerichte');
  WebLabel21 := TLabel.Create('unabhaengigeDatenPnBerichteHeadline');
  WebLabel22 := TLabel.Create('unlockKostentraegerRechnungLabel');
  WebLabel23 := TLabel.Create('unlockDeckungsbeitragRechnungLabel');
  WebLabel35 := TLabel.Create('unlockMarktforschungsBerichteLabel');
  WebDBEdit4 := TDBEdit.Create('unlockKostentraegerRechnungInput');
  WebDBEdit5 := TDBEdit.Create('unlockDeckungsbeitragRechnungInput');
  WebDBEdit6 := TDBEdit.Create('unlockMarktforschungsBerichteInput');
  pnModule := TPanel.Create('pnModule');
  pnModuleFunktion := TPanel.Create('pnModuleFunktion');
  lblStation1 := TLabel.Create('kaufWertpapiereLabel');
  WebLabel1 := TLabel.Create('ertragsausschuettungLabel');
  WebLabel2 := TLabel.Create('kredittilgungLabel');
  WebLabel3 := TLabel.Create('vorkalkulationLabel');
  WebLabel4 := TLabel.Create('verkaufLabel');
  WebLabel5 := TLabel.Create('codierLabel');
  WebLabel6 := TLabel.Create('funktionFreischaltenHeadline');
  La4_Inst6 := TLabel.Create('waeschereiOutsourcingLabel');
  La4_Inst7 := TLabel.Create('PlanungKPILabel');
  LF4_GeldAnl := TDBEdit.Create('kaufWertpapiereInput');
  LF4_ErtrAus := TDBEdit.Create('ertragsausschuettungInput');
  LF4_KredTlg := TDBEdit.Create('kredittilgungInput');
  LF4_VorkErl := TDBEdit.Create('vorkalkulationInput');
  LF4_VerkAnl := TDBEdit.Create('verkaufInput');
  LF4_CMngmnt := TDBEdit.Create('codierInput');
  LF4_Inst6OutSrc := TDBEdit.Create('waeschereiOutsourcing');
  LF4_Inst7PlanKPI := TDBEdit.Create('PlanungKPI');
  pnKPI := TPanel.Create('unabhaengigeDatenPnKPI');
  lblHeadlineKPIDaten := TLabel.Create('unabhaengigeDatenPnKPIHeadline');
  pgSeite6 := TTabSheet.Create('pgSeiteSechs');
  pnAbteilungen := TPanel.Create('pnAbteilungen');
  strGridAbteilungen := TStringGrid.Create(Self);
  pnLeftNavigation := TPanel.Create('PanelNAVDefault');
  lblPeriode := TLabel.Create('LabelNAVPeriode');
  lblAbteilung := TLabel.Create('LabelNAVAbteilung');
  lblFallnummer := TLabel.Create('LabelNAVFallnummer');
  btnClose := TButton.Create('btnNAVBack');
  btnSave := TButton.Create('btnNAVSave');
  spedPeriode := TSpinEdit.Create('SpinEdNAVPeriode');
  btnPrint := TButton.Create('btnNAVPrint');
  btnCancel := TButton.Create('btnNAVCancel');
  brnHelp := TButton.Create('btnNAVHelp');
  spedAbteilung := TSpinEdit.Create('SpinEdNAVAbteilung');
  spedFallNummer := TSpinEdit.Create('SpinEdNAVFallnummer');
  XDataWebConnection1 := TXDataWebConnection.Create(Self);
  ModulWebDataSource := TDataSource.Create(Self);
  XDataWebDataSetModul := TXDataWebDataSet.Create(Self);
  MVZStat1WebDataSource := TDataSource.Create(Self);
  XDataWebDataSetMVZStation1 := TXDataWebDataSet.Create(Self);
  MVZStat2WebDataSource := TDataSource.Create(Self);
  XDataWebDataSetMVZStation2 := TXDataWebDataSet.Create(Self);
  MVZStat3WebDataSource := TDataSource.Create(Self);
  XDataWebDataSetMVZStation3 := TXDataWebDataSet.Create(Self);
  XDataWebDataSetFaelle := TXDataWebDataSet.Create(Self);
  XDataWebDataSetKPI := TXDataWebDataSet.Create(Self);
  KPIWebDataSource := TDataSource.Create(Self);

  WaitMessage.BeforeLoadDFMValues;
  PageControl.BeforeLoadDFMValues;
  pgSeite1.BeforeLoadDFMValues;
  pnInstitute.BeforeLoadDFMValues;
  strGridInstitute.BeforeLoadDFMValues;
  pgSeite3.BeforeLoadDFMValues;
  pnFallZuordnung.BeforeLoadDFMValues;
  strGridFallZuordnung.BeforeLoadDFMValues;
  pgSeite4.BeforeLoadDFMValues;
  pnMedVersorgung.BeforeLoadDFMValues;
  WebLabel15.BeforeLoadDFMValues;
  WebLabel16.BeforeLoadDFMValues;
  WebLabel17.BeforeLoadDFMValues;
  WebLabel18.BeforeLoadDFMValues;
  WebLabel19.BeforeLoadDFMValues;
  WebLabel20.BeforeLoadDFMValues;
  lblfirstChirurgieHeadline.BeforeLoadDFMValues;
  lblfirstOrthopaedieHeadline.BeforeLoadDFMValues;
  lblfirstInnereHeadline.BeforeLoadDFMValues;
  WebLabel24.BeforeLoadDFMValues;
  WebLabel25.BeforeLoadDFMValues;
  WebLabel26.BeforeLoadDFMValues;
  WebLabel27.BeforeLoadDFMValues;
  WebLabel28.BeforeLoadDFMValues;
  WebLabel29.BeforeLoadDFMValues;
  WebLabel30.BeforeLoadDFMValues;
  WebLabel31.BeforeLoadDFMValues;
  WebLabel32.BeforeLoadDFMValues;
  WebLabel33.BeforeLoadDFMValues;
  WebLabel34.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebLabel9.BeforeLoadDFMValues;
  WebLabel10.BeforeLoadDFMValues;
  WebLabel11.BeforeLoadDFMValues;
  lblsecondChirurgieHeadline.BeforeLoadDFMValues;
  LblthirdChirurgieHeadline.BeforeLoadDFMValues;
  lblfourthChirurgieHeadline.BeforeLoadDFMValues;
  lblfourthOrthopaedieHeadline.BeforeLoadDFMValues;
  LblthirdOrthopaedieHeadline.BeforeLoadDFMValues;
  lblsecondOrthopaedieHeadline.BeforeLoadDFMValues;
  lblfourthInnereHeadline.BeforeLoadDFMValues;
  lblthirdInnereHeadline.BeforeLoadDFMValues;
  lblsecondInnereHeadline.BeforeLoadDFMValues;
  RFE_MVZ_AnschaffKoA1.BeforeLoadDFMValues;
  RFE_MVZ_InvestiKoA1.BeforeLoadDFMValues;
  RFE_MVZ_InstHaltKoA1.BeforeLoadDFMValues;
  RFE_MVZ_ZusVerwKoA1.BeforeLoadDFMValues;
  RFE_MVZ_ZusLebensmA1.BeforeLoadDFMValues;
  RFE_MVZ_ZusMedTechnA1.BeforeLoadDFMValues;
  RFE_MVZ_AnschaffKoA2.BeforeLoadDFMValues;
  RFE_MVZ_InvestiKoA2.BeforeLoadDFMValues;
  RFE_MVZ_InstHaltKoA2.BeforeLoadDFMValues;
  RFE_MVZ_ZusVerwKoA2.BeforeLoadDFMValues;
  RFE_MVZ_ZusLebensmA2.BeforeLoadDFMValues;
  RFE_MVZ_ZusMedTechnA2.BeforeLoadDFMValues;
  RFE_MVZ_AnschaffKoA3.BeforeLoadDFMValues;
  RFE_MVZ_InvestiKoA3.BeforeLoadDFMValues;
  RFE_MVZ_InstHaltKoA3.BeforeLoadDFMValues;
  RFE_MVZ_ZusVerwKoA3.BeforeLoadDFMValues;
  RFE_MVZ_ZusLebensmA3.BeforeLoadDFMValues;
  RFE_MVZ_ZusMedTechnA3.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntNormalA1.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlNormA1.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntWahlA1.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlWahlA1.BeforeLoadDFMValues;
  RFE_MVZ_EignPaVersTageA1.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntNormalA1.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntNormalA2.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlNormA2.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntWahlA2.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlWahlA2.BeforeLoadDFMValues;
  RFE_MVZ_EignPaVersTageA2.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntNormalA2.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntNormalA3.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlNormA3.BeforeLoadDFMValues;
  RFE_MVZ_EignPaAntWahlA3.BeforeLoadDFMValues;
  RFE_MVZ_EignPaZusErlWahlA3.BeforeLoadDFMValues;
  RFE_MVZ_EignPaVersTageA3.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntNormalA3.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlNormA1.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntWahlA1.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlWahlA1.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaVersTageA1.BeforeLoadDFMValues;
  RFE_MVZ_ArztMinA1.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlNormA2.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntWahlA2.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlWahlA2.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaVersTageA2.BeforeLoadDFMValues;
  RFE_MVZ_ArztMinA2.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlNormA3.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaAntWahlA3.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaZusErlWahlA3.BeforeLoadDFMValues;
  RFE_MVZ_FrmdPaVersTageA3.BeforeLoadDFMValues;
  RFE_MVZ_ArztMinA3.BeforeLoadDFMValues;
  pgSeite5.BeforeLoadDFMValues;
  pnBerichte.BeforeLoadDFMValues;
  WebLabel21.BeforeLoadDFMValues;
  WebLabel22.BeforeLoadDFMValues;
  WebLabel23.BeforeLoadDFMValues;
  WebLabel35.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit6.BeforeLoadDFMValues;
  pnModule.BeforeLoadDFMValues;
  pnModuleFunktion.BeforeLoadDFMValues;
  lblStation1.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  La4_Inst6.BeforeLoadDFMValues;
  La4_Inst7.BeforeLoadDFMValues;
  LF4_GeldAnl.BeforeLoadDFMValues;
  LF4_ErtrAus.BeforeLoadDFMValues;
  LF4_KredTlg.BeforeLoadDFMValues;
  LF4_VorkErl.BeforeLoadDFMValues;
  LF4_VerkAnl.BeforeLoadDFMValues;
  LF4_CMngmnt.BeforeLoadDFMValues;
  LF4_Inst6OutSrc.BeforeLoadDFMValues;
  LF4_Inst7PlanKPI.BeforeLoadDFMValues;
  pnKPI.BeforeLoadDFMValues;
  lblHeadlineKPIDaten.BeforeLoadDFMValues;
  pgSeite6.BeforeLoadDFMValues;
  pnAbteilungen.BeforeLoadDFMValues;
  strGridAbteilungen.BeforeLoadDFMValues;
  pnLeftNavigation.BeforeLoadDFMValues;
  lblPeriode.BeforeLoadDFMValues;
  lblAbteilung.BeforeLoadDFMValues;
  lblFallnummer.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnSave.BeforeLoadDFMValues;
  spedPeriode.BeforeLoadDFMValues;
  btnPrint.BeforeLoadDFMValues;
  btnCancel.BeforeLoadDFMValues;
  brnHelp.BeforeLoadDFMValues;
  spedAbteilung.BeforeLoadDFMValues;
  spedFallNummer.BeforeLoadDFMValues;
  XDataWebConnection1.BeforeLoadDFMValues;
  ModulWebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetModul.BeforeLoadDFMValues;
  MVZStat1WebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetMVZStation1.BeforeLoadDFMValues;
  MVZStat2WebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetMVZStation2.BeforeLoadDFMValues;
  MVZStat3WebDataSource.BeforeLoadDFMValues;
  XDataWebDataSetMVZStation3.BeforeLoadDFMValues;
  XDataWebDataSetFaelle.BeforeLoadDFMValues;
  XDataWebDataSetKPI.BeforeLoadDFMValues;
  KPIWebDataSource.BeforeLoadDFMValues;
  try
    Width := 1512;
    Height := 992;
    ElementPosition := epRelative;
    WaitMessage.Picture.LoadFromFile('PrjFormPeriodenUnabhaengigeDaten.WaitMessage.Picture.gif');
    PageControl.SetParentComponent(Self);
    PageControl.Name := 'PageControl';
    PageControl.Left := 0;
    PageControl.Top := 0;
    PageControl.Width := 1240;
    PageControl.Height := 992;
    PageControl.ElementClassName := 'tabs tabs-boxed justify-start order-first rounded-none';
    PageControl.HeightStyle := ssAuto;
    PageControl.WidthStyle := ssAuto;
    PageControl.Align := alClient;
    PageControl.ChildOrder := 2;
    PageControl.ElementTabClassName := 'tabs ';
    PageControl.ElementTabActiveClassName := 'tab-active tab';
    PageControl.ElementTabItemClassName := 'tab px-2';
    PageControl.ElementFont := efCSS;
    PageControl.TabIndex := 2;
    PageControl.TabOrder := 1;
    SetEvent(PageControl, Self, 'OnChange', 'PageControlChange');
    pgSeite1.SetParentComponent(PageControl);
    pgSeite1.Name := 'pgSeite1';
    pgSeite1.Left := 0;
    pgSeite1.Top := 20;
    pgSeite1.Width := 1240;
    pgSeite1.Height := 972;
    pgSeite1.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite1.HeightStyle := ssAuto;
    pgSeite1.WidthStyle := ssAuto;
    pgSeite1.Caption := 'Institute';
    pgSeite1.ElementFont := efCSS;
    pgSeite1.ElementPosition := epRelative;
    pnInstitute.SetParentComponent(pgSeite1);
    pnInstitute.Name := 'pnInstitute';
    pnInstitute.Left := 0;
    pnInstitute.Top := 0;
    pnInstitute.Width := 1240;
    pnInstitute.Height := 972;
    pnInstitute.HeightStyle := ssAuto;
    pnInstitute.WidthStyle := ssAuto;
    pnInstitute.Align := alClient;
    pnInstitute.ElementFont := efCSS;
    pnInstitute.ElementPosition := epRelative;
    pnInstitute.TabOrder := 0;
    strGridInstitute.SetParentComponent(pnInstitute);
    strGridInstitute.Name := 'strGridInstitute';
    strGridInstitute.Left := 104;
    strGridInstitute.Top := 87;
    strGridInstitute.Width := 951;
    strGridInstitute.Height := 419;
    strGridInstitute.ColCount := 4;
    strGridInstitute.RowCount := 11;
    strGridInstitute.TabOrder := 0;
    strGridInstitute.ElementFont := efCSS;
    strGridInstitute.ElementPosition := epRelative;
    strGridInstitute.FixedFont.Charset := DEFAULT_CHARSET;
    strGridInstitute.FixedFont.Color := clWindowText;
    strGridInstitute.FixedFont.Height := -18;
    strGridInstitute.FixedFont.Name := 'Segoe UI';
    strGridInstitute.FixedFont.Style := [];
    strGridInstitute.RangeEdit.Max := 100.00000000000000000;
    strGridInstitute.RangeEdit.Step := 1.00000000000000000;
    strGridInstitute.HeightStyle := ssAuto;
    strGridInstitute.HeightPercent := 100.00000000000000000;
    strGridInstitute.WidthStyle := ssAuto;
    strGridInstitute.WidthPercent := 100.00000000000000000;
    pgSeite3.SetParentComponent(PageControl);
    pgSeite3.Name := 'pgSeite3';
    pgSeite3.Left := 0;
    pgSeite3.Top := 20;
    pgSeite3.Width := 1240;
    pgSeite3.Height := 972;
    pgSeite3.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite3.HeightStyle := ssAuto;
    pgSeite3.WidthStyle := ssAuto;
    pgSeite3.Caption := 'Abteilung / Fallzuordnung';
    pgSeite3.ChildOrder := 2;
    pgSeite3.ElementFont := efCSS;
    pgSeite3.ElementPosition := epRelative;
    pnFallZuordnung.SetParentComponent(pgSeite3);
    pnFallZuordnung.Name := 'pnFallZuordnung';
    pnFallZuordnung.Left := 0;
    pnFallZuordnung.Top := 0;
    pnFallZuordnung.Width := 1240;
    pnFallZuordnung.Height := 972;
    pnFallZuordnung.HeightStyle := ssAuto;
    pnFallZuordnung.WidthStyle := ssAuto;
    pnFallZuordnung.Align := alClient;
    pnFallZuordnung.ElementFont := efCSS;
    pnFallZuordnung.ElementPosition := epRelative;
    pnFallZuordnung.TabOrder := 0;
    strGridFallZuordnung.SetParentComponent(pnFallZuordnung);
    strGridFallZuordnung.Name := 'strGridFallZuordnung';
    strGridFallZuordnung.Left := 71;
    strGridFallZuordnung.Top := 102;
    strGridFallZuordnung.Width := 933;
    strGridFallZuordnung.Height := 410;
    strGridFallZuordnung.ColCount := 7;
    strGridFallZuordnung.RowCount := 1;
    strGridFallZuordnung.FixedRows := 0;
    strGridFallZuordnung.Options := [goFixedVertLine,goFixedHorzLine,goVertLine,goHorzLine,goRangeSelect,goEditing,goFixedRowDefAlign];
    strGridFallZuordnung.TabOrder := 0;
    strGridFallZuordnung.ElementFont := efCSS;
    strGridFallZuordnung.ElementPosition := epRelative;
    strGridFallZuordnung.FixedFont.Charset := DEFAULT_CHARSET;
    strGridFallZuordnung.FixedFont.Color := clWindowText;
    strGridFallZuordnung.FixedFont.Height := -18;
    strGridFallZuordnung.FixedFont.Name := 'Segoe UI';
    strGridFallZuordnung.FixedFont.Style := [];
    strGridFallZuordnung.RangeEdit.Min := 1.00000000000000000;
    strGridFallZuordnung.RangeEdit.Max := 15.00000000000000000;
    strGridFallZuordnung.RangeEdit.Step := 1.00000000000000000;
    strGridFallZuordnung.HeightStyle := ssAuto;
    strGridFallZuordnung.HeightPercent := 100.00000000000000000;
    strGridFallZuordnung.WidthStyle := ssAuto;
    strGridFallZuordnung.WidthPercent := 100.00000000000000000;
    SetEvent(strGridFallZuordnung, Self, 'OnClickCell', 'strGridFallZuordnungClickCell');
    SetEvent(strGridFallZuordnung, Self, 'OnCheckClick', 'strGridFallZuordnungCheckClick');
    SetEvent(strGridFallZuordnung, Self, 'OnGetCellEditor', 'strGridFallZuordnungGetCellEditor');
    pgSeite4.SetParentComponent(PageControl);
    pgSeite4.Name := 'pgSeite4';
    pgSeite4.Left := 0;
    pgSeite4.Top := 20;
    pgSeite4.Width := 1240;
    pgSeite4.Height := 972;
    pgSeite4.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite4.HeightStyle := ssAuto;
    pgSeite4.WidthStyle := ssAuto;
    pgSeite4.Caption := 'Medizinische Versorgungszentren';
    pgSeite4.ChildOrder := 3;
    pgSeite4.ElementFont := efCSS;
    pgSeite4.ElementPosition := epRelative;
    pnMedVersorgung.SetParentComponent(pgSeite4);
    pnMedVersorgung.Name := 'pnMedVersorgung';
    pnMedVersorgung.Left := 0;
    pnMedVersorgung.Top := 0;
    pnMedVersorgung.Width := 1240;
    pnMedVersorgung.Height := 972;
    pnMedVersorgung.HeightStyle := ssAuto;
    pnMedVersorgung.WidthStyle := ssAuto;
    pnMedVersorgung.Align := alClient;
    pnMedVersorgung.ElementFont := efCSS;
    pnMedVersorgung.ElementPosition := epRelative;
    pnMedVersorgung.TabOrder := 0;
    WebLabel15.SetParentComponent(pnMedVersorgung);
    WebLabel15.Name := 'WebLabel15';
    WebLabel15.Left := 32;
    WebLabel15.Top := 115;
    WebLabel15.Width := 416;
    WebLabel15.Height := 29;
    WebLabel15.Caption := 'Anschaffung Ger'#228'te einmal (TEUR)';
    WebLabel15.ElementFont := efCSS;
    WebLabel15.ElementPosition := epRelative;
    WebLabel15.Font.Charset := DEFAULT_CHARSET;
    WebLabel15.Font.Color := clWindowText;
    WebLabel15.Font.Height := -24;
    WebLabel15.Font.Name := 'Tahoma';
    WebLabel15.Font.Style := [fsBold];
    WebLabel15.HeightStyle := ssAuto;
    WebLabel15.HeightPercent := 100.00000000000000000;
    WebLabel15.ParentFont := False;
    WebLabel15.WidthPercent := 100.00000000000000000;
    WebLabel16.SetParentComponent(pnMedVersorgung);
    WebLabel16.Name := 'WebLabel16';
    WebLabel16.Left := 32;
    WebLabel16.Top := 159;
    WebLabel16.Width := 429;
    WebLabel16.Height := 29;
    WebLabel16.Caption := 'Investitionskosten Geb'#228'ude (TEUR)';
    WebLabel16.ElementFont := efCSS;
    WebLabel16.ElementPosition := epRelative;
    WebLabel16.Font.Charset := DEFAULT_CHARSET;
    WebLabel16.Font.Color := clWindowText;
    WebLabel16.Font.Height := -24;
    WebLabel16.Font.Name := 'Tahoma';
    WebLabel16.Font.Style := [fsBold];
    WebLabel16.HeightStyle := ssAuto;
    WebLabel16.HeightPercent := 100.00000000000000000;
    WebLabel16.ParentFont := False;
    WebLabel16.WidthPercent := 100.00000000000000000;
    WebLabel17.SetParentComponent(pnMedVersorgung);
    WebLabel17.Name := 'WebLabel17';
    WebLabel17.Left := 32;
    WebLabel17.Top := 204;
    WebLabel17.Width := 516;
    WebLabel17.Height := 29;
    WebLabel17.Caption := 'Instandhaltung / Versicherung p.A. (TEUR)';
    WebLabel17.ElementFont := efCSS;
    WebLabel17.ElementPosition := epRelative;
    WebLabel17.Font.Charset := DEFAULT_CHARSET;
    WebLabel17.Font.Color := clWindowText;
    WebLabel17.Font.Height := -24;
    WebLabel17.Font.Name := 'Tahoma';
    WebLabel17.Font.Style := [fsBold];
    WebLabel17.HeightStyle := ssAuto;
    WebLabel17.HeightPercent := 100.00000000000000000;
    WebLabel17.ParentFont := False;
    WebLabel17.WidthPercent := 100.00000000000000000;
    WebLabel18.SetParentComponent(pnMedVersorgung);
    WebLabel18.Name := 'WebLabel18';
    WebLabel18.Left := 32;
    WebLabel18.Top := 251;
    WebLabel18.Width := 463;
    WebLabel18.Height := 29;
    WebLabel18.Caption := 'Verwaltungskosten (% von Erl'#246's MVZ)';
    WebLabel18.ElementFont := efCSS;
    WebLabel18.ElementPosition := epRelative;
    WebLabel18.Font.Charset := DEFAULT_CHARSET;
    WebLabel18.Font.Color := clWindowText;
    WebLabel18.Font.Height := -24;
    WebLabel18.Font.Name := 'Tahoma';
    WebLabel18.Font.Style := [fsBold];
    WebLabel18.HeightStyle := ssAuto;
    WebLabel18.HeightPercent := 100.00000000000000000;
    WebLabel18.ParentFont := False;
    WebLabel18.WidthPercent := 100.00000000000000000;
    WebLabel19.SetParentComponent(pnMedVersorgung);
    WebLabel19.Name := 'WebLabel19';
    WebLabel19.Left := 32;
    WebLabel19.Top := 295;
    WebLabel19.Width := 604;
    WebLabel19.Height := 29;
    WebLabel19.Caption := 'Lebensmittel / Energie / Wi-Bedarf (% vom Erl'#246's)';
    WebLabel19.ElementFont := efCSS;
    WebLabel19.ElementPosition := epRelative;
    WebLabel19.Font.Charset := DEFAULT_CHARSET;
    WebLabel19.Font.Color := clWindowText;
    WebLabel19.Font.Height := -24;
    WebLabel19.Font.Name := 'Tahoma';
    WebLabel19.Font.Style := [fsBold];
    WebLabel19.HeightStyle := ssAuto;
    WebLabel19.HeightPercent := 100.00000000000000000;
    WebLabel19.ParentFont := False;
    WebLabel19.WordWrap := True;
    WebLabel19.WidthPercent := 100.00000000000000000;
    WebLabel20.SetParentComponent(pnMedVersorgung);
    WebLabel20.Name := 'WebLabel20';
    WebLabel20.Left := 32;
    WebLabel20.Top := 341;
    WebLabel20.Width := 490;
    WebLabel20.Height := 29;
    WebLabel20.Caption := 'Medizinischer Bedarf (% vom Erl'#246's MVZ)';
    WebLabel20.ElementFont := efCSS;
    WebLabel20.ElementPosition := epRelative;
    WebLabel20.Font.Charset := DEFAULT_CHARSET;
    WebLabel20.Font.Color := clWindowText;
    WebLabel20.Font.Height := -24;
    WebLabel20.Font.Name := 'Tahoma';
    WebLabel20.Font.Style := [fsBold];
    WebLabel20.HeightStyle := ssAuto;
    WebLabel20.HeightPercent := 100.00000000000000000;
    WebLabel20.ParentFont := False;
    WebLabel20.WordWrap := True;
    WebLabel20.WidthPercent := 100.00000000000000000;
    lblfirstChirurgieHeadline.SetParentComponent(pnMedVersorgung);
    lblfirstChirurgieHeadline.Name := 'lblfirstChirurgieHeadline';
    lblfirstChirurgieHeadline.Left := 736;
    lblfirstChirurgieHeadline.Top := 67;
    lblfirstChirurgieHeadline.Width := 109;
    lblfirstChirurgieHeadline.Height := 29;
    lblfirstChirurgieHeadline.Caption := 'Chirurgie';
    lblfirstChirurgieHeadline.ElementFont := efCSS;
    lblfirstChirurgieHeadline.ElementPosition := epRelative;
    lblfirstChirurgieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfirstChirurgieHeadline.Font.Color := clWindowText;
    lblfirstChirurgieHeadline.Font.Height := -24;
    lblfirstChirurgieHeadline.Font.Name := 'Tahoma';
    lblfirstChirurgieHeadline.Font.Style := [fsBold];
    lblfirstChirurgieHeadline.HeightStyle := ssAuto;
    lblfirstChirurgieHeadline.HeightPercent := 100.00000000000000000;
    lblfirstChirurgieHeadline.ParentFont := False;
    lblfirstChirurgieHeadline.WordWrap := True;
    lblfirstChirurgieHeadline.WidthPercent := 100.00000000000000000;
    lblfirstOrthopaedieHeadline.SetParentComponent(pnMedVersorgung);
    lblfirstOrthopaedieHeadline.Name := 'lblfirstOrthopaedieHeadline';
    lblfirstOrthopaedieHeadline.Left := 934;
    lblfirstOrthopaedieHeadline.Top := 75;
    lblfirstOrthopaedieHeadline.Width := 133;
    lblfirstOrthopaedieHeadline.Height := 29;
    lblfirstOrthopaedieHeadline.Caption := 'Orthop'#228'die';
    lblfirstOrthopaedieHeadline.ElementFont := efCSS;
    lblfirstOrthopaedieHeadline.ElementPosition := epRelative;
    lblfirstOrthopaedieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfirstOrthopaedieHeadline.Font.Color := clWindowText;
    lblfirstOrthopaedieHeadline.Font.Height := -24;
    lblfirstOrthopaedieHeadline.Font.Name := 'Tahoma';
    lblfirstOrthopaedieHeadline.Font.Style := [fsBold];
    lblfirstOrthopaedieHeadline.HeightStyle := ssAuto;
    lblfirstOrthopaedieHeadline.HeightPercent := 100.00000000000000000;
    lblfirstOrthopaedieHeadline.ParentFont := False;
    lblfirstOrthopaedieHeadline.WordWrap := True;
    lblfirstOrthopaedieHeadline.WidthPercent := 100.00000000000000000;
    lblfirstInnereHeadline.SetParentComponent(pnMedVersorgung);
    lblfirstInnereHeadline.Name := 'lblfirstInnereHeadline';
    lblfirstInnereHeadline.Left := 1128;
    lblfirstInnereHeadline.Top := 75;
    lblfirstInnereHeadline.Width := 80;
    lblfirstInnereHeadline.Height := 29;
    lblfirstInnereHeadline.Caption := 'Innere';
    lblfirstInnereHeadline.ElementFont := efCSS;
    lblfirstInnereHeadline.ElementPosition := epRelative;
    lblfirstInnereHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfirstInnereHeadline.Font.Color := clWindowText;
    lblfirstInnereHeadline.Font.Height := -24;
    lblfirstInnereHeadline.Font.Name := 'Tahoma';
    lblfirstInnereHeadline.Font.Style := [fsBold];
    lblfirstInnereHeadline.HeightStyle := ssAuto;
    lblfirstInnereHeadline.HeightPercent := 100.00000000000000000;
    lblfirstInnereHeadline.ParentFont := False;
    lblfirstInnereHeadline.WordWrap := True;
    lblfirstInnereHeadline.WidthPercent := 100.00000000000000000;
    WebLabel24.SetParentComponent(pnMedVersorgung);
    WebLabel24.Name := 'WebLabel24';
    WebLabel24.Left := 32;
    WebLabel24.Top := 405;
    WebLabel24.Width := 586;
    WebLabel24.Height := 29;
    WebLabel24.Caption := 'Eigene behandelte Personen Normalleistung (%)';
    WebLabel24.ElementFont := efCSS;
    WebLabel24.ElementPosition := epRelative;
    WebLabel24.Font.Charset := DEFAULT_CHARSET;
    WebLabel24.Font.Color := clWindowText;
    WebLabel24.Font.Height := -24;
    WebLabel24.Font.Name := 'Tahoma';
    WebLabel24.Font.Style := [fsBold];
    WebLabel24.HeightStyle := ssAuto;
    WebLabel24.HeightPercent := 100.00000000000000000;
    WebLabel24.ParentFont := False;
    WebLabel24.WidthPercent := 100.00000000000000000;
    WebLabel25.SetParentComponent(pnMedVersorgung);
    WebLabel25.Name := 'WebLabel25';
    WebLabel25.Left := 32;
    WebLabel25.Top := 448;
    WebLabel25.Width := 432;
    WebLabel25.Height := 29;
    WebLabel25.Caption := 'Zusatzerl. MVZ Normal je Tag (EUR)';
    WebLabel25.ElementFont := efCSS;
    WebLabel25.ElementPosition := epRelative;
    WebLabel25.Font.Charset := DEFAULT_CHARSET;
    WebLabel25.Font.Color := clWindowText;
    WebLabel25.Font.Height := -24;
    WebLabel25.Font.Name := 'Tahoma';
    WebLabel25.Font.Style := [fsBold];
    WebLabel25.HeightStyle := ssAuto;
    WebLabel25.HeightPercent := 100.00000000000000000;
    WebLabel25.ParentFont := False;
    WebLabel25.WidthPercent := 100.00000000000000000;
    WebLabel26.SetParentComponent(pnMedVersorgung);
    WebLabel26.Name := 'WebLabel26';
    WebLabel26.Left := 32;
    WebLabel26.Top := 492;
    WebLabel26.Width := 529;
    WebLabel26.Height := 29;
    WebLabel26.Caption := 'Eigene behandelte Personen Wahl 1 / 2 (%)';
    WebLabel26.ElementFont := efCSS;
    WebLabel26.ElementPosition := epRelative;
    WebLabel26.Font.Charset := DEFAULT_CHARSET;
    WebLabel26.Font.Color := clWindowText;
    WebLabel26.Font.Height := -24;
    WebLabel26.Font.Name := 'Tahoma';
    WebLabel26.Font.Style := [fsBold];
    WebLabel26.HeightStyle := ssAuto;
    WebLabel26.HeightPercent := 100.00000000000000000;
    WebLabel26.ParentFont := False;
    WebLabel26.WidthPercent := 100.00000000000000000;
    WebLabel27.SetParentComponent(pnMedVersorgung);
    WebLabel27.Name := 'WebLabel27';
    WebLabel27.Left := 32;
    WebLabel27.Top := 539;
    WebLabel27.Width := 470;
    WebLabel27.Height := 29;
    WebLabel27.Caption := 'Zusatzerl. MVZ Wahl 1 / 2 je Tag (EUR)';
    WebLabel27.ElementFont := efCSS;
    WebLabel27.ElementPosition := epRelative;
    WebLabel27.Font.Charset := DEFAULT_CHARSET;
    WebLabel27.Font.Color := clWindowText;
    WebLabel27.Font.Height := -24;
    WebLabel27.Font.Name := 'Tahoma';
    WebLabel27.Font.Style := [fsBold];
    WebLabel27.HeightStyle := ssAuto;
    WebLabel27.HeightPercent := 100.00000000000000000;
    WebLabel27.ParentFont := False;
    WebLabel27.WidthPercent := 100.00000000000000000;
    WebLabel28.SetParentComponent(pnMedVersorgung);
    WebLabel28.Name := 'WebLabel28';
    WebLabel28.Left := 32;
    WebLabel28.Top := 585;
    WebLabel28.Width := 311;
    WebLabel28.Height := 29;
    WebLabel28.Caption := 'Versorgungstage (Anzahl)';
    WebLabel28.ElementFont := efCSS;
    WebLabel28.ElementPosition := epRelative;
    WebLabel28.Font.Charset := DEFAULT_CHARSET;
    WebLabel28.Font.Color := clWindowText;
    WebLabel28.Font.Height := -24;
    WebLabel28.Font.Name := 'Tahoma';
    WebLabel28.Font.Style := [fsBold];
    WebLabel28.HeightStyle := ssAuto;
    WebLabel28.HeightPercent := 100.00000000000000000;
    WebLabel28.ParentFont := False;
    WebLabel28.WordWrap := True;
    WebLabel28.WidthPercent := 100.00000000000000000;
    WebLabel29.SetParentComponent(pnMedVersorgung);
    WebLabel29.Name := 'WebLabel29';
    WebLabel29.Left := 32;
    WebLabel29.Top := 649;
    WebLabel29.Width := 308;
    WebLabel29.Height := 87;
    WebLabel29.Caption := 'Fremde behandelte Personen Normalleistung (%)';
    WebLabel29.ElementFont := efCSS;
    WebLabel29.ElementPosition := epRelative;
    WebLabel29.Font.Charset := DEFAULT_CHARSET;
    WebLabel29.Font.Color := clWindowText;
    WebLabel29.Font.Height := -24;
    WebLabel29.Font.Name := 'Tahoma';
    WebLabel29.Font.Style := [fsBold];
    WebLabel29.HeightStyle := ssAuto;
    WebLabel29.HeightPercent := 100.00000000000000000;
    WebLabel29.ParentFont := False;
    WebLabel29.WordWrap := True;
    WebLabel29.WidthPercent := 100.00000000000000000;
    WebLabel30.SetParentComponent(pnMedVersorgung);
    WebLabel30.Name := 'WebLabel30';
    WebLabel30.Left := 32;
    WebLabel30.Top := 692;
    WebLabel30.Width := 432;
    WebLabel30.Height := 29;
    WebLabel30.Caption := 'Zusatzerl. MVZ Normal je Tag (EUR)';
    WebLabel30.ElementFont := efCSS;
    WebLabel30.ElementPosition := epRelative;
    WebLabel30.Font.Charset := DEFAULT_CHARSET;
    WebLabel30.Font.Color := clWindowText;
    WebLabel30.Font.Height := -24;
    WebLabel30.Font.Name := 'Tahoma';
    WebLabel30.Font.Style := [fsBold];
    WebLabel30.HeightStyle := ssAuto;
    WebLabel30.HeightPercent := 100.00000000000000000;
    WebLabel30.ParentFont := False;
    WebLabel30.WidthPercent := 100.00000000000000000;
    WebLabel31.SetParentComponent(pnMedVersorgung);
    WebLabel31.Name := 'WebLabel31';
    WebLabel31.Left := 32;
    WebLabel31.Top := 737;
    WebLabel31.Width := 539;
    WebLabel31.Height := 29;
    WebLabel31.Caption := 'Fremde behandelte Personen Wahl 1 / 2 (%)';
    WebLabel31.ElementFont := efCSS;
    WebLabel31.ElementPosition := epRelative;
    WebLabel31.Font.Charset := DEFAULT_CHARSET;
    WebLabel31.Font.Color := clWindowText;
    WebLabel31.Font.Height := -24;
    WebLabel31.Font.Name := 'Tahoma';
    WebLabel31.Font.Style := [fsBold];
    WebLabel31.HeightStyle := ssAuto;
    WebLabel31.HeightPercent := 100.00000000000000000;
    WebLabel31.ParentFont := False;
    WebLabel31.WidthPercent := 100.00000000000000000;
    WebLabel32.SetParentComponent(pnMedVersorgung);
    WebLabel32.Name := 'WebLabel32';
    WebLabel32.Left := 32;
    WebLabel32.Top := 784;
    WebLabel32.Width := 405;
    WebLabel32.Height := 29;
    WebLabel32.Caption := 'Zusatzerl. MVZ Wahl je Tag (EUR)';
    WebLabel32.ElementFont := efCSS;
    WebLabel32.ElementPosition := epRelative;
    WebLabel32.Font.Charset := DEFAULT_CHARSET;
    WebLabel32.Font.Color := clWindowText;
    WebLabel32.Font.Height := -24;
    WebLabel32.Font.Name := 'Tahoma';
    WebLabel32.Font.Style := [fsBold];
    WebLabel32.HeightStyle := ssAuto;
    WebLabel32.HeightPercent := 100.00000000000000000;
    WebLabel32.ParentFont := False;
    WebLabel32.WidthPercent := 100.00000000000000000;
    WebLabel33.SetParentComponent(pnMedVersorgung);
    WebLabel33.Name := 'WebLabel33';
    WebLabel33.Left := 32;
    WebLabel33.Top := 829;
    WebLabel33.Width := 311;
    WebLabel33.Height := 29;
    WebLabel33.Caption := 'Versorgungstage (Anzahl)';
    WebLabel33.ElementFont := efCSS;
    WebLabel33.Font.Charset := DEFAULT_CHARSET;
    WebLabel33.Font.Color := clWindowText;
    WebLabel33.Font.Height := -24;
    WebLabel33.Font.Name := 'Tahoma';
    WebLabel33.Font.Style := [fsBold];
    WebLabel33.HeightStyle := ssAuto;
    WebLabel33.HeightPercent := 100.00000000000000000;
    WebLabel33.ParentFont := False;
    WebLabel33.WordWrap := True;
    WebLabel33.WidthPercent := 100.00000000000000000;
    WebLabel34.SetParentComponent(pnMedVersorgung);
    WebLabel34.Name := 'WebLabel34';
    WebLabel34.Left := 32;
    WebLabel34.Top := 889;
    WebLabel34.Width := 229;
    WebLabel34.Height := 29;
    WebLabel34.Caption := 'Arztminuten je Tag';
    WebLabel34.ElementFont := efCSS;
    WebLabel34.ElementPosition := epRelative;
    WebLabel34.Font.Charset := DEFAULT_CHARSET;
    WebLabel34.Font.Color := clWindowText;
    WebLabel34.Font.Height := -24;
    WebLabel34.Font.Name := 'Tahoma';
    WebLabel34.Font.Style := [fsBold];
    WebLabel34.HeightStyle := ssAuto;
    WebLabel34.HeightPercent := 100.00000000000000000;
    WebLabel34.ParentFont := False;
    WebLabel34.WordWrap := True;
    WebLabel34.WidthPercent := 100.00000000000000000;
    WebLabel8.SetParentComponent(pnMedVersorgung);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 96;
    WebLabel8.Top := 32;
    WebLabel8.Width := 97;
    WebLabel8.Height := 18;
    WebLabel8.Caption := 'Anschaffungen';
    WebLabel8.ElementFont := efCSS;
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.00000000000000000;
    WebLabel8.HTMLType := tH3;
    WebLabel8.WidthPercent := 100.00000000000000000;
    WebLabel9.SetParentComponent(pnMedVersorgung);
    WebLabel9.Name := 'WebLabel9';
    WebLabel9.Left := 216;
    WebLabel9.Top := 32;
    WebLabel9.Width := 107;
    WebLabel9.Height := 18;
    WebLabel9.Caption := 'Eigene Personen';
    WebLabel9.ElementFont := efCSS;
    WebLabel9.HeightStyle := ssAuto;
    WebLabel9.HeightPercent := 100.00000000000000000;
    WebLabel9.HTMLType := tH3;
    WebLabel9.WidthPercent := 100.00000000000000000;
    WebLabel10.SetParentComponent(pnMedVersorgung);
    WebLabel10.Name := 'WebLabel10';
    WebLabel10.Left := 354;
    WebLabel10.Top := 32;
    WebLabel10.Width := 115;
    WebLabel10.Height := 18;
    WebLabel10.Caption := 'Fremde Personen';
    WebLabel10.ElementFont := efCSS;
    WebLabel10.HeightStyle := ssAuto;
    WebLabel10.HeightPercent := 100.00000000000000000;
    WebLabel10.HTMLType := tH3;
    WebLabel10.WidthPercent := 100.00000000000000000;
    WebLabel11.SetParentComponent(pnMedVersorgung);
    WebLabel11.Name := 'WebLabel11';
    WebLabel11.Left := 478;
    WebLabel11.Top := 32;
    WebLabel11.Width := 78;
    WebLabel11.Height := 18;
    WebLabel11.Caption := 'Arztminuten';
    WebLabel11.ElementFont := efCSS;
    WebLabel11.HeightStyle := ssAuto;
    WebLabel11.HeightPercent := 100.00000000000000000;
    WebLabel11.HTMLType := tH3;
    WebLabel11.WidthPercent := 100.00000000000000000;
    lblsecondChirurgieHeadline.SetParentComponent(pnMedVersorgung);
    lblsecondChirurgieHeadline.Name := 'lblsecondChirurgieHeadline';
    lblsecondChirurgieHeadline.Left := 736;
    lblsecondChirurgieHeadline.Top := 34;
    lblsecondChirurgieHeadline.Width := 109;
    lblsecondChirurgieHeadline.Height := 29;
    lblsecondChirurgieHeadline.Caption := 'Chirurgie';
    lblsecondChirurgieHeadline.ElementFont := efCSS;
    lblsecondChirurgieHeadline.ElementPosition := epRelative;
    lblsecondChirurgieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblsecondChirurgieHeadline.Font.Color := clWindowText;
    lblsecondChirurgieHeadline.Font.Height := -24;
    lblsecondChirurgieHeadline.Font.Name := 'Tahoma';
    lblsecondChirurgieHeadline.Font.Style := [fsBold];
    lblsecondChirurgieHeadline.HeightStyle := ssAuto;
    lblsecondChirurgieHeadline.HeightPercent := 100.00000000000000000;
    lblsecondChirurgieHeadline.ParentFont := False;
    lblsecondChirurgieHeadline.WordWrap := True;
    lblsecondChirurgieHeadline.WidthPercent := 100.00000000000000000;
    LblthirdChirurgieHeadline.SetParentComponent(pnMedVersorgung);
    LblthirdChirurgieHeadline.Name := 'LblthirdChirurgieHeadline';
    LblthirdChirurgieHeadline.Left := 736;
    LblthirdChirurgieHeadline.Top := 3;
    LblthirdChirurgieHeadline.Width := 109;
    LblthirdChirurgieHeadline.Height := 29;
    LblthirdChirurgieHeadline.Caption := 'Chirurgie';
    LblthirdChirurgieHeadline.ElementFont := efCSS;
    LblthirdChirurgieHeadline.ElementPosition := epRelative;
    LblthirdChirurgieHeadline.Font.Charset := DEFAULT_CHARSET;
    LblthirdChirurgieHeadline.Font.Color := clWindowText;
    LblthirdChirurgieHeadline.Font.Height := -24;
    LblthirdChirurgieHeadline.Font.Name := 'Tahoma';
    LblthirdChirurgieHeadline.Font.Style := [fsBold];
    LblthirdChirurgieHeadline.HeightStyle := ssAuto;
    LblthirdChirurgieHeadline.HeightPercent := 100.00000000000000000;
    LblthirdChirurgieHeadline.ParentFont := False;
    LblthirdChirurgieHeadline.WordWrap := True;
    LblthirdChirurgieHeadline.WidthPercent := 100.00000000000000000;
    lblfourthChirurgieHeadline.SetParentComponent(pnMedVersorgung);
    lblfourthChirurgieHeadline.Name := 'lblfourthChirurgieHeadline';
    lblfourthChirurgieHeadline.Left := 736;
    lblfourthChirurgieHeadline.Top := 87;
    lblfourthChirurgieHeadline.Width := 109;
    lblfourthChirurgieHeadline.Height := 29;
    lblfourthChirurgieHeadline.Caption := 'Chirurgie';
    lblfourthChirurgieHeadline.ElementFont := efCSS;
    lblfourthChirurgieHeadline.ElementPosition := epRelative;
    lblfourthChirurgieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfourthChirurgieHeadline.Font.Color := clWindowText;
    lblfourthChirurgieHeadline.Font.Height := -24;
    lblfourthChirurgieHeadline.Font.Name := 'Tahoma';
    lblfourthChirurgieHeadline.Font.Style := [fsBold];
    lblfourthChirurgieHeadline.HeightStyle := ssAuto;
    lblfourthChirurgieHeadline.HeightPercent := 100.00000000000000000;
    lblfourthChirurgieHeadline.ParentFont := False;
    lblfourthChirurgieHeadline.WordWrap := True;
    lblfourthChirurgieHeadline.WidthPercent := 100.00000000000000000;
    lblfourthOrthopaedieHeadline.SetParentComponent(pnMedVersorgung);
    lblfourthOrthopaedieHeadline.Name := 'lblfourthOrthopaedieHeadline';
    lblfourthOrthopaedieHeadline.Left := 936;
    lblfourthOrthopaedieHeadline.Top := 52;
    lblfourthOrthopaedieHeadline.Width := 133;
    lblfourthOrthopaedieHeadline.Height := 29;
    lblfourthOrthopaedieHeadline.Caption := 'Orthop'#228'die';
    lblfourthOrthopaedieHeadline.ElementFont := efCSS;
    lblfourthOrthopaedieHeadline.ElementPosition := epRelative;
    lblfourthOrthopaedieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfourthOrthopaedieHeadline.Font.Color := clWindowText;
    lblfourthOrthopaedieHeadline.Font.Height := -24;
    lblfourthOrthopaedieHeadline.Font.Name := 'Tahoma';
    lblfourthOrthopaedieHeadline.Font.Style := [fsBold];
    lblfourthOrthopaedieHeadline.HeightStyle := ssAuto;
    lblfourthOrthopaedieHeadline.HeightPercent := 100.00000000000000000;
    lblfourthOrthopaedieHeadline.ParentFont := False;
    lblfourthOrthopaedieHeadline.WordWrap := True;
    lblfourthOrthopaedieHeadline.WidthPercent := 100.00000000000000000;
    LblthirdOrthopaedieHeadline.SetParentComponent(pnMedVersorgung);
    LblthirdOrthopaedieHeadline.Name := 'LblthirdOrthopaedieHeadline';
    LblthirdOrthopaedieHeadline.Left := 934;
    LblthirdOrthopaedieHeadline.Top := 32;
    LblthirdOrthopaedieHeadline.Width := 133;
    LblthirdOrthopaedieHeadline.Height := 29;
    LblthirdOrthopaedieHeadline.Caption := 'Orthop'#228'die';
    LblthirdOrthopaedieHeadline.ElementFont := efCSS;
    LblthirdOrthopaedieHeadline.ElementPosition := epRelative;
    LblthirdOrthopaedieHeadline.Font.Charset := DEFAULT_CHARSET;
    LblthirdOrthopaedieHeadline.Font.Color := clWindowText;
    LblthirdOrthopaedieHeadline.Font.Height := -24;
    LblthirdOrthopaedieHeadline.Font.Name := 'Tahoma';
    LblthirdOrthopaedieHeadline.Font.Style := [fsBold];
    LblthirdOrthopaedieHeadline.HeightStyle := ssAuto;
    LblthirdOrthopaedieHeadline.HeightPercent := 100.00000000000000000;
    LblthirdOrthopaedieHeadline.ParentFont := False;
    LblthirdOrthopaedieHeadline.WordWrap := True;
    LblthirdOrthopaedieHeadline.WidthPercent := 100.00000000000000000;
    lblsecondOrthopaedieHeadline.SetParentComponent(pnMedVersorgung);
    lblsecondOrthopaedieHeadline.Name := 'lblsecondOrthopaedieHeadline';
    lblsecondOrthopaedieHeadline.Left := 934;
    lblsecondOrthopaedieHeadline.Top := 4;
    lblsecondOrthopaedieHeadline.Width := 133;
    lblsecondOrthopaedieHeadline.Height := 29;
    lblsecondOrthopaedieHeadline.Caption := 'Orthop'#228'die';
    lblsecondOrthopaedieHeadline.ElementFont := efCSS;
    lblsecondOrthopaedieHeadline.ElementPosition := epRelative;
    lblsecondOrthopaedieHeadline.Font.Charset := DEFAULT_CHARSET;
    lblsecondOrthopaedieHeadline.Font.Color := clWindowText;
    lblsecondOrthopaedieHeadline.Font.Height := -24;
    lblsecondOrthopaedieHeadline.Font.Name := 'Tahoma';
    lblsecondOrthopaedieHeadline.Font.Style := [fsBold];
    lblsecondOrthopaedieHeadline.HeightStyle := ssAuto;
    lblsecondOrthopaedieHeadline.HeightPercent := 100.00000000000000000;
    lblsecondOrthopaedieHeadline.ParentFont := False;
    lblsecondOrthopaedieHeadline.WordWrap := True;
    lblsecondOrthopaedieHeadline.WidthPercent := 100.00000000000000000;
    lblfourthInnereHeadline.SetParentComponent(pnMedVersorgung);
    lblfourthInnereHeadline.Name := 'lblfourthInnereHeadline';
    lblfourthInnereHeadline.Left := 1128;
    lblfourthInnereHeadline.Top := 52;
    lblfourthInnereHeadline.Width := 80;
    lblfourthInnereHeadline.Height := 29;
    lblfourthInnereHeadline.Caption := 'Innere';
    lblfourthInnereHeadline.ElementFont := efCSS;
    lblfourthInnereHeadline.ElementPosition := epRelative;
    lblfourthInnereHeadline.Font.Charset := DEFAULT_CHARSET;
    lblfourthInnereHeadline.Font.Color := clWindowText;
    lblfourthInnereHeadline.Font.Height := -24;
    lblfourthInnereHeadline.Font.Name := 'Tahoma';
    lblfourthInnereHeadline.Font.Style := [fsBold];
    lblfourthInnereHeadline.HeightStyle := ssAuto;
    lblfourthInnereHeadline.HeightPercent := 100.00000000000000000;
    lblfourthInnereHeadline.ParentFont := False;
    lblfourthInnereHeadline.WordWrap := True;
    lblfourthInnereHeadline.WidthPercent := 100.00000000000000000;
    lblthirdInnereHeadline.SetParentComponent(pnMedVersorgung);
    lblthirdInnereHeadline.Name := 'lblthirdInnereHeadline';
    lblthirdInnereHeadline.Left := 1128;
    lblthirdInnereHeadline.Top := 23;
    lblthirdInnereHeadline.Width := 80;
    lblthirdInnereHeadline.Height := 29;
    lblthirdInnereHeadline.Caption := 'Innere';
    lblthirdInnereHeadline.ElementFont := efCSS;
    lblthirdInnereHeadline.ElementPosition := epRelative;
    lblthirdInnereHeadline.Font.Charset := DEFAULT_CHARSET;
    lblthirdInnereHeadline.Font.Color := clWindowText;
    lblthirdInnereHeadline.Font.Height := -24;
    lblthirdInnereHeadline.Font.Name := 'Tahoma';
    lblthirdInnereHeadline.Font.Style := [fsBold];
    lblthirdInnereHeadline.HeightStyle := ssAuto;
    lblthirdInnereHeadline.HeightPercent := 100.00000000000000000;
    lblthirdInnereHeadline.ParentFont := False;
    lblthirdInnereHeadline.WordWrap := True;
    lblthirdInnereHeadline.WidthPercent := 100.00000000000000000;
    lblsecondInnereHeadline.SetParentComponent(pnMedVersorgung);
    lblsecondInnereHeadline.Name := 'lblsecondInnereHeadline';
    lblsecondInnereHeadline.Left := 1128;
    lblsecondInnereHeadline.Top := 4;
    lblsecondInnereHeadline.Width := 80;
    lblsecondInnereHeadline.Height := 29;
    lblsecondInnereHeadline.Caption := 'Innere';
    lblsecondInnereHeadline.ElementFont := efCSS;
    lblsecondInnereHeadline.ElementPosition := epRelative;
    lblsecondInnereHeadline.Font.Charset := DEFAULT_CHARSET;
    lblsecondInnereHeadline.Font.Color := clWindowText;
    lblsecondInnereHeadline.Font.Height := -24;
    lblsecondInnereHeadline.Font.Name := 'Tahoma';
    lblsecondInnereHeadline.Font.Style := [fsBold];
    lblsecondInnereHeadline.HeightStyle := ssAuto;
    lblsecondInnereHeadline.HeightPercent := 100.00000000000000000;
    lblsecondInnereHeadline.ParentFont := False;
    lblsecondInnereHeadline.WordWrap := True;
    lblsecondInnereHeadline.WidthPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_AnschaffKoA1.Name := 'RFE_MVZ_AnschaffKoA1';
    RFE_MVZ_AnschaffKoA1.Left := 736;
    RFE_MVZ_AnschaffKoA1.Top := 104;
    RFE_MVZ_AnschaffKoA1.Width := 150;
    RFE_MVZ_AnschaffKoA1.Height := 46;
    RFE_MVZ_AnschaffKoA1.ChildOrder := 20;
    RFE_MVZ_AnschaffKoA1.ElementFont := efCSS;
    RFE_MVZ_AnschaffKoA1.ElementPosition := epRelative;
    RFE_MVZ_AnschaffKoA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_AnschaffKoA1.Font.Color := clWindowText;
    RFE_MVZ_AnschaffKoA1.Font.Height := -24;
    RFE_MVZ_AnschaffKoA1.Font.Name := 'Segoe UI';
    RFE_MVZ_AnschaffKoA1.Font.Style := [fsBold];
    RFE_MVZ_AnschaffKoA1.HeightStyle := ssAuto;
    RFE_MVZ_AnschaffKoA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA1.ParentFont := False;
    RFE_MVZ_AnschaffKoA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA1.DataField := 'Upmv_Purchase_Devices';
    RFE_MVZ_AnschaffKoA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_InvestiKoA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InvestiKoA1.Name := 'RFE_MVZ_InvestiKoA1';
    RFE_MVZ_InvestiKoA1.Left := 736;
    RFE_MVZ_InvestiKoA1.Top := 156;
    RFE_MVZ_InvestiKoA1.Width := 150;
    RFE_MVZ_InvestiKoA1.Height := 46;
    RFE_MVZ_InvestiKoA1.ChildOrder := 21;
    RFE_MVZ_InvestiKoA1.ElementFont := efCSS;
    RFE_MVZ_InvestiKoA1.ElementPosition := epRelative;
    RFE_MVZ_InvestiKoA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InvestiKoA1.Font.Color := clWindowText;
    RFE_MVZ_InvestiKoA1.Font.Height := -24;
    RFE_MVZ_InvestiKoA1.Font.Name := 'Segoe UI';
    RFE_MVZ_InvestiKoA1.Font.Style := [fsBold];
    RFE_MVZ_InvestiKoA1.HeightStyle := ssAuto;
    RFE_MVZ_InvestiKoA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA1.ParentFont := False;
    RFE_MVZ_InvestiKoA1.TabOrder := 1;
    RFE_MVZ_InvestiKoA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA1.DataField := 'Upmv_Investment_Buildings';
    RFE_MVZ_InvestiKoA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_InstHaltKoA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InstHaltKoA1.Name := 'RFE_MVZ_InstHaltKoA1';
    RFE_MVZ_InstHaltKoA1.Left := 736;
    RFE_MVZ_InstHaltKoA1.Top := 201;
    RFE_MVZ_InstHaltKoA1.Width := 150;
    RFE_MVZ_InstHaltKoA1.Height := 46;
    RFE_MVZ_InstHaltKoA1.ChildOrder := 22;
    RFE_MVZ_InstHaltKoA1.ElementFont := efCSS;
    RFE_MVZ_InstHaltKoA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InstHaltKoA1.Font.Color := clWindowText;
    RFE_MVZ_InstHaltKoA1.Font.Height := -24;
    RFE_MVZ_InstHaltKoA1.Font.Name := 'Segoe UI';
    RFE_MVZ_InstHaltKoA1.Font.Style := [fsBold];
    RFE_MVZ_InstHaltKoA1.HeightStyle := ssAuto;
    RFE_MVZ_InstHaltKoA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA1.ParentFont := False;
    RFE_MVZ_InstHaltKoA1.TabOrder := 2;
    RFE_MVZ_InstHaltKoA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA1.DataField := 'Upmv_Administrative_Cost';
    RFE_MVZ_InstHaltKoA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_ZusVerwKoA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusVerwKoA1.Name := 'RFE_MVZ_ZusVerwKoA1';
    RFE_MVZ_ZusVerwKoA1.Left := 736;
    RFE_MVZ_ZusVerwKoA1.Top := 246;
    RFE_MVZ_ZusVerwKoA1.Width := 150;
    RFE_MVZ_ZusVerwKoA1.Height := 46;
    RFE_MVZ_ZusVerwKoA1.ChildOrder := 23;
    RFE_MVZ_ZusVerwKoA1.ElementFont := efCSS;
    RFE_MVZ_ZusVerwKoA1.ElementPosition := epRelative;
    RFE_MVZ_ZusVerwKoA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusVerwKoA1.Font.Color := clWindowText;
    RFE_MVZ_ZusVerwKoA1.Font.Height := -24;
    RFE_MVZ_ZusVerwKoA1.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusVerwKoA1.Font.Style := [fsBold];
    RFE_MVZ_ZusVerwKoA1.HeightStyle := ssAuto;
    RFE_MVZ_ZusVerwKoA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA1.ParentFont := False;
    RFE_MVZ_ZusVerwKoA1.TabOrder := 3;
    RFE_MVZ_ZusVerwKoA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA1.DataField := 'Upmv_Maintenance';
    RFE_MVZ_ZusVerwKoA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_ZusLebensmA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusLebensmA1.Name := 'RFE_MVZ_ZusLebensmA1';
    RFE_MVZ_ZusLebensmA1.Left := 736;
    RFE_MVZ_ZusLebensmA1.Top := 291;
    RFE_MVZ_ZusLebensmA1.Width := 150;
    RFE_MVZ_ZusLebensmA1.Height := 46;
    RFE_MVZ_ZusLebensmA1.ChildOrder := 24;
    RFE_MVZ_ZusLebensmA1.ElementFont := efCSS;
    RFE_MVZ_ZusLebensmA1.ElementPosition := epRelative;
    RFE_MVZ_ZusLebensmA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusLebensmA1.Font.Color := clWindowText;
    RFE_MVZ_ZusLebensmA1.Font.Height := -24;
    RFE_MVZ_ZusLebensmA1.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusLebensmA1.Font.Style := [fsBold];
    RFE_MVZ_ZusLebensmA1.HeightStyle := ssAuto;
    RFE_MVZ_ZusLebensmA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA1.ParentFont := False;
    RFE_MVZ_ZusLebensmA1.TabOrder := 4;
    RFE_MVZ_ZusLebensmA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA1.DataField := 'Upmv_Food';
    RFE_MVZ_ZusLebensmA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_ZusMedTechnA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusMedTechnA1.Name := 'RFE_MVZ_ZusMedTechnA1';
    RFE_MVZ_ZusMedTechnA1.Left := 736;
    RFE_MVZ_ZusMedTechnA1.Top := 336;
    RFE_MVZ_ZusMedTechnA1.Width := 150;
    RFE_MVZ_ZusMedTechnA1.Height := 46;
    RFE_MVZ_ZusMedTechnA1.ChildOrder := 25;
    RFE_MVZ_ZusMedTechnA1.ElementFont := efCSS;
    RFE_MVZ_ZusMedTechnA1.ElementPosition := epRelative;
    RFE_MVZ_ZusMedTechnA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusMedTechnA1.Font.Color := clWindowText;
    RFE_MVZ_ZusMedTechnA1.Font.Height := -24;
    RFE_MVZ_ZusMedTechnA1.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusMedTechnA1.Font.Style := [fsBold];
    RFE_MVZ_ZusMedTechnA1.HeightStyle := ssAuto;
    RFE_MVZ_ZusMedTechnA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA1.ParentFont := False;
    RFE_MVZ_ZusMedTechnA1.TabOrder := 5;
    RFE_MVZ_ZusMedTechnA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA1.DataField := 'Upmv_Medical_Need';
    RFE_MVZ_ZusMedTechnA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_AnschaffKoA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_AnschaffKoA2.Name := 'RFE_MVZ_AnschaffKoA2';
    RFE_MVZ_AnschaffKoA2.Left := 936;
    RFE_MVZ_AnschaffKoA2.Top := 110;
    RFE_MVZ_AnschaffKoA2.Width := 150;
    RFE_MVZ_AnschaffKoA2.Height := 46;
    RFE_MVZ_AnschaffKoA2.ChildOrder := 26;
    RFE_MVZ_AnschaffKoA2.ElementFont := efCSS;
    RFE_MVZ_AnschaffKoA2.ElementPosition := epRelative;
    RFE_MVZ_AnschaffKoA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_AnschaffKoA2.Font.Color := clWindowText;
    RFE_MVZ_AnschaffKoA2.Font.Height := -24;
    RFE_MVZ_AnschaffKoA2.Font.Name := 'Segoe UI';
    RFE_MVZ_AnschaffKoA2.Font.Style := [fsBold];
    RFE_MVZ_AnschaffKoA2.HeightStyle := ssAuto;
    RFE_MVZ_AnschaffKoA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA2.ParentFont := False;
    RFE_MVZ_AnschaffKoA2.TabOrder := 6;
    RFE_MVZ_AnschaffKoA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA2.DataField := 'Upmv_Purchase_Devices';
    RFE_MVZ_AnschaffKoA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_InvestiKoA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InvestiKoA2.Name := 'RFE_MVZ_InvestiKoA2';
    RFE_MVZ_InvestiKoA2.Left := 936;
    RFE_MVZ_InvestiKoA2.Top := 156;
    RFE_MVZ_InvestiKoA2.Width := 150;
    RFE_MVZ_InvestiKoA2.Height := 46;
    RFE_MVZ_InvestiKoA2.ChildOrder := 27;
    RFE_MVZ_InvestiKoA2.ElementFont := efCSS;
    RFE_MVZ_InvestiKoA2.ElementPosition := epRelative;
    RFE_MVZ_InvestiKoA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InvestiKoA2.Font.Color := clWindowText;
    RFE_MVZ_InvestiKoA2.Font.Height := -24;
    RFE_MVZ_InvestiKoA2.Font.Name := 'Segoe UI';
    RFE_MVZ_InvestiKoA2.Font.Style := [fsBold];
    RFE_MVZ_InvestiKoA2.HeightStyle := ssAuto;
    RFE_MVZ_InvestiKoA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA2.ParentFont := False;
    RFE_MVZ_InvestiKoA2.TabOrder := 7;
    RFE_MVZ_InvestiKoA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA2.DataField := 'Upmv_Investment_Buildings';
    RFE_MVZ_InvestiKoA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_InstHaltKoA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InstHaltKoA2.Name := 'RFE_MVZ_InstHaltKoA2';
    RFE_MVZ_InstHaltKoA2.Left := 936;
    RFE_MVZ_InstHaltKoA2.Top := 201;
    RFE_MVZ_InstHaltKoA2.Width := 150;
    RFE_MVZ_InstHaltKoA2.Height := 46;
    RFE_MVZ_InstHaltKoA2.ChildOrder := 28;
    RFE_MVZ_InstHaltKoA2.ElementFont := efCSS;
    RFE_MVZ_InstHaltKoA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InstHaltKoA2.Font.Color := clWindowText;
    RFE_MVZ_InstHaltKoA2.Font.Height := -24;
    RFE_MVZ_InstHaltKoA2.Font.Name := 'Segoe UI';
    RFE_MVZ_InstHaltKoA2.Font.Style := [fsBold];
    RFE_MVZ_InstHaltKoA2.HeightStyle := ssAuto;
    RFE_MVZ_InstHaltKoA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA2.ParentFont := False;
    RFE_MVZ_InstHaltKoA2.TabOrder := 8;
    RFE_MVZ_InstHaltKoA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA2.DataField := 'Upmv_Administrative_Cost';
    RFE_MVZ_InstHaltKoA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_ZusVerwKoA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusVerwKoA2.Name := 'RFE_MVZ_ZusVerwKoA2';
    RFE_MVZ_ZusVerwKoA2.Left := 936;
    RFE_MVZ_ZusVerwKoA2.Top := 246;
    RFE_MVZ_ZusVerwKoA2.Width := 150;
    RFE_MVZ_ZusVerwKoA2.Height := 46;
    RFE_MVZ_ZusVerwKoA2.ChildOrder := 29;
    RFE_MVZ_ZusVerwKoA2.ElementFont := efCSS;
    RFE_MVZ_ZusVerwKoA2.ElementPosition := epRelative;
    RFE_MVZ_ZusVerwKoA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusVerwKoA2.Font.Color := clWindowText;
    RFE_MVZ_ZusVerwKoA2.Font.Height := -24;
    RFE_MVZ_ZusVerwKoA2.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusVerwKoA2.Font.Style := [fsBold];
    RFE_MVZ_ZusVerwKoA2.HeightStyle := ssAuto;
    RFE_MVZ_ZusVerwKoA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA2.ParentFont := False;
    RFE_MVZ_ZusVerwKoA2.TabOrder := 9;
    RFE_MVZ_ZusVerwKoA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA2.DataField := 'Upmv_Maintenance';
    RFE_MVZ_ZusVerwKoA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_ZusLebensmA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusLebensmA2.Name := 'RFE_MVZ_ZusLebensmA2';
    RFE_MVZ_ZusLebensmA2.Left := 936;
    RFE_MVZ_ZusLebensmA2.Top := 291;
    RFE_MVZ_ZusLebensmA2.Width := 150;
    RFE_MVZ_ZusLebensmA2.Height := 46;
    RFE_MVZ_ZusLebensmA2.ChildOrder := 30;
    RFE_MVZ_ZusLebensmA2.ElementFont := efCSS;
    RFE_MVZ_ZusLebensmA2.ElementPosition := epRelative;
    RFE_MVZ_ZusLebensmA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusLebensmA2.Font.Color := clWindowText;
    RFE_MVZ_ZusLebensmA2.Font.Height := -24;
    RFE_MVZ_ZusLebensmA2.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusLebensmA2.Font.Style := [fsBold];
    RFE_MVZ_ZusLebensmA2.HeightStyle := ssAuto;
    RFE_MVZ_ZusLebensmA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA2.ParentFont := False;
    RFE_MVZ_ZusLebensmA2.TabOrder := 10;
    RFE_MVZ_ZusLebensmA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA2.DataField := 'Upmv_Food';
    RFE_MVZ_ZusLebensmA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_ZusMedTechnA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusMedTechnA2.Name := 'RFE_MVZ_ZusMedTechnA2';
    RFE_MVZ_ZusMedTechnA2.Left := 936;
    RFE_MVZ_ZusMedTechnA2.Top := 336;
    RFE_MVZ_ZusMedTechnA2.Width := 150;
    RFE_MVZ_ZusMedTechnA2.Height := 46;
    RFE_MVZ_ZusMedTechnA2.ChildOrder := 31;
    RFE_MVZ_ZusMedTechnA2.ElementFont := efCSS;
    RFE_MVZ_ZusMedTechnA2.ElementPosition := epRelative;
    RFE_MVZ_ZusMedTechnA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusMedTechnA2.Font.Color := clWindowText;
    RFE_MVZ_ZusMedTechnA2.Font.Height := -24;
    RFE_MVZ_ZusMedTechnA2.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusMedTechnA2.Font.Style := [fsBold];
    RFE_MVZ_ZusMedTechnA2.HeightStyle := ssAuto;
    RFE_MVZ_ZusMedTechnA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA2.ParentFont := False;
    RFE_MVZ_ZusMedTechnA2.TabOrder := 11;
    RFE_MVZ_ZusMedTechnA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA2.DataField := 'Upmv_Medical_Need';
    RFE_MVZ_ZusMedTechnA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_AnschaffKoA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_AnschaffKoA3.Name := 'RFE_MVZ_AnschaffKoA3';
    RFE_MVZ_AnschaffKoA3.Left := 1128;
    RFE_MVZ_AnschaffKoA3.Top := 110;
    RFE_MVZ_AnschaffKoA3.Width := 150;
    RFE_MVZ_AnschaffKoA3.Height := 46;
    RFE_MVZ_AnschaffKoA3.ChildOrder := 32;
    RFE_MVZ_AnschaffKoA3.ElementFont := efCSS;
    RFE_MVZ_AnschaffKoA3.ElementPosition := epRelative;
    RFE_MVZ_AnschaffKoA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_AnschaffKoA3.Font.Color := clWindowText;
    RFE_MVZ_AnschaffKoA3.Font.Height := -24;
    RFE_MVZ_AnschaffKoA3.Font.Name := 'Segoe UI';
    RFE_MVZ_AnschaffKoA3.Font.Style := [fsBold];
    RFE_MVZ_AnschaffKoA3.HeightStyle := ssAuto;
    RFE_MVZ_AnschaffKoA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA3.ParentFont := False;
    RFE_MVZ_AnschaffKoA3.TabOrder := 12;
    RFE_MVZ_AnschaffKoA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_AnschaffKoA3.DataField := 'Upmv_Purchase_Devices';
    RFE_MVZ_AnschaffKoA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_InvestiKoA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InvestiKoA3.Name := 'RFE_MVZ_InvestiKoA3';
    RFE_MVZ_InvestiKoA3.Left := 1128;
    RFE_MVZ_InvestiKoA3.Top := 156;
    RFE_MVZ_InvestiKoA3.Width := 150;
    RFE_MVZ_InvestiKoA3.Height := 46;
    RFE_MVZ_InvestiKoA3.ChildOrder := 33;
    RFE_MVZ_InvestiKoA3.ElementFont := efCSS;
    RFE_MVZ_InvestiKoA3.ElementPosition := epRelative;
    RFE_MVZ_InvestiKoA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InvestiKoA3.Font.Color := clWindowText;
    RFE_MVZ_InvestiKoA3.Font.Height := -24;
    RFE_MVZ_InvestiKoA3.Font.Name := 'Segoe UI';
    RFE_MVZ_InvestiKoA3.Font.Style := [fsBold];
    RFE_MVZ_InvestiKoA3.HeightStyle := ssAuto;
    RFE_MVZ_InvestiKoA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA3.ParentFont := False;
    RFE_MVZ_InvestiKoA3.TabOrder := 13;
    RFE_MVZ_InvestiKoA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InvestiKoA3.DataField := 'Upmv_Investment_Buildings';
    RFE_MVZ_InvestiKoA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_InstHaltKoA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_InstHaltKoA3.Name := 'RFE_MVZ_InstHaltKoA3';
    RFE_MVZ_InstHaltKoA3.Left := 1128;
    RFE_MVZ_InstHaltKoA3.Top := 201;
    RFE_MVZ_InstHaltKoA3.Width := 150;
    RFE_MVZ_InstHaltKoA3.Height := 46;
    RFE_MVZ_InstHaltKoA3.ChildOrder := 34;
    RFE_MVZ_InstHaltKoA3.ElementFont := efCSS;
    RFE_MVZ_InstHaltKoA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_InstHaltKoA3.Font.Color := clWindowText;
    RFE_MVZ_InstHaltKoA3.Font.Height := -24;
    RFE_MVZ_InstHaltKoA3.Font.Name := 'Segoe UI';
    RFE_MVZ_InstHaltKoA3.Font.Style := [fsBold];
    RFE_MVZ_InstHaltKoA3.HeightStyle := ssAuto;
    RFE_MVZ_InstHaltKoA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA3.ParentFont := False;
    RFE_MVZ_InstHaltKoA3.TabOrder := 14;
    RFE_MVZ_InstHaltKoA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_InstHaltKoA3.DataField := 'Upmv_Administrative_Cost';
    RFE_MVZ_InstHaltKoA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_ZusVerwKoA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusVerwKoA3.Name := 'RFE_MVZ_ZusVerwKoA3';
    RFE_MVZ_ZusVerwKoA3.Left := 1128;
    RFE_MVZ_ZusVerwKoA3.Top := 246;
    RFE_MVZ_ZusVerwKoA3.Width := 150;
    RFE_MVZ_ZusVerwKoA3.Height := 46;
    RFE_MVZ_ZusVerwKoA3.ChildOrder := 35;
    RFE_MVZ_ZusVerwKoA3.ElementFont := efCSS;
    RFE_MVZ_ZusVerwKoA3.ElementPosition := epRelative;
    RFE_MVZ_ZusVerwKoA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusVerwKoA3.Font.Color := clWindowText;
    RFE_MVZ_ZusVerwKoA3.Font.Height := -24;
    RFE_MVZ_ZusVerwKoA3.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusVerwKoA3.Font.Style := [fsBold];
    RFE_MVZ_ZusVerwKoA3.HeightStyle := ssAuto;
    RFE_MVZ_ZusVerwKoA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA3.ParentFont := False;
    RFE_MVZ_ZusVerwKoA3.TabOrder := 15;
    RFE_MVZ_ZusVerwKoA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusVerwKoA3.DataField := 'Upmv_Maintenance';
    RFE_MVZ_ZusVerwKoA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_ZusLebensmA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusLebensmA3.Name := 'RFE_MVZ_ZusLebensmA3';
    RFE_MVZ_ZusLebensmA3.Left := 1128;
    RFE_MVZ_ZusLebensmA3.Top := 291;
    RFE_MVZ_ZusLebensmA3.Width := 150;
    RFE_MVZ_ZusLebensmA3.Height := 46;
    RFE_MVZ_ZusLebensmA3.ChildOrder := 36;
    RFE_MVZ_ZusLebensmA3.ElementFont := efCSS;
    RFE_MVZ_ZusLebensmA3.ElementPosition := epRelative;
    RFE_MVZ_ZusLebensmA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusLebensmA3.Font.Color := clWindowText;
    RFE_MVZ_ZusLebensmA3.Font.Height := -24;
    RFE_MVZ_ZusLebensmA3.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusLebensmA3.Font.Style := [fsBold];
    RFE_MVZ_ZusLebensmA3.HeightStyle := ssAuto;
    RFE_MVZ_ZusLebensmA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA3.ParentFont := False;
    RFE_MVZ_ZusLebensmA3.TabOrder := 16;
    RFE_MVZ_ZusLebensmA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusLebensmA3.DataField := 'Upmv_Food';
    RFE_MVZ_ZusLebensmA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_ZusMedTechnA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ZusMedTechnA3.Name := 'RFE_MVZ_ZusMedTechnA3';
    RFE_MVZ_ZusMedTechnA3.Left := 1128;
    RFE_MVZ_ZusMedTechnA3.Top := 336;
    RFE_MVZ_ZusMedTechnA3.Width := 150;
    RFE_MVZ_ZusMedTechnA3.Height := 46;
    RFE_MVZ_ZusMedTechnA3.ChildOrder := 37;
    RFE_MVZ_ZusMedTechnA3.ElementFont := efCSS;
    RFE_MVZ_ZusMedTechnA3.ElementPosition := epRelative;
    RFE_MVZ_ZusMedTechnA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ZusMedTechnA3.Font.Color := clWindowText;
    RFE_MVZ_ZusMedTechnA3.Font.Height := -24;
    RFE_MVZ_ZusMedTechnA3.Font.Name := 'Segoe UI';
    RFE_MVZ_ZusMedTechnA3.Font.Style := [fsBold];
    RFE_MVZ_ZusMedTechnA3.HeightStyle := ssAuto;
    RFE_MVZ_ZusMedTechnA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA3.ParentFont := False;
    RFE_MVZ_ZusMedTechnA3.TabOrder := 17;
    RFE_MVZ_ZusMedTechnA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ZusMedTechnA3.DataField := 'Upmv_Medical_Need';
    RFE_MVZ_ZusMedTechnA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_EignPaAntNormalA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntNormalA1.Name := 'RFE_MVZ_EignPaAntNormalA1';
    RFE_MVZ_EignPaAntNormalA1.Left := 736;
    RFE_MVZ_EignPaAntNormalA1.Top := 400;
    RFE_MVZ_EignPaAntNormalA1.Width := 150;
    RFE_MVZ_EignPaAntNormalA1.Height := 46;
    RFE_MVZ_EignPaAntNormalA1.ChildOrder := 38;
    RFE_MVZ_EignPaAntNormalA1.ElementFont := efCSS;
    RFE_MVZ_EignPaAntNormalA1.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntNormalA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntNormalA1.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntNormalA1.Font.Height := -24;
    RFE_MVZ_EignPaAntNormalA1.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntNormalA1.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntNormalA1.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntNormalA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA1.ParentFont := False;
    RFE_MVZ_EignPaAntNormalA1.TabOrder := 18;
    RFE_MVZ_EignPaAntNormalA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA1.DataField := 'Upmv_Own_Treatment_Normal';
    RFE_MVZ_EignPaAntNormalA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_EignPaZusErlNormA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlNormA1.Name := 'RFE_MVZ_EignPaZusErlNormA1';
    RFE_MVZ_EignPaZusErlNormA1.Left := 736;
    RFE_MVZ_EignPaZusErlNormA1.Top := 445;
    RFE_MVZ_EignPaZusErlNormA1.Width := 150;
    RFE_MVZ_EignPaZusErlNormA1.Height := 46;
    RFE_MVZ_EignPaZusErlNormA1.ChildOrder := 39;
    RFE_MVZ_EignPaZusErlNormA1.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlNormA1.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlNormA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlNormA1.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlNormA1.Font.Height := -24;
    RFE_MVZ_EignPaZusErlNormA1.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlNormA1.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlNormA1.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlNormA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA1.ParentFont := False;
    RFE_MVZ_EignPaZusErlNormA1.TabOrder := 19;
    RFE_MVZ_EignPaZusErlNormA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA1.DataField := 'Upmv_Own_Mvz_Normal_Day';
    RFE_MVZ_EignPaZusErlNormA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_EignPaAntWahlA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntWahlA1.Name := 'RFE_MVZ_EignPaAntWahlA1';
    RFE_MVZ_EignPaAntWahlA1.Left := 736;
    RFE_MVZ_EignPaAntWahlA1.Top := 490;
    RFE_MVZ_EignPaAntWahlA1.Width := 150;
    RFE_MVZ_EignPaAntWahlA1.Height := 46;
    RFE_MVZ_EignPaAntWahlA1.ChildOrder := 40;
    RFE_MVZ_EignPaAntWahlA1.ElementFont := efCSS;
    RFE_MVZ_EignPaAntWahlA1.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntWahlA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntWahlA1.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntWahlA1.Font.Height := -24;
    RFE_MVZ_EignPaAntWahlA1.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntWahlA1.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntWahlA1.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntWahlA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA1.ParentFont := False;
    RFE_MVZ_EignPaAntWahlA1.TabOrder := 20;
    RFE_MVZ_EignPaAntWahlA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA1.DataField := 'Upmv_Own_Treatment_Category';
    RFE_MVZ_EignPaAntWahlA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_EignPaZusErlWahlA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlWahlA1.Name := 'RFE_MVZ_EignPaZusErlWahlA1';
    RFE_MVZ_EignPaZusErlWahlA1.Left := 736;
    RFE_MVZ_EignPaZusErlWahlA1.Top := 535;
    RFE_MVZ_EignPaZusErlWahlA1.Width := 150;
    RFE_MVZ_EignPaZusErlWahlA1.Height := 46;
    RFE_MVZ_EignPaZusErlWahlA1.ChildOrder := 41;
    RFE_MVZ_EignPaZusErlWahlA1.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlWahlA1.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlWahlA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlWahlA1.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlWahlA1.Font.Height := -24;
    RFE_MVZ_EignPaZusErlWahlA1.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlWahlA1.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlWahlA1.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlWahlA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA1.ParentFont := False;
    RFE_MVZ_EignPaZusErlWahlA1.TabOrder := 21;
    RFE_MVZ_EignPaZusErlWahlA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA1.DataField := 'Upmv_Own_Additional_Proceed_Mvz_Category';
    RFE_MVZ_EignPaZusErlWahlA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_EignPaVersTageA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaVersTageA1.Name := 'RFE_MVZ_EignPaVersTageA1';
    RFE_MVZ_EignPaVersTageA1.Left := 736;
    RFE_MVZ_EignPaVersTageA1.Top := 580;
    RFE_MVZ_EignPaVersTageA1.Width := 150;
    RFE_MVZ_EignPaVersTageA1.Height := 46;
    RFE_MVZ_EignPaVersTageA1.ChildOrder := 42;
    RFE_MVZ_EignPaVersTageA1.ElementFont := efCSS;
    RFE_MVZ_EignPaVersTageA1.ElementPosition := epRelative;
    RFE_MVZ_EignPaVersTageA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaVersTageA1.Font.Color := clWindowText;
    RFE_MVZ_EignPaVersTageA1.Font.Height := -24;
    RFE_MVZ_EignPaVersTageA1.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaVersTageA1.Font.Style := [fsBold];
    RFE_MVZ_EignPaVersTageA1.HeightStyle := ssAuto;
    RFE_MVZ_EignPaVersTageA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA1.ParentFont := False;
    RFE_MVZ_EignPaVersTageA1.TabOrder := 22;
    RFE_MVZ_EignPaVersTageA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA1.DataField := 'Upmv_Own_Supply_Day';
    RFE_MVZ_EignPaVersTageA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_FrmdPaAntNormalA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntNormalA1.Name := 'RFE_MVZ_FrmdPaAntNormalA1';
    RFE_MVZ_FrmdPaAntNormalA1.Left := 736;
    RFE_MVZ_FrmdPaAntNormalA1.Top := 644;
    RFE_MVZ_FrmdPaAntNormalA1.Width := 150;
    RFE_MVZ_FrmdPaAntNormalA1.Height := 46;
    RFE_MVZ_FrmdPaAntNormalA1.ChildOrder := 43;
    RFE_MVZ_FrmdPaAntNormalA1.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntNormalA1.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntNormalA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntNormalA1.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntNormalA1.Font.Height := -24;
    RFE_MVZ_FrmdPaAntNormalA1.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntNormalA1.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntNormalA1.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntNormalA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA1.ParentFont := False;
    RFE_MVZ_FrmdPaAntNormalA1.TabOrder := 23;
    RFE_MVZ_FrmdPaAntNormalA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA1.DataField := 'Upmv_Stranger_Treatment_Normal';
    RFE_MVZ_FrmdPaAntNormalA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_EignPaAntNormalA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntNormalA2.Name := 'RFE_MVZ_EignPaAntNormalA2';
    RFE_MVZ_EignPaAntNormalA2.Left := 936;
    RFE_MVZ_EignPaAntNormalA2.Top := 400;
    RFE_MVZ_EignPaAntNormalA2.Width := 150;
    RFE_MVZ_EignPaAntNormalA2.Height := 46;
    RFE_MVZ_EignPaAntNormalA2.ChildOrder := 44;
    RFE_MVZ_EignPaAntNormalA2.ElementFont := efCSS;
    RFE_MVZ_EignPaAntNormalA2.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntNormalA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntNormalA2.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntNormalA2.Font.Height := -24;
    RFE_MVZ_EignPaAntNormalA2.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntNormalA2.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntNormalA2.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntNormalA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA2.ParentFont := False;
    RFE_MVZ_EignPaAntNormalA2.TabOrder := 24;
    RFE_MVZ_EignPaAntNormalA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA2.DataField := 'Upmv_Own_Treatment_Normal';
    RFE_MVZ_EignPaAntNormalA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_EignPaZusErlNormA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlNormA2.Name := 'RFE_MVZ_EignPaZusErlNormA2';
    RFE_MVZ_EignPaZusErlNormA2.Left := 936;
    RFE_MVZ_EignPaZusErlNormA2.Top := 445;
    RFE_MVZ_EignPaZusErlNormA2.Width := 150;
    RFE_MVZ_EignPaZusErlNormA2.Height := 46;
    RFE_MVZ_EignPaZusErlNormA2.ChildOrder := 45;
    RFE_MVZ_EignPaZusErlNormA2.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlNormA2.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlNormA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlNormA2.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlNormA2.Font.Height := -24;
    RFE_MVZ_EignPaZusErlNormA2.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlNormA2.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlNormA2.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlNormA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA2.ParentFont := False;
    RFE_MVZ_EignPaZusErlNormA2.TabOrder := 25;
    RFE_MVZ_EignPaZusErlNormA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA2.DataField := 'Upmv_Own_Mvz_Normal_Day';
    RFE_MVZ_EignPaZusErlNormA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_EignPaAntWahlA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntWahlA2.Name := 'RFE_MVZ_EignPaAntWahlA2';
    RFE_MVZ_EignPaAntWahlA2.Left := 936;
    RFE_MVZ_EignPaAntWahlA2.Top := 490;
    RFE_MVZ_EignPaAntWahlA2.Width := 150;
    RFE_MVZ_EignPaAntWahlA2.Height := 46;
    RFE_MVZ_EignPaAntWahlA2.ChildOrder := 46;
    RFE_MVZ_EignPaAntWahlA2.ElementFont := efCSS;
    RFE_MVZ_EignPaAntWahlA2.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntWahlA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntWahlA2.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntWahlA2.Font.Height := -24;
    RFE_MVZ_EignPaAntWahlA2.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntWahlA2.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntWahlA2.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntWahlA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA2.ParentFont := False;
    RFE_MVZ_EignPaAntWahlA2.TabOrder := 26;
    RFE_MVZ_EignPaAntWahlA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA2.DataField := 'Upmv_Own_Treatment_Category';
    RFE_MVZ_EignPaAntWahlA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_EignPaZusErlWahlA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlWahlA2.Name := 'RFE_MVZ_EignPaZusErlWahlA2';
    RFE_MVZ_EignPaZusErlWahlA2.Left := 936;
    RFE_MVZ_EignPaZusErlWahlA2.Top := 535;
    RFE_MVZ_EignPaZusErlWahlA2.Width := 150;
    RFE_MVZ_EignPaZusErlWahlA2.Height := 46;
    RFE_MVZ_EignPaZusErlWahlA2.ChildOrder := 47;
    RFE_MVZ_EignPaZusErlWahlA2.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlWahlA2.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlWahlA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlWahlA2.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlWahlA2.Font.Height := -24;
    RFE_MVZ_EignPaZusErlWahlA2.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlWahlA2.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlWahlA2.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlWahlA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA2.ParentFont := False;
    RFE_MVZ_EignPaZusErlWahlA2.TabOrder := 27;
    RFE_MVZ_EignPaZusErlWahlA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA2.DataField := 'Upmv_Own_Additional_Proceed_Mvz_Category';
    RFE_MVZ_EignPaZusErlWahlA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_EignPaVersTageA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaVersTageA2.Name := 'RFE_MVZ_EignPaVersTageA2';
    RFE_MVZ_EignPaVersTageA2.Left := 936;
    RFE_MVZ_EignPaVersTageA2.Top := 580;
    RFE_MVZ_EignPaVersTageA2.Width := 150;
    RFE_MVZ_EignPaVersTageA2.Height := 46;
    RFE_MVZ_EignPaVersTageA2.ChildOrder := 48;
    RFE_MVZ_EignPaVersTageA2.ElementFont := efCSS;
    RFE_MVZ_EignPaVersTageA2.ElementPosition := epRelative;
    RFE_MVZ_EignPaVersTageA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaVersTageA2.Font.Color := clWindowText;
    RFE_MVZ_EignPaVersTageA2.Font.Height := -24;
    RFE_MVZ_EignPaVersTageA2.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaVersTageA2.Font.Style := [fsBold];
    RFE_MVZ_EignPaVersTageA2.HeightStyle := ssAuto;
    RFE_MVZ_EignPaVersTageA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA2.ParentFont := False;
    RFE_MVZ_EignPaVersTageA2.TabOrder := 28;
    RFE_MVZ_EignPaVersTageA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA2.DataField := 'Upmv_Own_Supply_Day';
    RFE_MVZ_EignPaVersTageA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_FrmdPaAntNormalA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntNormalA2.Name := 'RFE_MVZ_FrmdPaAntNormalA2';
    RFE_MVZ_FrmdPaAntNormalA2.Left := 936;
    RFE_MVZ_FrmdPaAntNormalA2.Top := 644;
    RFE_MVZ_FrmdPaAntNormalA2.Width := 150;
    RFE_MVZ_FrmdPaAntNormalA2.Height := 46;
    RFE_MVZ_FrmdPaAntNormalA2.ChildOrder := 49;
    RFE_MVZ_FrmdPaAntNormalA2.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntNormalA2.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntNormalA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntNormalA2.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntNormalA2.Font.Height := -24;
    RFE_MVZ_FrmdPaAntNormalA2.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntNormalA2.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntNormalA2.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntNormalA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA2.ParentFont := False;
    RFE_MVZ_FrmdPaAntNormalA2.TabOrder := 29;
    RFE_MVZ_FrmdPaAntNormalA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA2.DataField := 'Upmv_Stranger_Treatment_Normal';
    RFE_MVZ_FrmdPaAntNormalA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_EignPaAntNormalA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntNormalA3.Name := 'RFE_MVZ_EignPaAntNormalA3';
    RFE_MVZ_EignPaAntNormalA3.Left := 1128;
    RFE_MVZ_EignPaAntNormalA3.Top := 400;
    RFE_MVZ_EignPaAntNormalA3.Width := 150;
    RFE_MVZ_EignPaAntNormalA3.Height := 46;
    RFE_MVZ_EignPaAntNormalA3.ChildOrder := 50;
    RFE_MVZ_EignPaAntNormalA3.ElementFont := efCSS;
    RFE_MVZ_EignPaAntNormalA3.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntNormalA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntNormalA3.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntNormalA3.Font.Height := -24;
    RFE_MVZ_EignPaAntNormalA3.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntNormalA3.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntNormalA3.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntNormalA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA3.ParentFont := False;
    RFE_MVZ_EignPaAntNormalA3.TabOrder := 30;
    RFE_MVZ_EignPaAntNormalA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntNormalA3.DataField := 'Upmv_Own_Treatment_Normal';
    RFE_MVZ_EignPaAntNormalA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_EignPaZusErlNormA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlNormA3.Name := 'RFE_MVZ_EignPaZusErlNormA3';
    RFE_MVZ_EignPaZusErlNormA3.Left := 1128;
    RFE_MVZ_EignPaZusErlNormA3.Top := 445;
    RFE_MVZ_EignPaZusErlNormA3.Width := 150;
    RFE_MVZ_EignPaZusErlNormA3.Height := 46;
    RFE_MVZ_EignPaZusErlNormA3.ChildOrder := 51;
    RFE_MVZ_EignPaZusErlNormA3.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlNormA3.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlNormA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlNormA3.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlNormA3.Font.Height := -24;
    RFE_MVZ_EignPaZusErlNormA3.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlNormA3.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlNormA3.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlNormA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA3.ParentFont := False;
    RFE_MVZ_EignPaZusErlNormA3.TabOrder := 31;
    RFE_MVZ_EignPaZusErlNormA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlNormA3.DataField := 'Upmv_Own_Mvz_Normal_Day';
    RFE_MVZ_EignPaZusErlNormA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_EignPaAntWahlA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaAntWahlA3.Name := 'RFE_MVZ_EignPaAntWahlA3';
    RFE_MVZ_EignPaAntWahlA3.Left := 1128;
    RFE_MVZ_EignPaAntWahlA3.Top := 490;
    RFE_MVZ_EignPaAntWahlA3.Width := 150;
    RFE_MVZ_EignPaAntWahlA3.Height := 46;
    RFE_MVZ_EignPaAntWahlA3.ChildOrder := 52;
    RFE_MVZ_EignPaAntWahlA3.ElementFont := efCSS;
    RFE_MVZ_EignPaAntWahlA3.ElementPosition := epRelative;
    RFE_MVZ_EignPaAntWahlA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaAntWahlA3.Font.Color := clWindowText;
    RFE_MVZ_EignPaAntWahlA3.Font.Height := -24;
    RFE_MVZ_EignPaAntWahlA3.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaAntWahlA3.Font.Style := [fsBold];
    RFE_MVZ_EignPaAntWahlA3.HeightStyle := ssAuto;
    RFE_MVZ_EignPaAntWahlA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA3.ParentFont := False;
    RFE_MVZ_EignPaAntWahlA3.TabOrder := 32;
    RFE_MVZ_EignPaAntWahlA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaAntWahlA3.DataField := 'Upmv_Own_Treatment_Category';
    RFE_MVZ_EignPaAntWahlA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_EignPaZusErlWahlA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaZusErlWahlA3.Name := 'RFE_MVZ_EignPaZusErlWahlA3';
    RFE_MVZ_EignPaZusErlWahlA3.Left := 1128;
    RFE_MVZ_EignPaZusErlWahlA3.Top := 535;
    RFE_MVZ_EignPaZusErlWahlA3.Width := 150;
    RFE_MVZ_EignPaZusErlWahlA3.Height := 46;
    RFE_MVZ_EignPaZusErlWahlA3.ChildOrder := 53;
    RFE_MVZ_EignPaZusErlWahlA3.ElementFont := efCSS;
    RFE_MVZ_EignPaZusErlWahlA3.ElementPosition := epRelative;
    RFE_MVZ_EignPaZusErlWahlA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaZusErlWahlA3.Font.Color := clWindowText;
    RFE_MVZ_EignPaZusErlWahlA3.Font.Height := -24;
    RFE_MVZ_EignPaZusErlWahlA3.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaZusErlWahlA3.Font.Style := [fsBold];
    RFE_MVZ_EignPaZusErlWahlA3.HeightStyle := ssAuto;
    RFE_MVZ_EignPaZusErlWahlA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA3.ParentFont := False;
    RFE_MVZ_EignPaZusErlWahlA3.TabOrder := 33;
    RFE_MVZ_EignPaZusErlWahlA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaZusErlWahlA3.DataField := 'Upmv_Own_Additional_Proceed_Mvz_Category';
    RFE_MVZ_EignPaZusErlWahlA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_EignPaVersTageA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_EignPaVersTageA3.Name := 'RFE_MVZ_EignPaVersTageA3';
    RFE_MVZ_EignPaVersTageA3.Left := 1128;
    RFE_MVZ_EignPaVersTageA3.Top := 580;
    RFE_MVZ_EignPaVersTageA3.Width := 150;
    RFE_MVZ_EignPaVersTageA3.Height := 46;
    RFE_MVZ_EignPaVersTageA3.ChildOrder := 54;
    RFE_MVZ_EignPaVersTageA3.ElementFont := efCSS;
    RFE_MVZ_EignPaVersTageA3.ElementPosition := epRelative;
    RFE_MVZ_EignPaVersTageA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_EignPaVersTageA3.Font.Color := clWindowText;
    RFE_MVZ_EignPaVersTageA3.Font.Height := -24;
    RFE_MVZ_EignPaVersTageA3.Font.Name := 'Segoe UI';
    RFE_MVZ_EignPaVersTageA3.Font.Style := [fsBold];
    RFE_MVZ_EignPaVersTageA3.HeightStyle := ssAuto;
    RFE_MVZ_EignPaVersTageA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA3.ParentFont := False;
    RFE_MVZ_EignPaVersTageA3.TabOrder := 34;
    RFE_MVZ_EignPaVersTageA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_EignPaVersTageA3.DataField := 'Upmv_Own_Supply_Day';
    RFE_MVZ_EignPaVersTageA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_FrmdPaAntNormalA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntNormalA3.Name := 'RFE_MVZ_FrmdPaAntNormalA3';
    RFE_MVZ_FrmdPaAntNormalA3.Left := 1128;
    RFE_MVZ_FrmdPaAntNormalA3.Top := 644;
    RFE_MVZ_FrmdPaAntNormalA3.Width := 150;
    RFE_MVZ_FrmdPaAntNormalA3.Height := 46;
    RFE_MVZ_FrmdPaAntNormalA3.ChildOrder := 55;
    RFE_MVZ_FrmdPaAntNormalA3.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntNormalA3.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntNormalA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntNormalA3.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntNormalA3.Font.Height := -24;
    RFE_MVZ_FrmdPaAntNormalA3.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntNormalA3.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntNormalA3.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntNormalA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA3.ParentFont := False;
    RFE_MVZ_FrmdPaAntNormalA3.TabOrder := 35;
    RFE_MVZ_FrmdPaAntNormalA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntNormalA3.DataField := 'Upmv_Stranger_Treatment_Normal';
    RFE_MVZ_FrmdPaAntNormalA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_FrmdPaZusErlNormA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlNormA1.Name := 'RFE_MVZ_FrmdPaZusErlNormA1';
    RFE_MVZ_FrmdPaZusErlNormA1.Left := 736;
    RFE_MVZ_FrmdPaZusErlNormA1.Top := 689;
    RFE_MVZ_FrmdPaZusErlNormA1.Width := 150;
    RFE_MVZ_FrmdPaZusErlNormA1.Height := 46;
    RFE_MVZ_FrmdPaZusErlNormA1.ChildOrder := 56;
    RFE_MVZ_FrmdPaZusErlNormA1.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlNormA1.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlNormA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlNormA1.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlNormA1.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlNormA1.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlNormA1.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlNormA1.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlNormA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA1.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlNormA1.TabOrder := 36;
    RFE_MVZ_FrmdPaZusErlNormA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA1.DataField := 'Upmv_Stranger_Mvz_Normal_Day';
    RFE_MVZ_FrmdPaZusErlNormA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_FrmdPaAntWahlA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntWahlA1.Name := 'RFE_MVZ_FrmdPaAntWahlA1';
    RFE_MVZ_FrmdPaAntWahlA1.Left := 736;
    RFE_MVZ_FrmdPaAntWahlA1.Top := 734;
    RFE_MVZ_FrmdPaAntWahlA1.Width := 150;
    RFE_MVZ_FrmdPaAntWahlA1.Height := 46;
    RFE_MVZ_FrmdPaAntWahlA1.ChildOrder := 57;
    RFE_MVZ_FrmdPaAntWahlA1.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntWahlA1.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntWahlA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntWahlA1.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntWahlA1.Font.Height := -24;
    RFE_MVZ_FrmdPaAntWahlA1.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntWahlA1.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntWahlA1.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntWahlA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA1.ParentFont := False;
    RFE_MVZ_FrmdPaAntWahlA1.TabOrder := 37;
    RFE_MVZ_FrmdPaAntWahlA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA1.DataField := 'Upmv_Stranger_Treatment_Category';
    RFE_MVZ_FrmdPaAntWahlA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_FrmdPaZusErlWahlA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlWahlA1.Name := 'RFE_MVZ_FrmdPaZusErlWahlA1';
    RFE_MVZ_FrmdPaZusErlWahlA1.Left := 736;
    RFE_MVZ_FrmdPaZusErlWahlA1.Top := 779;
    RFE_MVZ_FrmdPaZusErlWahlA1.Width := 150;
    RFE_MVZ_FrmdPaZusErlWahlA1.Height := 46;
    RFE_MVZ_FrmdPaZusErlWahlA1.ChildOrder := 58;
    RFE_MVZ_FrmdPaZusErlWahlA1.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlWahlA1.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlWahlA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlWahlA1.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlWahlA1.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlWahlA1.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlWahlA1.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlWahlA1.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlWahlA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA1.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlWahlA1.TabOrder := 38;
    RFE_MVZ_FrmdPaZusErlWahlA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA1.DataField := 'Upmv_Stranger_Additional_Proceed_Mvz_Category';
    RFE_MVZ_FrmdPaZusErlWahlA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_FrmdPaVersTageA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaVersTageA1.Name := 'RFE_MVZ_FrmdPaVersTageA1';
    RFE_MVZ_FrmdPaVersTageA1.Left := 736;
    RFE_MVZ_FrmdPaVersTageA1.Top := 824;
    RFE_MVZ_FrmdPaVersTageA1.Width := 150;
    RFE_MVZ_FrmdPaVersTageA1.Height := 46;
    RFE_MVZ_FrmdPaVersTageA1.ChildOrder := 59;
    RFE_MVZ_FrmdPaVersTageA1.ElementFont := efCSS;
    RFE_MVZ_FrmdPaVersTageA1.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaVersTageA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaVersTageA1.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaVersTageA1.Font.Height := -24;
    RFE_MVZ_FrmdPaVersTageA1.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaVersTageA1.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaVersTageA1.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaVersTageA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA1.ParentFont := False;
    RFE_MVZ_FrmdPaVersTageA1.TabOrder := 39;
    RFE_MVZ_FrmdPaVersTageA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA1.DataField := 'Upmv_Stranger_Supply_Day';
    RFE_MVZ_FrmdPaVersTageA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_ArztMinA1.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ArztMinA1.Name := 'RFE_MVZ_ArztMinA1';
    RFE_MVZ_ArztMinA1.Left := 736;
    RFE_MVZ_ArztMinA1.Top := 884;
    RFE_MVZ_ArztMinA1.Width := 150;
    RFE_MVZ_ArztMinA1.Height := 46;
    RFE_MVZ_ArztMinA1.ChildOrder := 60;
    RFE_MVZ_ArztMinA1.ElementFont := efCSS;
    RFE_MVZ_ArztMinA1.ElementPosition := epRelative;
    RFE_MVZ_ArztMinA1.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ArztMinA1.Font.Color := clWindowText;
    RFE_MVZ_ArztMinA1.Font.Height := -24;
    RFE_MVZ_ArztMinA1.Font.Name := 'Segoe UI';
    RFE_MVZ_ArztMinA1.Font.Style := [fsBold];
    RFE_MVZ_ArztMinA1.HeightStyle := ssAuto;
    RFE_MVZ_ArztMinA1.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA1.ParentFont := False;
    RFE_MVZ_ArztMinA1.TabOrder := 40;
    RFE_MVZ_ArztMinA1.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA1.DataField := 'Upmv_Doctor_Minutes';
    RFE_MVZ_ArztMinA1.DataSource := MVZStat1WebDataSource;
    RFE_MVZ_FrmdPaZusErlNormA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlNormA2.Name := 'RFE_MVZ_FrmdPaZusErlNormA2';
    RFE_MVZ_FrmdPaZusErlNormA2.Left := 936;
    RFE_MVZ_FrmdPaZusErlNormA2.Top := 689;
    RFE_MVZ_FrmdPaZusErlNormA2.Width := 150;
    RFE_MVZ_FrmdPaZusErlNormA2.Height := 46;
    RFE_MVZ_FrmdPaZusErlNormA2.ChildOrder := 61;
    RFE_MVZ_FrmdPaZusErlNormA2.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlNormA2.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlNormA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlNormA2.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlNormA2.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlNormA2.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlNormA2.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlNormA2.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlNormA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA2.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlNormA2.TabOrder := 41;
    RFE_MVZ_FrmdPaZusErlNormA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA2.DataField := 'Upmv_Stranger_Mvz_Normal_Day';
    RFE_MVZ_FrmdPaZusErlNormA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_FrmdPaAntWahlA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntWahlA2.Name := 'RFE_MVZ_FrmdPaAntWahlA2';
    RFE_MVZ_FrmdPaAntWahlA2.Left := 936;
    RFE_MVZ_FrmdPaAntWahlA2.Top := 734;
    RFE_MVZ_FrmdPaAntWahlA2.Width := 150;
    RFE_MVZ_FrmdPaAntWahlA2.Height := 46;
    RFE_MVZ_FrmdPaAntWahlA2.ChildOrder := 62;
    RFE_MVZ_FrmdPaAntWahlA2.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntWahlA2.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntWahlA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntWahlA2.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntWahlA2.Font.Height := -24;
    RFE_MVZ_FrmdPaAntWahlA2.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntWahlA2.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntWahlA2.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntWahlA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA2.ParentFont := False;
    RFE_MVZ_FrmdPaAntWahlA2.TabOrder := 42;
    RFE_MVZ_FrmdPaAntWahlA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA2.DataField := 'Upmv_Stranger_Treatment_Category';
    RFE_MVZ_FrmdPaAntWahlA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_FrmdPaZusErlWahlA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlWahlA2.Name := 'RFE_MVZ_FrmdPaZusErlWahlA2';
    RFE_MVZ_FrmdPaZusErlWahlA2.Left := 936;
    RFE_MVZ_FrmdPaZusErlWahlA2.Top := 779;
    RFE_MVZ_FrmdPaZusErlWahlA2.Width := 150;
    RFE_MVZ_FrmdPaZusErlWahlA2.Height := 46;
    RFE_MVZ_FrmdPaZusErlWahlA2.ChildOrder := 63;
    RFE_MVZ_FrmdPaZusErlWahlA2.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlWahlA2.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlWahlA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlWahlA2.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlWahlA2.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlWahlA2.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlWahlA2.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlWahlA2.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlWahlA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA2.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlWahlA2.TabOrder := 43;
    RFE_MVZ_FrmdPaZusErlWahlA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA2.DataField := 'Upmv_Stranger_Additional_Proceed_Mvz_Category';
    RFE_MVZ_FrmdPaZusErlWahlA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_FrmdPaVersTageA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaVersTageA2.Name := 'RFE_MVZ_FrmdPaVersTageA2';
    RFE_MVZ_FrmdPaVersTageA2.Left := 936;
    RFE_MVZ_FrmdPaVersTageA2.Top := 824;
    RFE_MVZ_FrmdPaVersTageA2.Width := 150;
    RFE_MVZ_FrmdPaVersTageA2.Height := 46;
    RFE_MVZ_FrmdPaVersTageA2.ChildOrder := 64;
    RFE_MVZ_FrmdPaVersTageA2.ElementFont := efCSS;
    RFE_MVZ_FrmdPaVersTageA2.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaVersTageA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaVersTageA2.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaVersTageA2.Font.Height := -24;
    RFE_MVZ_FrmdPaVersTageA2.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaVersTageA2.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaVersTageA2.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaVersTageA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA2.ParentFont := False;
    RFE_MVZ_FrmdPaVersTageA2.TabOrder := 44;
    RFE_MVZ_FrmdPaVersTageA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA2.DataField := 'Upmv_Stranger_Supply_Day';
    RFE_MVZ_FrmdPaVersTageA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_ArztMinA2.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ArztMinA2.Name := 'RFE_MVZ_ArztMinA2';
    RFE_MVZ_ArztMinA2.Left := 936;
    RFE_MVZ_ArztMinA2.Top := 884;
    RFE_MVZ_ArztMinA2.Width := 150;
    RFE_MVZ_ArztMinA2.Height := 46;
    RFE_MVZ_ArztMinA2.ChildOrder := 65;
    RFE_MVZ_ArztMinA2.ElementFont := efCSS;
    RFE_MVZ_ArztMinA2.ElementPosition := epRelative;
    RFE_MVZ_ArztMinA2.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ArztMinA2.Font.Color := clWindowText;
    RFE_MVZ_ArztMinA2.Font.Height := -24;
    RFE_MVZ_ArztMinA2.Font.Name := 'Segoe UI';
    RFE_MVZ_ArztMinA2.Font.Style := [fsBold];
    RFE_MVZ_ArztMinA2.HeightStyle := ssAuto;
    RFE_MVZ_ArztMinA2.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA2.ParentFont := False;
    RFE_MVZ_ArztMinA2.TabOrder := 45;
    RFE_MVZ_ArztMinA2.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA2.DataField := 'Upmv_Doctor_Minutes';
    RFE_MVZ_ArztMinA2.DataSource := MVZStat2WebDataSource;
    RFE_MVZ_FrmdPaZusErlNormA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlNormA3.Name := 'RFE_MVZ_FrmdPaZusErlNormA3';
    RFE_MVZ_FrmdPaZusErlNormA3.Left := 1128;
    RFE_MVZ_FrmdPaZusErlNormA3.Top := 689;
    RFE_MVZ_FrmdPaZusErlNormA3.Width := 150;
    RFE_MVZ_FrmdPaZusErlNormA3.Height := 46;
    RFE_MVZ_FrmdPaZusErlNormA3.ChildOrder := 66;
    RFE_MVZ_FrmdPaZusErlNormA3.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlNormA3.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlNormA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlNormA3.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlNormA3.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlNormA3.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlNormA3.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlNormA3.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlNormA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA3.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlNormA3.TabOrder := 46;
    RFE_MVZ_FrmdPaZusErlNormA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlNormA3.DataField := 'Upmv_Stranger_Mvz_Normal_Day';
    RFE_MVZ_FrmdPaZusErlNormA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_FrmdPaAntWahlA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaAntWahlA3.Name := 'RFE_MVZ_FrmdPaAntWahlA3';
    RFE_MVZ_FrmdPaAntWahlA3.Left := 1128;
    RFE_MVZ_FrmdPaAntWahlA3.Top := 734;
    RFE_MVZ_FrmdPaAntWahlA3.Width := 150;
    RFE_MVZ_FrmdPaAntWahlA3.Height := 46;
    RFE_MVZ_FrmdPaAntWahlA3.ChildOrder := 67;
    RFE_MVZ_FrmdPaAntWahlA3.ElementFont := efCSS;
    RFE_MVZ_FrmdPaAntWahlA3.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaAntWahlA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaAntWahlA3.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaAntWahlA3.Font.Height := -24;
    RFE_MVZ_FrmdPaAntWahlA3.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaAntWahlA3.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaAntWahlA3.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaAntWahlA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA3.ParentFont := False;
    RFE_MVZ_FrmdPaAntWahlA3.TabOrder := 47;
    RFE_MVZ_FrmdPaAntWahlA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaAntWahlA3.DataField := 'Upmv_Stranger_Treatment_Category';
    RFE_MVZ_FrmdPaAntWahlA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_FrmdPaZusErlWahlA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaZusErlWahlA3.Name := 'RFE_MVZ_FrmdPaZusErlWahlA3';
    RFE_MVZ_FrmdPaZusErlWahlA3.Left := 1128;
    RFE_MVZ_FrmdPaZusErlWahlA3.Top := 779;
    RFE_MVZ_FrmdPaZusErlWahlA3.Width := 150;
    RFE_MVZ_FrmdPaZusErlWahlA3.Height := 46;
    RFE_MVZ_FrmdPaZusErlWahlA3.ChildOrder := 68;
    RFE_MVZ_FrmdPaZusErlWahlA3.ElementFont := efCSS;
    RFE_MVZ_FrmdPaZusErlWahlA3.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaZusErlWahlA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaZusErlWahlA3.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaZusErlWahlA3.Font.Height := -24;
    RFE_MVZ_FrmdPaZusErlWahlA3.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaZusErlWahlA3.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaZusErlWahlA3.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaZusErlWahlA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA3.ParentFont := False;
    RFE_MVZ_FrmdPaZusErlWahlA3.TabOrder := 48;
    RFE_MVZ_FrmdPaZusErlWahlA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaZusErlWahlA3.DataField := 'Upmv_Stranger_Additional_Proceed_Mvz_Category';
    RFE_MVZ_FrmdPaZusErlWahlA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_FrmdPaVersTageA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_FrmdPaVersTageA3.Name := 'RFE_MVZ_FrmdPaVersTageA3';
    RFE_MVZ_FrmdPaVersTageA3.Left := 1128;
    RFE_MVZ_FrmdPaVersTageA3.Top := 824;
    RFE_MVZ_FrmdPaVersTageA3.Width := 150;
    RFE_MVZ_FrmdPaVersTageA3.Height := 46;
    RFE_MVZ_FrmdPaVersTageA3.ChildOrder := 69;
    RFE_MVZ_FrmdPaVersTageA3.ElementFont := efCSS;
    RFE_MVZ_FrmdPaVersTageA3.ElementPosition := epRelative;
    RFE_MVZ_FrmdPaVersTageA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_FrmdPaVersTageA3.Font.Color := clWindowText;
    RFE_MVZ_FrmdPaVersTageA3.Font.Height := -24;
    RFE_MVZ_FrmdPaVersTageA3.Font.Name := 'Segoe UI';
    RFE_MVZ_FrmdPaVersTageA3.Font.Style := [fsBold];
    RFE_MVZ_FrmdPaVersTageA3.HeightStyle := ssAuto;
    RFE_MVZ_FrmdPaVersTageA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA3.ParentFont := False;
    RFE_MVZ_FrmdPaVersTageA3.TabOrder := 49;
    RFE_MVZ_FrmdPaVersTageA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_FrmdPaVersTageA3.DataField := 'Upmv_Stranger_Supply_Day';
    RFE_MVZ_FrmdPaVersTageA3.DataSource := MVZStat3WebDataSource;
    RFE_MVZ_ArztMinA3.SetParentComponent(pnMedVersorgung);
    RFE_MVZ_ArztMinA3.Name := 'RFE_MVZ_ArztMinA3';
    RFE_MVZ_ArztMinA3.Left := 1128;
    RFE_MVZ_ArztMinA3.Top := 884;
    RFE_MVZ_ArztMinA3.Width := 150;
    RFE_MVZ_ArztMinA3.Height := 46;
    RFE_MVZ_ArztMinA3.ChildOrder := 70;
    RFE_MVZ_ArztMinA3.ElementFont := efCSS;
    RFE_MVZ_ArztMinA3.ElementPosition := epRelative;
    RFE_MVZ_ArztMinA3.Font.Charset := ANSI_CHARSET;
    RFE_MVZ_ArztMinA3.Font.Color := clWindowText;
    RFE_MVZ_ArztMinA3.Font.Height := -24;
    RFE_MVZ_ArztMinA3.Font.Name := 'Segoe UI';
    RFE_MVZ_ArztMinA3.Font.Style := [fsBold];
    RFE_MVZ_ArztMinA3.HeightStyle := ssAuto;
    RFE_MVZ_ArztMinA3.HeightPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA3.ParentFont := False;
    RFE_MVZ_ArztMinA3.TabOrder := 50;
    RFE_MVZ_ArztMinA3.WidthPercent := 100.00000000000000000;
    RFE_MVZ_ArztMinA3.DataField := 'Upmv_Doctor_Minutes';
    RFE_MVZ_ArztMinA3.DataSource := MVZStat3WebDataSource;
    pgSeite5.SetParentComponent(PageControl);
    pgSeite5.Name := 'pgSeite5';
    pgSeite5.Left := 0;
    pgSeite5.Top := 20;
    pgSeite5.Width := 1240;
    pgSeite5.Height := 972;
    pgSeite5.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite5.Caption := 'Module / Berichte';
    pgSeite5.ChildOrder := 4;
    pgSeite5.ElementFont := efCSS;
    pnBerichte.SetParentComponent(pgSeite5);
    pnBerichte.Name := 'pnBerichte';
    pnBerichte.Left := 0;
    pnBerichte.Top := 601;
    pnBerichte.Width := 1240;
    pnBerichte.Height := 165;
    pnBerichte.HeightStyle := ssPercent;
    pnBerichte.WidthStyle := ssPercent;
    pnBerichte.Align := alTop;
    pnBerichte.ElementFont := efCSS;
    pnBerichte.ElementPosition := epRelative;
    pnBerichte.TabOrder := 0;
    WebLabel21.SetParentComponent(pnBerichte);
    WebLabel21.Name := 'WebLabel21';
    WebLabel21.Left := 32;
    WebLabel21.Top := 22;
    WebLabel21.Width := 203;
    WebLabel21.Height := 18;
    WebLabel21.Caption := 'Berichte ab Periode freischalten';
    WebLabel21.ElementFont := efCSS;
    WebLabel21.HeightStyle := ssAuto;
    WebLabel21.HeightPercent := 100.00000000000000000;
    WebLabel21.HTMLType := tH3;
    WebLabel21.WidthPercent := 100.00000000000000000;
    WebLabel22.SetParentComponent(pnBerichte);
    WebLabel22.Name := 'WebLabel22';
    WebLabel22.Left := 32;
    WebLabel22.Top := 50;
    WebLabel22.Width := 268;
    WebLabel22.Height := 29;
    WebLabel22.Caption := 'Kostentr'#228'gerrechnung';
    WebLabel22.ElementFont := efCSS;
    WebLabel22.ElementPosition := epRelative;
    WebLabel22.Font.Charset := DEFAULT_CHARSET;
    WebLabel22.Font.Color := clWindowText;
    WebLabel22.Font.Height := -24;
    WebLabel22.Font.Name := 'Tahoma';
    WebLabel22.Font.Style := [fsBold];
    WebLabel22.HeightStyle := ssAuto;
    WebLabel22.HeightPercent := 100.00000000000000000;
    WebLabel22.ParentFont := False;
    WebLabel22.WordWrap := True;
    WebLabel22.WidthPercent := 100.00000000000000000;
    WebLabel23.SetParentComponent(pnBerichte);
    WebLabel23.Name := 'WebLabel23';
    WebLabel23.Left := 354;
    WebLabel23.Top := 49;
    WebLabel23.Width := 325;
    WebLabel23.Height := 29;
    WebLabel23.Caption := 'Deckungsbeitragsrechnung';
    WebLabel23.ElementFont := efCSS;
    WebLabel23.ElementPosition := epRelative;
    WebLabel23.Font.Charset := DEFAULT_CHARSET;
    WebLabel23.Font.Color := clWindowText;
    WebLabel23.Font.Height := -24;
    WebLabel23.Font.Name := 'Tahoma';
    WebLabel23.Font.Style := [fsBold];
    WebLabel23.HeightStyle := ssAuto;
    WebLabel23.HeightPercent := 100.00000000000000000;
    WebLabel23.ParentFont := False;
    WebLabel23.WordWrap := True;
    WebLabel23.WidthPercent := 100.00000000000000000;
    WebLabel35.SetParentComponent(pnBerichte);
    WebLabel35.Name := 'WebLabel35';
    WebLabel35.Left := 767;
    WebLabel35.Top := 46;
    WebLabel35.Width := 298;
    WebLabel35.Height := 29;
    WebLabel35.Caption := 'Marktforschungsberichte';
    WebLabel35.ElementFont := efCSS;
    WebLabel35.ElementPosition := epRelative;
    WebLabel35.Font.Charset := DEFAULT_CHARSET;
    WebLabel35.Font.Color := clWindowText;
    WebLabel35.Font.Height := -24;
    WebLabel35.Font.Name := 'Tahoma';
    WebLabel35.Font.Style := [fsBold];
    WebLabel35.HeightStyle := ssAuto;
    WebLabel35.HeightPercent := 100.00000000000000000;
    WebLabel35.ParentFont := False;
    WebLabel35.WordWrap := True;
    WebLabel35.WidthPercent := 100.00000000000000000;
    WebDBEdit4.SetParentComponent(pnBerichte);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 32;
    WebDBEdit4.Top := 84;
    WebDBEdit4.Width := 150;
    WebDBEdit4.Height := 46;
    WebDBEdit4.ChildOrder := 20;
    WebDBEdit4.ElementClassName := 'form-control';
    WebDBEdit4.ElementFont := efCSS;
    WebDBEdit4.ElementPosition := epRelative;
    WebDBEdit4.Font.Charset := ANSI_CHARSET;
    WebDBEdit4.Font.Color := clWindowText;
    WebDBEdit4.Font.Height := -24;
    WebDBEdit4.Font.Name := 'Segoe UI';
    WebDBEdit4.Font.Style := [fsBold];
    WebDBEdit4.HeightStyle := ssAuto;
    WebDBEdit4.HeightPercent := 100.00000000000000000;
    WebDBEdit4.ParentFont := False;
    WebDBEdit4.TabOrder := 11;
    WebDBEdit4.WidthStyle := ssAuto;
    WebDBEdit4.WidthPercent := 100.00000000000000000;
    WebDBEdit4.DataField := 'Upmd_Period_Cost_Unit_Accounting';
    WebDBEdit4.DataSource := ModulWebDataSource;
    WebDBEdit5.SetParentComponent(pnBerichte);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 354;
    WebDBEdit5.Top := 84;
    WebDBEdit5.Width := 150;
    WebDBEdit5.Height := 46;
    WebDBEdit5.ChildOrder := 20;
    WebDBEdit5.ElementClassName := 'form-control';
    WebDBEdit5.ElementFont := efCSS;
    WebDBEdit5.ElementPosition := epRelative;
    WebDBEdit5.Font.Charset := ANSI_CHARSET;
    WebDBEdit5.Font.Color := clWindowText;
    WebDBEdit5.Font.Height := -24;
    WebDBEdit5.Font.Name := 'Segoe UI';
    WebDBEdit5.Font.Style := [fsBold];
    WebDBEdit5.HeightStyle := ssAuto;
    WebDBEdit5.HeightPercent := 100.00000000000000000;
    WebDBEdit5.ParentFont := False;
    WebDBEdit5.TabOrder := 11;
    WebDBEdit5.WidthStyle := ssAuto;
    WebDBEdit5.WidthPercent := 100.00000000000000000;
    WebDBEdit5.DataField := 'Upmd_Period_Contribution_Margin_Calculation';
    WebDBEdit5.DataSource := ModulWebDataSource;
    WebDBEdit6.SetParentComponent(pnBerichte);
    WebDBEdit6.Name := 'WebDBEdit6';
    WebDBEdit6.Left := 767;
    WebDBEdit6.Top := 81;
    WebDBEdit6.Width := 150;
    WebDBEdit6.Height := 46;
    WebDBEdit6.ChildOrder := 20;
    WebDBEdit6.ElementClassName := 'form-control';
    WebDBEdit6.ElementFont := efCSS;
    WebDBEdit6.ElementPosition := epRelative;
    WebDBEdit6.Font.Charset := ANSI_CHARSET;
    WebDBEdit6.Font.Color := clWindowText;
    WebDBEdit6.Font.Height := -24;
    WebDBEdit6.Font.Name := 'Segoe UI';
    WebDBEdit6.Font.Style := [fsBold];
    WebDBEdit6.HeightStyle := ssAuto;
    WebDBEdit6.HeightPercent := 100.00000000000000000;
    WebDBEdit6.ParentFont := False;
    WebDBEdit6.TabOrder := 11;
    WebDBEdit6.WidthStyle := ssAuto;
    WebDBEdit6.WidthPercent := 100.00000000000000000;
    WebDBEdit6.DataField := 'Upmd_Period_Market_Research_Report';
    WebDBEdit6.DataSource := ModulWebDataSource;
    pnModule.SetParentComponent(pgSeite5);
    pnModule.Name := 'pnModule';
    pnModule.Left := 0;
    pnModule.Top := 0;
    pnModule.Width := 1240;
    pnModule.Height := 601;
    pnModule.HeightStyle := ssPercent;
    pnModule.WidthStyle := ssPercent;
    pnModule.Align := alTop;
    pnModule.ChildOrder := 1;
    pnModule.ElementFont := efCSS;
    pnModule.ElementPosition := epRelative;
    pnModule.TabOrder := 1;
    pnModuleFunktion.SetParentComponent(pnModule);
    pnModuleFunktion.Name := 'pnModuleFunktion';
    pnModuleFunktion.Left := 0;
    pnModuleFunktion.Top := 0;
    pnModuleFunktion.Width := 1055;
    pnModuleFunktion.Height := 601;
    pnModuleFunktion.HeightStyle := ssPercent;
    pnModuleFunktion.WidthStyle := ssPercent;
    pnModuleFunktion.Align := alLeft;
    pnModuleFunktion.ElementFont := efCSS;
    pnModuleFunktion.ElementPosition := epRelative;
    pnModuleFunktion.TabOrder := 0;
    lblStation1.SetParentComponent(pnModuleFunktion);
    lblStation1.Name := 'lblStation1';
    lblStation1.Left := 16;
    lblStation1.Top := 80;
    lblStation1.Width := 210;
    lblStation1.Height := 29;
    lblStation1.Caption := 'Kauf Wertpapiere';
    lblStation1.ElementFont := efCSS;
    lblStation1.ElementPosition := epRelative;
    lblStation1.Font.Charset := DEFAULT_CHARSET;
    lblStation1.Font.Color := clWindowText;
    lblStation1.Font.Height := -24;
    lblStation1.Font.Name := 'Tahoma';
    lblStation1.Font.Style := [fsBold];
    lblStation1.HeightStyle := ssAuto;
    lblStation1.HeightPercent := 100.00000000000000000;
    lblStation1.ParentFont := False;
    lblStation1.WidthStyle := ssAuto;
    lblStation1.WidthPercent := 100.00000000000000000;
    WebLabel1.SetParentComponent(pnModuleFunktion);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 140;
    WebLabel1.Width := 247;
    WebLabel1.Height := 29;
    WebLabel1.Caption := 'Ertragsaussch'#252'ttung';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.ElementPosition := epRelative;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -24;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.00000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthStyle := ssPercent;
    WebLabel1.WidthPercent := 100.00000000000000000;
    WebLabel2.SetParentComponent(pnModuleFunktion);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 16;
    WebLabel2.Top := 199;
    WebLabel2.Width := 286;
    WebLabel2.Height := 29;
    WebLabel2.Caption := 'Kredittilgung kurzfristig';
    WebLabel2.ElementFont := efCSS;
    WebLabel2.ElementPosition := epRelative;
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clWindowText;
    WebLabel2.Font.Height := -24;
    WebLabel2.Font.Name := 'Tahoma';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightStyle := ssAuto;
    WebLabel2.HeightPercent := 100.00000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthStyle := ssPercent;
    WebLabel2.WidthPercent := 100.00000000000000000;
    WebLabel3.SetParentComponent(pnModuleFunktion);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 255;
    WebLabel3.Width := 265;
    WebLabel3.Height := 29;
    WebLabel3.Caption := 'Vorkalkulation erlaubt';
    WebLabel3.ElementFont := efCSS;
    WebLabel3.ElementPosition := epRelative;
    WebLabel3.Font.Charset := DEFAULT_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -24;
    WebLabel3.Font.Name := 'Tahoma';
    WebLabel3.Font.Style := [fsBold];
    WebLabel3.HeightStyle := ssAuto;
    WebLabel3.HeightPercent := 100.00000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthStyle := ssPercent;
    WebLabel3.WidthPercent := 100.00000000000000000;
    WebLabel4.SetParentComponent(pnModuleFunktion);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 312;
    WebLabel4.Width := 395;
    WebLabel4.Height := 29;
    WebLabel4.Caption := 'Verkauf v. Finanz- / Sachanlagen';
    WebLabel4.ElementFont := efCSS;
    WebLabel4.ElementPosition := epRelative;
    WebLabel4.Font.Charset := DEFAULT_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -24;
    WebLabel4.Font.Name := 'Tahoma';
    WebLabel4.Font.Style := [fsBold];
    WebLabel4.HeightStyle := ssAuto;
    WebLabel4.HeightPercent := 100.00000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WordWrap := True;
    WebLabel4.WidthStyle := ssPercent;
    WebLabel4.WidthPercent := 100.00000000000000000;
    WebLabel5.SetParentComponent(pnModuleFunktion);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 16;
    WebLabel5.Top := 367;
    WebLabel5.Width := 333;
    WebLabel5.Height := 29;
    WebLabel5.Caption := 'Codier- / Case Management';
    WebLabel5.ElementFont := efCSS;
    WebLabel5.ElementPosition := epRelative;
    WebLabel5.Font.Charset := DEFAULT_CHARSET;
    WebLabel5.Font.Color := clWindowText;
    WebLabel5.Font.Height := -24;
    WebLabel5.Font.Name := 'Tahoma';
    WebLabel5.Font.Style := [fsBold];
    WebLabel5.HeightStyle := ssAuto;
    WebLabel5.HeightPercent := 100.00000000000000000;
    WebLabel5.HTMLType := tH3;
    WebLabel5.ParentFont := False;
    WebLabel5.WordWrap := True;
    WebLabel5.WidthStyle := ssPercent;
    WebLabel5.WidthPercent := 100.00000000000000000;
    WebLabel6.SetParentComponent(pnModuleFunktion);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 16;
    WebLabel6.Top := 22;
    WebLabel6.Width := 210;
    WebLabel6.Height := 18;
    WebLabel6.Caption := 'Funktion ab Periode freischalten ';
    WebLabel6.ElementFont := efCSS;
    WebLabel6.ElementPosition := epRelative;
    WebLabel6.HeightStyle := ssAuto;
    WebLabel6.HeightPercent := 100.00000000000000000;
    WebLabel6.HTMLType := tH3;
    WebLabel6.WidthPercent := 100.00000000000000000;
    La4_Inst6.SetParentComponent(pnModuleFunktion);
    La4_Inst6.Name := 'La4_Inst6';
    La4_Inst6.Left := 16;
    La4_Inst6.Top := 440;
    La4_Inst6.Width := 276;
    La4_Inst6.Height := 29;
    La4_Inst6.Caption := 'Outsourcing W'#228'scherei';
    La4_Inst6.ElementFont := efCSS;
    La4_Inst6.ElementPosition := epRelative;
    La4_Inst6.Font.Charset := DEFAULT_CHARSET;
    La4_Inst6.Font.Color := clWindowText;
    La4_Inst6.Font.Height := -24;
    La4_Inst6.Font.Name := 'Tahoma';
    La4_Inst6.Font.Style := [fsBold];
    La4_Inst6.HeightStyle := ssAuto;
    La4_Inst6.HeightPercent := 100.00000000000000000;
    La4_Inst6.ParentFont := False;
    La4_Inst6.WordWrap := True;
    La4_Inst6.WidthPercent := 100.00000000000000000;
    La4_Inst7.SetParentComponent(pnModuleFunktion);
    La4_Inst7.Name := 'La4_Inst7';
    La4_Inst7.Left := 16;
    La4_Inst7.Top := 503;
    La4_Inst7.Width := 168;
    La4_Inst7.Height := 29;
    La4_Inst7.Caption := 'Planung KPI'#39's';
    La4_Inst7.ElementFont := efCSS;
    La4_Inst7.ElementPosition := epRelative;
    La4_Inst7.Font.Charset := DEFAULT_CHARSET;
    La4_Inst7.Font.Color := clWindowText;
    La4_Inst7.Font.Height := -24;
    La4_Inst7.Font.Name := 'Tahoma';
    La4_Inst7.Font.Style := [fsBold];
    La4_Inst7.HeightStyle := ssAuto;
    La4_Inst7.HeightPercent := 100.00000000000000000;
    La4_Inst7.ParentFont := False;
    La4_Inst7.WordWrap := True;
    La4_Inst7.WidthPercent := 100.00000000000000000;
    LF4_GeldAnl.SetParentComponent(pnModuleFunktion);
    LF4_GeldAnl.Name := 'LF4_GeldAnl';
    LF4_GeldAnl.Left := 440;
    LF4_GeldAnl.Top := 82;
    LF4_GeldAnl.Width := 150;
    LF4_GeldAnl.Height := 46;
    LF4_GeldAnl.ChildOrder := 6;
    LF4_GeldAnl.ElementFont := efCSS;
    LF4_GeldAnl.ElementPosition := epRelative;
    LF4_GeldAnl.Font.Charset := ANSI_CHARSET;
    LF4_GeldAnl.Font.Color := clWindowText;
    LF4_GeldAnl.Font.Height := -24;
    LF4_GeldAnl.Font.Name := 'Segoe UI';
    LF4_GeldAnl.Font.Style := [fsBold];
    LF4_GeldAnl.HeightStyle := ssAuto;
    LF4_GeldAnl.HeightPercent := 100.00000000000000000;
    LF4_GeldAnl.ParentFont := False;
    LF4_GeldAnl.Text := 'LF4_GeldAnl';
    LF4_GeldAnl.WidthStyle := ssPercent;
    LF4_GeldAnl.WidthPercent := 100.00000000000000000;
    LF4_GeldAnl.DataField := 'Upmd_Period_Securities';
    LF4_GeldAnl.DataSource := ModulWebDataSource;
    LF4_ErtrAus.SetParentComponent(pnModuleFunktion);
    LF4_ErtrAus.Name := 'LF4_ErtrAus';
    LF4_ErtrAus.Left := 440;
    LF4_ErtrAus.Top := 135;
    LF4_ErtrAus.Width := 150;
    LF4_ErtrAus.Height := 46;
    LF4_ErtrAus.ChildOrder := 7;
    LF4_ErtrAus.ElementFont := efCSS;
    LF4_ErtrAus.ElementPosition := epRelative;
    LF4_ErtrAus.Font.Charset := ANSI_CHARSET;
    LF4_ErtrAus.Font.Color := clWindowText;
    LF4_ErtrAus.Font.Height := -24;
    LF4_ErtrAus.Font.Name := 'Segoe UI';
    LF4_ErtrAus.Font.Style := [fsBold];
    LF4_ErtrAus.HeightStyle := ssAuto;
    LF4_ErtrAus.HeightPercent := 100.00000000000000000;
    LF4_ErtrAus.ParentFont := False;
    LF4_ErtrAus.TabOrder := 1;
    LF4_ErtrAus.WidthStyle := ssPercent;
    LF4_ErtrAus.WidthPercent := 100.00000000000000000;
    LF4_ErtrAus.DataField := 'Upmd_Period_Income_Distribution';
    LF4_ErtrAus.DataSource := ModulWebDataSource;
    LF4_KredTlg.SetParentComponent(pnModuleFunktion);
    LF4_KredTlg.Name := 'LF4_KredTlg';
    LF4_KredTlg.Left := 440;
    LF4_KredTlg.Top := 194;
    LF4_KredTlg.Width := 150;
    LF4_KredTlg.Height := 46;
    LF4_KredTlg.ChildOrder := 8;
    LF4_KredTlg.ElementFont := efCSS;
    LF4_KredTlg.ElementPosition := epRelative;
    LF4_KredTlg.Font.Charset := ANSI_CHARSET;
    LF4_KredTlg.Font.Color := clWindowText;
    LF4_KredTlg.Font.Height := -24;
    LF4_KredTlg.Font.Name := 'Segoe UI';
    LF4_KredTlg.Font.Style := [fsBold];
    LF4_KredTlg.HeightStyle := ssAuto;
    LF4_KredTlg.HeightPercent := 100.00000000000000000;
    LF4_KredTlg.ParentFont := False;
    LF4_KredTlg.TabOrder := 2;
    LF4_KredTlg.WidthStyle := ssPercent;
    LF4_KredTlg.WidthPercent := 100.00000000000000000;
    LF4_KredTlg.DataField := 'Upmd_Period_Credit_Repay';
    LF4_KredTlg.DataSource := ModulWebDataSource;
    LF4_VorkErl.SetParentComponent(pnModuleFunktion);
    LF4_VorkErl.Name := 'LF4_VorkErl';
    LF4_VorkErl.Left := 440;
    LF4_VorkErl.Top := 250;
    LF4_VorkErl.Width := 150;
    LF4_VorkErl.Height := 46;
    LF4_VorkErl.ChildOrder := 9;
    LF4_VorkErl.EditType := weNumeric;
    LF4_VorkErl.ElementFont := efCSS;
    LF4_VorkErl.ElementPosition := epRelative;
    LF4_VorkErl.Font.Charset := ANSI_CHARSET;
    LF4_VorkErl.Font.Color := clWindowText;
    LF4_VorkErl.Font.Height := -24;
    LF4_VorkErl.Font.Name := 'Segoe UI';
    LF4_VorkErl.Font.Style := [fsBold];
    LF4_VorkErl.HeightStyle := ssAuto;
    LF4_VorkErl.HeightPercent := 100.00000000000000000;
    LF4_VorkErl.ParentFont := False;
    LF4_VorkErl.TabOrder := 3;
    LF4_VorkErl.WidthStyle := ssPercent;
    LF4_VorkErl.WidthPercent := 100.00000000000000000;
    LF4_VorkErl.DataField := 'Upmd_Period_Precalc_Allowed';
    LF4_VorkErl.DataSource := ModulWebDataSource;
    SetEvent(LF4_VorkErl, Self, 'OnValidate', 'LF4_VorkErlValidate');
    LF4_VerkAnl.SetParentComponent(pnModuleFunktion);
    LF4_VerkAnl.Name := 'LF4_VerkAnl';
    LF4_VerkAnl.Left := 440;
    LF4_VerkAnl.Top := 307;
    LF4_VerkAnl.Width := 150;
    LF4_VerkAnl.Height := 46;
    LF4_VerkAnl.ChildOrder := 10;
    LF4_VerkAnl.ElementFont := efCSS;
    LF4_VerkAnl.ElementPosition := epRelative;
    LF4_VerkAnl.Font.Charset := ANSI_CHARSET;
    LF4_VerkAnl.Font.Color := clWindowText;
    LF4_VerkAnl.Font.Height := -24;
    LF4_VerkAnl.Font.Name := 'Segoe UI';
    LF4_VerkAnl.Font.Style := [fsBold];
    LF4_VerkAnl.HeightStyle := ssAuto;
    LF4_VerkAnl.HeightPercent := 100.00000000000000000;
    LF4_VerkAnl.ParentFont := False;
    LF4_VerkAnl.TabOrder := 4;
    LF4_VerkAnl.WidthStyle := ssAuto;
    LF4_VerkAnl.WidthPercent := 100.00000000000000000;
    LF4_VerkAnl.DataField := 'Upmd_Period_Fixed_Assets';
    LF4_VerkAnl.DataSource := ModulWebDataSource;
    LF4_CMngmnt.SetParentComponent(pnModuleFunktion);
    LF4_CMngmnt.Name := 'LF4_CMngmnt';
    LF4_CMngmnt.Left := 440;
    LF4_CMngmnt.Top := 362;
    LF4_CMngmnt.Width := 150;
    LF4_CMngmnt.Height := 46;
    LF4_CMngmnt.ChildOrder := 11;
    LF4_CMngmnt.ElementFont := efCSS;
    LF4_CMngmnt.ElementPosition := epRelative;
    LF4_CMngmnt.Font.Charset := ANSI_CHARSET;
    LF4_CMngmnt.Font.Color := clWindowText;
    LF4_CMngmnt.Font.Height := -24;
    LF4_CMngmnt.Font.Name := 'Segoe UI';
    LF4_CMngmnt.Font.Style := [fsBold];
    LF4_CMngmnt.HeightStyle := ssAuto;
    LF4_CMngmnt.HeightPercent := 100.00000000000000000;
    LF4_CMngmnt.ParentFont := False;
    LF4_CMngmnt.TabOrder := 5;
    LF4_CMngmnt.WidthStyle := ssPercent;
    LF4_CMngmnt.WidthPercent := 100.00000000000000000;
    LF4_CMngmnt.DataField := 'Upmd_Period_Case_Management';
    LF4_CMngmnt.DataSource := ModulWebDataSource;
    LF4_Inst6OutSrc.SetParentComponent(pnModuleFunktion);
    LF4_Inst6OutSrc.Name := 'LF4_Inst6OutSrc';
    LF4_Inst6OutSrc.Left := 440;
    LF4_Inst6OutSrc.Top := 440;
    LF4_Inst6OutSrc.Width := 150;
    LF4_Inst6OutSrc.Height := 46;
    LF4_Inst6OutSrc.ChildOrder := 20;
    LF4_Inst6OutSrc.ElementClassName := 'form-control';
    LF4_Inst6OutSrc.ElementFont := efCSS;
    LF4_Inst6OutSrc.ElementPosition := epRelative;
    LF4_Inst6OutSrc.Font.Charset := ANSI_CHARSET;
    LF4_Inst6OutSrc.Font.Color := clWindowText;
    LF4_Inst6OutSrc.Font.Height := -24;
    LF4_Inst6OutSrc.Font.Name := 'Segoe UI';
    LF4_Inst6OutSrc.Font.Style := [fsBold];
    LF4_Inst6OutSrc.HeightStyle := ssAuto;
    LF4_Inst6OutSrc.HeightPercent := 100.00000000000000000;
    LF4_Inst6OutSrc.ParentFont := False;
    LF4_Inst6OutSrc.TabOrder := 11;
    LF4_Inst6OutSrc.WidthStyle := ssAuto;
    LF4_Inst6OutSrc.WidthPercent := 100.00000000000000000;
    LF4_Inst6OutSrc.DataField := 'Upmd_Period_Outsourcing_Cleaning';
    LF4_Inst6OutSrc.DataSource := ModulWebDataSource;
    LF4_Inst7PlanKPI.SetParentComponent(pnModuleFunktion);
    LF4_Inst7PlanKPI.Name := 'LF4_Inst7PlanKPI';
    LF4_Inst7PlanKPI.Left := 440;
    LF4_Inst7PlanKPI.Top := 503;
    LF4_Inst7PlanKPI.Width := 150;
    LF4_Inst7PlanKPI.Height := 46;
    LF4_Inst7PlanKPI.ChildOrder := 20;
    LF4_Inst7PlanKPI.ElementClassName := 'form-control';
    LF4_Inst7PlanKPI.ElementFont := efCSS;
    LF4_Inst7PlanKPI.ElementPosition := epRelative;
    LF4_Inst7PlanKPI.Font.Charset := ANSI_CHARSET;
    LF4_Inst7PlanKPI.Font.Color := clWindowText;
    LF4_Inst7PlanKPI.Font.Height := -24;
    LF4_Inst7PlanKPI.Font.Name := 'Segoe UI';
    LF4_Inst7PlanKPI.Font.Style := [fsBold];
    LF4_Inst7PlanKPI.HeightStyle := ssAuto;
    LF4_Inst7PlanKPI.HeightPercent := 100.00000000000000000;
    LF4_Inst7PlanKPI.ParentFont := False;
    LF4_Inst7PlanKPI.TabOrder := 11;
    LF4_Inst7PlanKPI.WidthStyle := ssAuto;
    LF4_Inst7PlanKPI.WidthPercent := 100.00000000000000000;
    LF4_Inst7PlanKPI.DataField := 'UPMD_PERIOD_KPI_CALCULATE';
    LF4_Inst7PlanKPI.DataSource := ModulWebDataSource;
    pnKPI.SetParentComponent(pgSeite5);
    pnKPI.Name := 'pnKPI';
    pnKPI.Left := 0;
    pnKPI.Top := 766;
    pnKPI.Width := 1240;
    pnKPI.Height := 195;
    pnKPI.HeightStyle := ssPercent;
    pnKPI.WidthStyle := ssPercent;
    pnKPI.Align := alTop;
    pnKPI.Caption := 'pnKPI';
    pnKPI.ChildOrder := 2;
    pnKPI.ElementFont := efCSS;
    pnKPI.ElementPosition := epRelative;
    pnKPI.ShowCaption := False;
    pnKPI.TabOrder := 2;
    lblHeadlineKPIDaten.SetParentComponent(pnKPI);
    lblHeadlineKPIDaten.Name := 'lblHeadlineKPIDaten';
    lblHeadlineKPIDaten.Left := 32;
    lblHeadlineKPIDaten.Top := 21;
    lblHeadlineKPIDaten.Width := 140;
    lblHeadlineKPIDaten.Height := 18;
    lblHeadlineKPIDaten.Caption := 'KPI Daten bearbeiten';
    lblHeadlineKPIDaten.ElementFont := efCSS;
    lblHeadlineKPIDaten.HeightStyle := ssAuto;
    lblHeadlineKPIDaten.HeightPercent := 100.00000000000000000;
    lblHeadlineKPIDaten.HTMLType := tH3;
    lblHeadlineKPIDaten.WidthPercent := 100.00000000000000000;
    pgSeite6.SetParentComponent(PageControl);
    pgSeite6.Name := 'pgSeite6';
    pgSeite6.Left := 0;
    pgSeite6.Top := 20;
    pgSeite6.Width := 1240;
    pgSeite6.Height := 972;
    pgSeite6.ElementClassName := 'h-full w-full overflow-auto flex flex-col p-4';
    pgSeite6.Caption := 'Abteilungen';
    pgSeite6.ChildOrder := 5;
    pgSeite6.ElementFont := efCSS;
    pgSeite6.ElementPosition := epRelative;
    pnAbteilungen.SetParentComponent(pgSeite6);
    pnAbteilungen.Name := 'pnAbteilungen';
    pnAbteilungen.Left := 0;
    pnAbteilungen.Top := 0;
    pnAbteilungen.Width := 1240;
    pnAbteilungen.Height := 972;
    pnAbteilungen.HeightStyle := ssPercent;
    pnAbteilungen.WidthStyle := ssPercent;
    pnAbteilungen.Align := alClient;
    pnAbteilungen.ChildOrder := 1;
    pnAbteilungen.ElementFont := efCSS;
    pnAbteilungen.ElementPosition := epRelative;
    pnAbteilungen.TabOrder := 0;
    strGridAbteilungen.SetParentComponent(pnAbteilungen);
    strGridAbteilungen.Name := 'strGridAbteilungen';
    strGridAbteilungen.Left := 61;
    strGridAbteilungen.Top := 22;
    strGridAbteilungen.Width := 656;
    strGridAbteilungen.Height := 514;
    strGridAbteilungen.ColCount := 4;
    strGridAbteilungen.RowCount := 11;
    strGridAbteilungen.TabOrder := 0;
    strGridAbteilungen.ElementFont := efCSS;
    strGridAbteilungen.ElementPosition := epRelative;
    strGridAbteilungen.FixedFont.Charset := DEFAULT_CHARSET;
    strGridAbteilungen.FixedFont.Color := clWindowText;
    strGridAbteilungen.FixedFont.Height := -18;
    strGridAbteilungen.FixedFont.Name := 'Segoe UI';
    strGridAbteilungen.FixedFont.Style := [];
    strGridAbteilungen.RangeEdit.Max := 100.00000000000000000;
    strGridAbteilungen.RangeEdit.Step := 1.00000000000000000;
    strGridAbteilungen.HeightStyle := ssAuto;
    strGridAbteilungen.HeightPercent := 100.00000000000000000;
    strGridAbteilungen.WidthStyle := ssAuto;
    strGridAbteilungen.WidthPercent := 100.00000000000000000;
    pnLeftNavigation.SetParentComponent(Self);
    pnLeftNavigation.Name := 'pnLeftNavigation';
    pnLeftNavigation.Left := 1240;
    pnLeftNavigation.Top := 0;
    pnLeftNavigation.Width := 272;
    pnLeftNavigation.Height := 992;
    pnLeftNavigation.HeightStyle := ssAuto;
    pnLeftNavigation.WidthStyle := ssAuto;
    pnLeftNavigation.Align := alRight;
    pnLeftNavigation.Alignment := taLeftJustify;
    pnLeftNavigation.Caption := 'pnLeftNavigation';
    pnLeftNavigation.ChildOrder := 2;
    pnLeftNavigation.ElementFont := efCSS;
    pnLeftNavigation.ElementPosition := epRelative;
    pnLeftNavigation.ShowCaption := False;
    pnLeftNavigation.TabOrder := 2;
    lblPeriode.SetParentComponent(pnLeftNavigation);
    lblPeriode.Name := 'lblPeriode';
    lblPeriode.Left := 9;
    lblPeriode.Top := 256;
    lblPeriode.Width := 153;
    lblPeriode.Height := 29;
    lblPeriode.Caption := 'Gesch'#228'ftjahr';
    lblPeriode.ElementFont := efCSS;
    lblPeriode.ElementPosition := epRelative;
    lblPeriode.Font.Charset := DEFAULT_CHARSET;
    lblPeriode.Font.Color := clWindowText;
    lblPeriode.Font.Height := -24;
    lblPeriode.Font.Name := 'Tahoma';
    lblPeriode.Font.Style := [fsBold];
    lblPeriode.HeightStyle := ssAuto;
    lblPeriode.HeightPercent := 100.00000000000000000;
    lblPeriode.ParentFont := False;
    lblPeriode.WidthStyle := ssAuto;
    lblPeriode.WidthPercent := 100.00000000000000000;
    lblAbteilung.SetParentComponent(pnLeftNavigation);
    lblAbteilung.Name := 'lblAbteilung';
    lblAbteilung.Left := 9;
    lblAbteilung.Top := 368;
    lblAbteilung.Width := 114;
    lblAbteilung.Height := 29;
    lblAbteilung.Caption := 'Abteilung';
    lblAbteilung.ElementFont := efCSS;
    lblAbteilung.ElementPosition := epRelative;
    lblAbteilung.Font.Charset := DEFAULT_CHARSET;
    lblAbteilung.Font.Color := clWindowText;
    lblAbteilung.Font.Height := -24;
    lblAbteilung.Font.Name := 'Tahoma';
    lblAbteilung.Font.Style := [fsBold];
    lblAbteilung.HeightStyle := ssAuto;
    lblAbteilung.HeightPercent := 100.00000000000000000;
    lblAbteilung.ParentFont := False;
    lblAbteilung.WidthStyle := ssAuto;
    lblAbteilung.WidthPercent := 100.00000000000000000;
    lblFallnummer.SetParentComponent(pnLeftNavigation);
    lblFallnummer.Name := 'lblFallnummer';
    lblFallnummer.Left := 9;
    lblFallnummer.Top := 488;
    lblFallnummer.Width := 142;
    lblFallnummer.Height := 29;
    lblFallnummer.Caption := 'Fallnummer';
    lblFallnummer.ElementFont := efCSS;
    lblFallnummer.ElementPosition := epRelative;
    lblFallnummer.Font.Charset := DEFAULT_CHARSET;
    lblFallnummer.Font.Color := clWindowText;
    lblFallnummer.Font.Height := -24;
    lblFallnummer.Font.Name := 'Tahoma';
    lblFallnummer.Font.Style := [fsBold];
    lblFallnummer.HeightStyle := ssAuto;
    lblFallnummer.HeightPercent := 100.00000000000000000;
    lblFallnummer.ParentFont := False;
    lblFallnummer.WidthStyle := ssAuto;
    lblFallnummer.WidthPercent := 100.00000000000000000;
    btnClose.SetParentComponent(pnLeftNavigation);
    btnClose.Name := 'btnClose';
    btnClose.Left := 13;
    btnClose.Top := 35;
    btnClose.Width := 250;
    btnClose.Height := 55;
    btnClose.Caption := 'Zur'#252'ck';
    btnClose.ChildOrder := 7;
    btnClose.ElementClassName := 'btn btn-outline flex gap-4';
    btnClose.ElementFont := efCSS;
    btnClose.ElementPosition := epRelative;
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.00000000000000000;
    btnClose.WidthStyle := ssAuto;
    btnClose.WidthPercent := 100.00000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnSave.SetParentComponent(pnLeftNavigation);
    btnSave.Name := 'btnSave';
    btnSave.Left := 13;
    btnSave.Top := 116;
    btnSave.Width := 250;
    btnSave.Height := 55;
    btnSave.Caption := 'Speichern';
    btnSave.ChildOrder := 7;
    btnSave.ElementClassName := 'btn btn-success btn-outline';
    btnSave.ElementFont := efCSS;
    btnSave.ElementPosition := epRelative;
    btnSave.HeightStyle := ssAuto;
    btnSave.HeightPercent := 100.00000000000000000;
    btnSave.WidthStyle := ssAuto;
    btnSave.WidthPercent := 100.00000000000000000;
    SetEvent(btnSave, Self, 'OnClick', 'btnSaveClick');
    spedPeriode.SetParentComponent(pnLeftNavigation);
    spedPeriode.Name := 'spedPeriode';
    spedPeriode.Left := 6;
    spedPeriode.Top := 291;
    spedPeriode.Width := 250;
    spedPeriode.Height := 57;
    spedPeriode.HeightStyle := ssAuto;
    spedPeriode.WidthStyle := ssAuto;
    spedPeriode.AutoSize := False;
    spedPeriode.BorderStyle := bsSingle;
    spedPeriode.ChildOrder := 7;
    spedPeriode.Color := clWhite;
    spedPeriode.ElementFont := efCSS;
    spedPeriode.ElementPosition := epRelative;
    spedPeriode.Increment := 1;
    spedPeriode.MaxValue := 100;
    spedPeriode.MinValue := 0;
    spedPeriode.Role := '';
    spedPeriode.Value := 0;
    btnPrint.SetParentComponent(pnLeftNavigation);
    btnPrint.Name := 'btnPrint';
    btnPrint.Left := 13;
    btnPrint.Top := 676;
    btnPrint.Width := 250;
    btnPrint.Height := 55;
    btnPrint.Caption := 'Drucken';
    btnPrint.ChildOrder := 7;
    btnPrint.ElementClassName := 'btn border btn-outline btn-accent';
    btnPrint.ElementFont := efCSS;
    btnPrint.ElementPosition := epRelative;
    btnPrint.HeightStyle := ssAuto;
    btnPrint.HeightPercent := 100.00000000000000000;
    btnPrint.Visible := False;
    btnPrint.WidthStyle := ssAuto;
    btnPrint.WidthPercent := 100.00000000000000000;
    btnCancel.SetParentComponent(pnLeftNavigation);
    btnCancel.Name := 'btnCancel';
    btnCancel.Left := 13;
    btnCancel.Top := 771;
    btnCancel.Width := 250;
    btnCancel.Height := 55;
    btnCancel.Caption := 'Abbruch';
    btnCancel.ChildOrder := 7;
    btnCancel.ElementClassName := 'btn btn-error';
    btnCancel.ElementFont := efCSS;
    btnCancel.ElementPosition := epRelative;
    btnCancel.HeightStyle := ssAuto;
    btnCancel.HeightPercent := 100.00000000000000000;
    btnCancel.Visible := False;
    btnCancel.WidthStyle := ssAuto;
    btnCancel.WidthPercent := 100.00000000000000000;
    brnHelp.SetParentComponent(pnLeftNavigation);
    brnHelp.Name := 'brnHelp';
    brnHelp.Left := 13;
    brnHelp.Top := 861;
    brnHelp.Width := 250;
    brnHelp.Height := 55;
    brnHelp.Caption := 'Hilfe';
    brnHelp.ChildOrder := 7;
    brnHelp.ElementClassName := 'btn btn-info';
    brnHelp.ElementFont := efCSS;
    brnHelp.ElementPosition := epRelative;
    brnHelp.HeightStyle := ssAuto;
    brnHelp.HeightPercent := 100.00000000000000000;
    brnHelp.Visible := False;
    brnHelp.WidthStyle := ssAuto;
    brnHelp.WidthPercent := 100.00000000000000000;
    spedAbteilung.SetParentComponent(pnLeftNavigation);
    spedAbteilung.Name := 'spedAbteilung';
    spedAbteilung.Left := 6;
    spedAbteilung.Top := 403;
    spedAbteilung.Width := 250;
    spedAbteilung.Height := 57;
    spedAbteilung.HeightStyle := ssAuto;
    spedAbteilung.WidthStyle := ssAuto;
    spedAbteilung.AutoSize := False;
    spedAbteilung.BorderStyle := bsSingle;
    spedAbteilung.ChildOrder := 7;
    spedAbteilung.Color := clWhite;
    spedAbteilung.ElementFont := efCSS;
    spedAbteilung.ElementPosition := epRelative;
    spedAbteilung.Increment := 1;
    spedAbteilung.MaxValue := 100;
    spedAbteilung.MinValue := 0;
    spedAbteilung.Role := '';
    spedAbteilung.Value := 0;
    spedFallNummer.SetParentComponent(pnLeftNavigation);
    spedFallNummer.Name := 'spedFallNummer';
    spedFallNummer.Left := 6;
    spedFallNummer.Top := 523;
    spedFallNummer.Width := 250;
    spedFallNummer.Height := 57;
    spedFallNummer.HeightStyle := ssAuto;
    spedFallNummer.WidthStyle := ssAuto;
    spedFallNummer.AutoSize := False;
    spedFallNummer.BorderStyle := bsSingle;
    spedFallNummer.ChildOrder := 7;
    spedFallNummer.Color := clWhite;
    spedFallNummer.ElementFont := efCSS;
    spedFallNummer.ElementPosition := epRelative;
    spedFallNummer.Increment := 1;
    spedFallNummer.MaxValue := 100;
    spedFallNummer.MinValue := 0;
    spedFallNummer.Role := '';
    spedFallNummer.Value := 0;
    XDataWebConnection1.SetParentComponent(Self);
    XDataWebConnection1.Name := 'XDataWebConnection1';
    XDataWebConnection1.URL := 'https://hbm-online.eu/MFCWebServices/';
    XDataWebConnection1.Left := 740;
    XDataWebConnection1.Top := 111;
    ModulWebDataSource.SetParentComponent(Self);
    ModulWebDataSource.Name := 'ModulWebDataSource';
    ModulWebDataSource.DataSet := XDataWebDataSetModul;
    SetEvent(ModulWebDataSource, Self, 'OnDataChange', 'ModulWebDataSourceDataChange');
    ModulWebDataSource.Left := 738;
    ModulWebDataSource.Top := 216;
    XDataWebDataSetModul.SetParentComponent(Self);
    XDataWebDataSetModul.Name := 'XDataWebDataSetModul';
    XDataWebDataSetModul.AfterOpen := XDataWebDataSetModulAfterOpen;
    XDataWebDataSetModul.EntitySetName := 'Tblhbm_Inperiodic_Modul_Data';
    XDataWebDataSetModul.Connection := XDataWebConnection1;
    XDataWebDataSetModul.Left := 908;
    XDataWebDataSetModul.Top := 216;
    MVZStat1WebDataSource.SetParentComponent(Self);
    MVZStat1WebDataSource.Name := 'MVZStat1WebDataSource';
    MVZStat1WebDataSource.DataSet := XDataWebDataSetMVZStation1;
    SetEvent(MVZStat1WebDataSource, Self, 'OnDataChange', 'ModulWebDataSourceDataChange');
    MVZStat1WebDataSource.Left := 738;
    MVZStat1WebDataSource.Top := 280;
    XDataWebDataSetMVZStation1.SetParentComponent(Self);
    XDataWebDataSetMVZStation1.Name := 'XDataWebDataSetMVZStation1';
    XDataWebDataSetMVZStation1.AfterOpen := XDataWebDataSetMVZStation1AfterOpen;
    XDataWebDataSetMVZStation1.EntitySetName := 'Tblhbm_Inperiodic_Mvz_Data';
    XDataWebDataSetMVZStation1.Connection := XDataWebConnection1;
    XDataWebDataSetMVZStation1.Left := 908;
    XDataWebDataSetMVZStation1.Top := 280;
    MVZStat2WebDataSource.SetParentComponent(Self);
    MVZStat2WebDataSource.Name := 'MVZStat2WebDataSource';
    MVZStat2WebDataSource.DataSet := XDataWebDataSetMVZStation2;
    SetEvent(MVZStat2WebDataSource, Self, 'OnDataChange', 'ModulWebDataSourceDataChange');
    MVZStat2WebDataSource.Left := 738;
    MVZStat2WebDataSource.Top := 344;
    XDataWebDataSetMVZStation2.SetParentComponent(Self);
    XDataWebDataSetMVZStation2.Name := 'XDataWebDataSetMVZStation2';
    XDataWebDataSetMVZStation2.AfterOpen := XDataWebDataSetMVZStation2AfterOpen;
    XDataWebDataSetMVZStation2.EntitySetName := 'Tblhbm_Inperiodic_Mvz_Data';
    XDataWebDataSetMVZStation2.Connection := XDataWebConnection1;
    XDataWebDataSetMVZStation2.Left := 908;
    XDataWebDataSetMVZStation2.Top := 344;
    MVZStat3WebDataSource.SetParentComponent(Self);
    MVZStat3WebDataSource.Name := 'MVZStat3WebDataSource';
    MVZStat3WebDataSource.DataSet := XDataWebDataSetMVZStation3;
    SetEvent(MVZStat3WebDataSource, Self, 'OnDataChange', 'ModulWebDataSourceDataChange');
    MVZStat3WebDataSource.Left := 738;
    MVZStat3WebDataSource.Top := 408;
    XDataWebDataSetMVZStation3.SetParentComponent(Self);
    XDataWebDataSetMVZStation3.Name := 'XDataWebDataSetMVZStation3';
    XDataWebDataSetMVZStation3.AfterOpen := XDataWebDataSetMVZStation3AfterOpen;
    XDataWebDataSetMVZStation3.EntitySetName := 'Tblhbm_Inperiodic_Mvz_Data';
    XDataWebDataSetMVZStation3.Connection := XDataWebConnection1;
    XDataWebDataSetMVZStation3.Left := 908;
    XDataWebDataSetMVZStation3.Top := 408;
    XDataWebDataSetFaelle.SetParentComponent(Self);
    XDataWebDataSetFaelle.Name := 'XDataWebDataSetFaelle';
    XDataWebDataSetFaelle.AfterOpen := XDataWebDataSetFaelleAfterOpen;
    XDataWebDataSetFaelle.EntitySetName := 'tblHBM_FAELLE';
    XDataWebDataSetFaelle.Connection := XDataWebConnection1;
    XDataWebDataSetFaelle.Left := 908;
    XDataWebDataSetFaelle.Top := 472;
    XDataWebDataSetKPI.SetParentComponent(Self);
    XDataWebDataSetKPI.Name := 'XDataWebDataSetKPI';
    XDataWebDataSetKPI.AfterOpen := XDataWebDataSetModulAfterOpen;
    XDataWebDataSetKPI.EntitySetName := 'Tblhbm_Inperiodic_Modul_Data';
    XDataWebDataSetKPI.Connection := XDataWebConnection1;
    XDataWebDataSetKPI.Left := 908;
    XDataWebDataSetKPI.Top := 544;
    KPIWebDataSource.SetParentComponent(Self);
    KPIWebDataSource.Name := 'KPIWebDataSource';
    KPIWebDataSource.DataSet := XDataWebDataSetKPI;
    SetEvent(KPIWebDataSource, Self, 'OnDataChange', 'ModulWebDataSourceDataChange');
    KPIWebDataSource.Left := 738;
    KPIWebDataSource.Top := 544;
  finally
    WaitMessage.AfterLoadDFMValues;
    PageControl.AfterLoadDFMValues;
    pgSeite1.AfterLoadDFMValues;
    pnInstitute.AfterLoadDFMValues;
    strGridInstitute.AfterLoadDFMValues;
    pgSeite3.AfterLoadDFMValues;
    pnFallZuordnung.AfterLoadDFMValues;
    strGridFallZuordnung.AfterLoadDFMValues;
    pgSeite4.AfterLoadDFMValues;
    pnMedVersorgung.AfterLoadDFMValues;
    WebLabel15.AfterLoadDFMValues;
    WebLabel16.AfterLoadDFMValues;
    WebLabel17.AfterLoadDFMValues;
    WebLabel18.AfterLoadDFMValues;
    WebLabel19.AfterLoadDFMValues;
    WebLabel20.AfterLoadDFMValues;
    lblfirstChirurgieHeadline.AfterLoadDFMValues;
    lblfirstOrthopaedieHeadline.AfterLoadDFMValues;
    lblfirstInnereHeadline.AfterLoadDFMValues;
    WebLabel24.AfterLoadDFMValues;
    WebLabel25.AfterLoadDFMValues;
    WebLabel26.AfterLoadDFMValues;
    WebLabel27.AfterLoadDFMValues;
    WebLabel28.AfterLoadDFMValues;
    WebLabel29.AfterLoadDFMValues;
    WebLabel30.AfterLoadDFMValues;
    WebLabel31.AfterLoadDFMValues;
    WebLabel32.AfterLoadDFMValues;
    WebLabel33.AfterLoadDFMValues;
    WebLabel34.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebLabel9.AfterLoadDFMValues;
    WebLabel10.AfterLoadDFMValues;
    WebLabel11.AfterLoadDFMValues;
    lblsecondChirurgieHeadline.AfterLoadDFMValues;
    LblthirdChirurgieHeadline.AfterLoadDFMValues;
    lblfourthChirurgieHeadline.AfterLoadDFMValues;
    lblfourthOrthopaedieHeadline.AfterLoadDFMValues;
    LblthirdOrthopaedieHeadline.AfterLoadDFMValues;
    lblsecondOrthopaedieHeadline.AfterLoadDFMValues;
    lblfourthInnereHeadline.AfterLoadDFMValues;
    lblthirdInnereHeadline.AfterLoadDFMValues;
    lblsecondInnereHeadline.AfterLoadDFMValues;
    RFE_MVZ_AnschaffKoA1.AfterLoadDFMValues;
    RFE_MVZ_InvestiKoA1.AfterLoadDFMValues;
    RFE_MVZ_InstHaltKoA1.AfterLoadDFMValues;
    RFE_MVZ_ZusVerwKoA1.AfterLoadDFMValues;
    RFE_MVZ_ZusLebensmA1.AfterLoadDFMValues;
    RFE_MVZ_ZusMedTechnA1.AfterLoadDFMValues;
    RFE_MVZ_AnschaffKoA2.AfterLoadDFMValues;
    RFE_MVZ_InvestiKoA2.AfterLoadDFMValues;
    RFE_MVZ_InstHaltKoA2.AfterLoadDFMValues;
    RFE_MVZ_ZusVerwKoA2.AfterLoadDFMValues;
    RFE_MVZ_ZusLebensmA2.AfterLoadDFMValues;
    RFE_MVZ_ZusMedTechnA2.AfterLoadDFMValues;
    RFE_MVZ_AnschaffKoA3.AfterLoadDFMValues;
    RFE_MVZ_InvestiKoA3.AfterLoadDFMValues;
    RFE_MVZ_InstHaltKoA3.AfterLoadDFMValues;
    RFE_MVZ_ZusVerwKoA3.AfterLoadDFMValues;
    RFE_MVZ_ZusLebensmA3.AfterLoadDFMValues;
    RFE_MVZ_ZusMedTechnA3.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntNormalA1.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlNormA1.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntWahlA1.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlWahlA1.AfterLoadDFMValues;
    RFE_MVZ_EignPaVersTageA1.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntNormalA1.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntNormalA2.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlNormA2.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntWahlA2.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlWahlA2.AfterLoadDFMValues;
    RFE_MVZ_EignPaVersTageA2.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntNormalA2.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntNormalA3.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlNormA3.AfterLoadDFMValues;
    RFE_MVZ_EignPaAntWahlA3.AfterLoadDFMValues;
    RFE_MVZ_EignPaZusErlWahlA3.AfterLoadDFMValues;
    RFE_MVZ_EignPaVersTageA3.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntNormalA3.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlNormA1.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntWahlA1.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlWahlA1.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaVersTageA1.AfterLoadDFMValues;
    RFE_MVZ_ArztMinA1.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlNormA2.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntWahlA2.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlWahlA2.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaVersTageA2.AfterLoadDFMValues;
    RFE_MVZ_ArztMinA2.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlNormA3.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaAntWahlA3.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaZusErlWahlA3.AfterLoadDFMValues;
    RFE_MVZ_FrmdPaVersTageA3.AfterLoadDFMValues;
    RFE_MVZ_ArztMinA3.AfterLoadDFMValues;
    pgSeite5.AfterLoadDFMValues;
    pnBerichte.AfterLoadDFMValues;
    WebLabel21.AfterLoadDFMValues;
    WebLabel22.AfterLoadDFMValues;
    WebLabel23.AfterLoadDFMValues;
    WebLabel35.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit6.AfterLoadDFMValues;
    pnModule.AfterLoadDFMValues;
    pnModuleFunktion.AfterLoadDFMValues;
    lblStation1.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    La4_Inst6.AfterLoadDFMValues;
    La4_Inst7.AfterLoadDFMValues;
    LF4_GeldAnl.AfterLoadDFMValues;
    LF4_ErtrAus.AfterLoadDFMValues;
    LF4_KredTlg.AfterLoadDFMValues;
    LF4_VorkErl.AfterLoadDFMValues;
    LF4_VerkAnl.AfterLoadDFMValues;
    LF4_CMngmnt.AfterLoadDFMValues;
    LF4_Inst6OutSrc.AfterLoadDFMValues;
    LF4_Inst7PlanKPI.AfterLoadDFMValues;
    pnKPI.AfterLoadDFMValues;
    lblHeadlineKPIDaten.AfterLoadDFMValues;
    pgSeite6.AfterLoadDFMValues;
    pnAbteilungen.AfterLoadDFMValues;
    strGridAbteilungen.AfterLoadDFMValues;
    pnLeftNavigation.AfterLoadDFMValues;
    lblPeriode.AfterLoadDFMValues;
    lblAbteilung.AfterLoadDFMValues;
    lblFallnummer.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnSave.AfterLoadDFMValues;
    spedPeriode.AfterLoadDFMValues;
    btnPrint.AfterLoadDFMValues;
    btnCancel.AfterLoadDFMValues;
    brnHelp.AfterLoadDFMValues;
    spedAbteilung.AfterLoadDFMValues;
    spedFallNummer.AfterLoadDFMValues;
    XDataWebConnection1.AfterLoadDFMValues;
    ModulWebDataSource.AfterLoadDFMValues;
    XDataWebDataSetModul.AfterLoadDFMValues;
    MVZStat1WebDataSource.AfterLoadDFMValues;
    XDataWebDataSetMVZStation1.AfterLoadDFMValues;
    MVZStat2WebDataSource.AfterLoadDFMValues;
    XDataWebDataSetMVZStation2.AfterLoadDFMValues;
    MVZStat3WebDataSource.AfterLoadDFMValues;
    XDataWebDataSetMVZStation3.AfterLoadDFMValues;
    XDataWebDataSetFaelle.AfterLoadDFMValues;
    XDataWebDataSetKPI.AfterLoadDFMValues;
    KPIWebDataSource.AfterLoadDFMValues;
  end;
end;

end.
